// Generado por scripts/sync-player-rosters.mjs con plantillas de ESPN y Transfermarkt. No editar a mano.
export const GENERATED_PLAYER_ROSTERS: Readonly<Record<string, readonly string[]>> = {
  "1. FC Heidenheim 1846": [
    "Thomas Dähne",
    "Paul Tschernuth",
    "Frank Feller",
    "Felix Mark",
    "Patrick Mainka",
    "Leart Paqarada",
    "Marnon Busch",
    "Benedikt Gimber",
    "Jonas Föhrenbach",
    "Tim Siersleben",
    "Oualid Mhamdi",
    "Adam Kölle",
    "Adrian Beck",
    "Jan Schöppner",
    "Julian Niehues",
    "Luca Kerber",
    "Luka Janes",
    "Paul Hennrich",
    "Marko Zrilic",
    "Mathias Honsak",
    "Budu Zivzivadze",
    "Marcel Costly",
    "Mikkel Kaufmann",
    "Christian Conteh",
    "Sirlord Conteh",
    "Maximilian Breunig",
    "Marvin Pieringer",
    "Yannik Wagner"
  ],
  "1. FC Magdeburg": [
    "Dominik Reimann",
    "Noah Kruth",
    "Robert Kampa",
    "Tobias Müller",
    "Lubambo Musonda",
    "Tarek Chahed",
    "Herbert Bockhorn",
    "Paul Jaeckel",
    "Daniel Heber",
    "Eldin Dzogovic",
    "Anselmo Garcia MacNulty",
    "Pierre Nadjombe",
    "Torben Müsel",
    "Moritz-Broni Kwarteng",
    "Falko Michel",
    "Luka Hyryläinen",
    "Tony Reitz",
    "Leon Noel Mergner",
    "Emmanuel Iyoha",
    "Baris Atik",
    "Alex Ahl-Holmström",
    "Mateusz Zukowski",
    "Alexander Nollenberger",
    "Richmond Tachie",
    "Yoon Do-Yong",
    "Magnus Baars",
    "Kevin Simon Manthey",
    "Chung-Hyun Lee"
  ],
  "1. FC Nürnberg": [
    "Christian Mathenia",
    "Jan Reichert",
    "Nicolas Ortegel",
    "Robin Lisewski",
    "Giannis Masouras",
    "Styopa Mkrtchyan",
    "Mikayil Faye",
    "Fynn Otto",
    "Alexios Kalogeropoulos",
    "Justin-Kai Von Der Hitz",
    "Andrea Ceresoli",
    "Tim Janisch",
    "Eric Porstner",
    "Kristian Mandic",
    "Finn Becker",
    "Julian Justvan",
    "Adam Markhiev",
    "Rafael Lubach",
    "Javier Fernández",
    "Ayoub Chaikhoun",
    "Marko Soldic",
    "Marc Kornwachs Barjuan",
    "Adriano Grimaldi",
    "Sigurd Haugen",
    "Rayan Ghrieb",
    "Piet Scobel",
    "Can Moustfa",
    "Mohamed Alì Zoma"
  ],
  "1. FC Union Berlin": [
    "Frederik Ronnow",
    "Carl Klaus",
    "Matheo Raab",
    "Christopher Trimmel",
    "Marvin Friedrich",
    "Josip Juranovic",
    "Derrick Köhn",
    "Stanley N'Soki",
    "Zeno Van Den Bosch",
    "Tom Rothe",
    "Leopold Querfeld",
    "Oluwaseun Ogbemudia",
    "Andrik Markgraf",
    "Rani Khedira",
    "Janik Haberer",
    "Robert Skov",
    "Tim Skarke",
    "Jeong Woo-Yeong",
    "András Schäfer",
    "Aljoscha Kemlein",
    "Julien Piet Friedrich",
    "Tim Blaszczak",
    "Andrej Ilić",
    "Oliver Burke",
    "Emmanuel Latte Lath",
    "Marin Ljubicic",
    "Ilyas Ansah",
    "Livan Burcu",
    "Dmytro Bohdanov",
    "Linus Güther",
    "Mekhi Anthony Gray"
  ],
  "Abha": [
    "Donovan Léon",
    "Mustafa Malaika",
    "Abdulrahman Al Bouq",
    "Abdou Diallo",
    "Juriën Gaari",
    "Mohammad Al-Dawsari",
    "Hazim Al-Zahrani",
    "Safwan Saud S",
    "Moayad Mohammed Ahmad Binyan",
    "Loreintz Rosier",
    "Nasser Al-Daajani",
    "Basil Yousef Al-Sayyali",
    "Bader Al Mutairi",
    "Faisal Al Sibyani",
    "Majed Dawran",
    "Mohammed Al Zaid",
    "Mubarak",
    "Mohammed Al Hamsal",
    "Nabil Fekir",
    "Alimani Gory",
    "Abdulkarim Darisi",
    "Koshaim Al Karani",
    "Kamil Boumedmed"
  ],
  "AC Milan": [
    "Pietro Terracciano",
    "Mike Maignan",
    "Lorenzo Torriani",
    "Matteo Pittarella",
    "Pervis Estupiñán",
    "Fikayo Tomori",
    "Matteo Gabbia",
    "Strahinja Pavlovic",
    "Filippo Terracciano",
    "Koni De Winter",
    "Davide Bartesaghi",
    "David Odogu",
    "Zachary Athekame",
    "Sankhoun Diawara",
    "Valeri Vladimirov",
    "Luka Modric",
    "Adrien Rabiot",
    "Ruben Loftus-Cheek",
    "Christian Pulisic",
    "Samuele Ricci",
    "Youssouf Fofana",
    "Ardon Jashari",
    "Warren Bondo",
    "Yunus Musah",
    "Jacopo Sardo",
    "Christian Comotto",
    "Lorenzo Ossola",
    "Christopher Nkunku",
    "Samuel Chukwueze",
    "Rafael Leão",
    "Santiago Gimenez",
    "Alexis Saelemaekers",
    "Andrej Kostic",
    "Emanuele Borsani"
  ],
  "Acassuso": [
    "Santiago Bogace",
    "Mariano Monllor",
    "César Atamañuk",
    "Alex Ruíz",
    "Joel Ghirardello",
    "Juan Ponce",
    "Santiago Bellatti",
    "Valentín Serrano",
    "Natán Acosta",
    "Santiago Borges",
    "Nicolás Stepanovitch",
    "Bruno Dordoni",
    "Franco Riente",
    "Lucas Pioli",
    "Matías Favale",
    "Román Etcheverri",
    "Agustín Romero",
    "Patricio Pérez",
    "David Escalante",
    "Lázaro Romero",
    "Franco Cortés",
    "Germán García",
    "Ramiro Reynoso",
    "Jonathan Raccio",
    "Joaquín Cancio",
    "Diego Roberts",
    "Matías Gutiérrez",
    "Nahuel Petillo",
    "Pedro Mamed",
    "Teo Santaliz",
    "Fabricio Sena",
    "Maximo Santoro",
    "Alexis González",
    "Kevin Dubini",
    "Felipe Senn",
    "Lautaro Rodríguez",
    "Lucas Rey",
    "Agustín Hermoso",
    "David De Estéfano",
    "Francisco Lara Marín",
    "Martín Schlotthauer",
    "Yair Gómez"
  ],
  "Agropecuario": [
    "Germán Salort",
    "Luciano Acosta",
    "Alan Pérez",
    "Alan Aguirre",
    "Matías Molina",
    "Fernando González",
    "Milton Gonzalo Ramos",
    "Tomas Lecanda",
    "Facundo Sanchez",
    "Jorge Cabello",
    "Enzo Aguirre",
    "Danilo Actis",
    "Rodrigo Castro",
    "Damián Lemos",
    "Santiago Gallucci",
    "Jorge Valdez",
    "Antonio Napolitano",
    "Rodrigo Mosqueira",
    "Federico Pérez",
    "Brian Rojas",
    "Juan Cruz Vega",
    "Braian Aranda",
    "Jarol Heritier",
    "Martín Corda",
    "Marcos Benítez",
    "Alejandro Gagliardi",
    "Carlos Auzqui",
    "Brian Blando",
    "Diego Vasquez",
    "Danilo Ruiz Díaz",
    "Lorenzo Barrera",
    "Marcos Millanes",
    "Natanael Pereyra"
  ],
  "Al-Adalah": [
    "Ali Al Amri",
    "Milan Mijatovic",
    "Mohammed Al Maqhawi",
    "Boris Godal",
    "Abdulaziz Aljamman",
    "Abdulaziz Al-Alawi",
    "Fahad Al Harbi",
    "Arif Al Haydar",
    "Mohammed Al Oufi",
    "Murtadha Al Burayh",
    "Ali Al Salem",
    "Mikael Dyrestam",
    "Nawaf Al-Subhi",
    "Mohammed Abu Abd",
    "Abdullah Al Yousef",
    "Edson",
    "Ahmad Al-Sultan",
    "David Tijanic",
    "Hassan Al-Habib",
    "Elyas Al Baladi",
    "Khaled Hamithi",
    "Abdularahman Al Hurayb",
    "Hussain Al Nattar",
    "Christofer Gonzáles",
    "Fawaz Al-Torais",
    "Anderson Plata",
    "Marcus Antonsson",
    "Reinaldo Lenis",
    "Pedro Eugénio",
    "Abdullah Hadhereti",
    "Abdulaziz Al Yousef",
    "Waleed Al Shanqiti",
    "Nasser Al Muqahem"
  ],
  "Al-Ahli": [
    "Édouard Mendy",
    "Abdulrahman Al-Sanbi",
    "Abdullah Abdo",
    "Salman Al-Jadani",
    "Ali Bakhashwin",
    "Roger Ibañez",
    "Merih Demiral",
    "Saad Balobaid",
    "Rayane Hamidou",
    "Matteo Dams",
    "Ali Majrashi",
    "Mohammed Sulaiman",
    "Zakaria Al Hawsawi",
    "Mohammed Yousef",
    "Abubacarr Kinteh",
    "Yazan Madani",
    "Yaser Al Fallatah",
    "Ahmed Al Refai",
    "Enzo Millot",
    "Ziyad Al-Johani",
    "Eduard Spertsyan",
    "Naif Masoud",
    "Valentin Atangana",
    "Eid Al Muwallad",
    "Meshal Ibrahim Al Mutairi",
    "Ayman Fallatah",
    "Ramez Al Attar",
    "Ziyad Mallah",
    "Ivan Toney",
    "Galeno",
    "Francisco Trincão",
    "Feras Al-Brikan",
    "Abdullah Radif",
    "Matheus Gonçalves",
    "Ricardo Mathias",
    "Waheb Saleh",
    "Salem Abdullah",
    "Saif Al Salami",
    "Aboubakkar Moussa"
  ],
  "Al-Anwar": [
    "Khalid Sharahili",
    "Mohammed Aldhulayfi",
    "Mazen Hussain Hazazi",
    "Nawaf Abdul Mohsen Al Dous",
    "Abdullah Yahya Magrshi",
    "Abdulmalek Al Shammary",
    "Hossam Majrashi",
    "Saif Al-Qishtah",
    "Loay Abdullah Al Shahrani",
    "Raykar Dos Santos Campos",
    "Mohammed Al Zahrani",
    "Hamad Al Aqili",
    "Marlon Lopes",
    "Khalid Al-Khabi",
    "Sulaiman Al Nakhli",
    "Abdulaziz Damdam",
    "Appolinaire Gabriel Kack",
    "Faisal Al Mujalli",
    "Ibrahim Bin Fahad Muattish",
    "Mohammed Majrashi",
    "Hassan Sharahili",
    "Rida Bensayah",
    "Yazid Joshan",
    "Thiago Bezerra",
    "Nahir Khaled Al Mahri",
    "Mshari Al-Twejri"
  ],
  "Al-Bukiryah": [
    "Motaz Akjah",
    "Mansour Jawhar",
    "Fernando Piñero",
    "Mousa Al-Hamidi Al-Harbi",
    "Bandar Baajaj",
    "Hazza Asseri",
    "Rayan Sharahili",
    "Meshaal Sané",
    "Hicham Faik",
    "Mohammed Al-Mahmoudi",
    "Abdulrahman Al-Barakah",
    "Osamah Al-Marwani",
    "Ibrahim Al-Sunaytan",
    "Nasser Kaabi",
    "Yassine Zakir",
    "Khaled Al-Hazemi",
    "Azzam Al-Bishi",
    "Saad Al-Muwallad",
    "Aremu Owolabi"
  ],
  "Al-Diriyah": [
    "Waleed Ali",
    "Muteb Sharahili",
    "Omar Colley",
    "Abdulaziz Al Faraj",
    "Fahad Al Obaid",
    "Khalid Al Asiri",
    "Taher Wadi",
    "Mohamed Thaiban Hameran",
    "Hussain Al Zarie",
    "Abdulelah Al Jaaferi",
    "Óscar Rodríguez",
    "Abdulelah Al-Malki",
    "Hussain Al-Qahtani",
    "Sultan Al Farhan",
    "Issam Al-Qarni",
    "Ziyad Al Qahtani",
    "Georges-Kévin N'Koudou",
    "Gaëtan Laborde",
    "Saleh Al-Rahmani",
    "Meshari Al Nemer",
    "Faisal Al Mutairi",
    "Clayton Diandy"
  ],
  "Al-Ettifaq": [
    "Marek Rodák",
    "Belal Mousa Ali Al Dawaa",
    "Turki Baaljawsh",
    "Hawswi",
    "Jack Hendry",
    "Abdullah Madu",
    "Madallah Al-Olayan",
    "Abdullah Khateeb",
    "Abdulbasit Hindi",
    "Meshal Sibyani",
    "Radhi Al-Otaibi",
    "Awad Dahal",
    "Álvaro Medrán",
    "Ondrej Duda",
    "Mukhtar Ali",
    "Jacopo Da Riva",
    "Faris Al Ghamdi",
    "Hassan Almusallam",
    "Abdulrahman Sahhari",
    "Yasir Shammari",
    "Mohammed Alkadi",
    "Abdulrahman Nabza",
    "Moussa Dembélé",
    "Khalid Al-Ghannam",
    "Mohau Nkota",
    "Matija Gluscevic",
    "Abdullah Al Bishi",
    "Turki Al Madani",
    "Jalal Al Salem",
    "Abdulhakim Maghfori",
    "Abdullah Al Ghamdi"
  ],
  "Al-Faisaly": [
    "Mohammed Al-Hasawi",
    "Salem Qaboos",
    "Abdulelah Nassief",
    "Raphael Silva",
    "Mohammed Jahfali",
    "Yaseen Barnawi",
    "Mohammed Al-Shanqiti",
    "Rayan Fallatah",
    "Ahmad Al Mhemaid",
    "Munif Doshi",
    "Abdullah Al Mutairi",
    "Meshal Haddad",
    "Saud Haddad",
    "Eduardo Henrique",
    "Ibrahima Ndiaye",
    "Jaber Mustafa",
    "Mohamed Al Oqil",
    "Ahmad Al Badah",
    "Malik Hamza",
    "Meshari Abduallah Shetaimi",
    "Mohammed Abbas Al Nakhli",
    "Moayad Saleem",
    "Abdulrahman Al Sharif",
    "Ayman Al Sahli",
    "Lucca Mounganga",
    "Ziyad Sultan Abdullah",
    "Henrique Luvannor",
    "Morato",
    "Fahad Al Dossari",
    "Wael Hassan Mohammed Kadan",
    "Hassan Al Solan",
    "Murad Hamzah"
  ],
  "Al-Fateh": [
    "Habib Alwotayan",
    "Abdulhadi Al-Alwan",
    "Mahmoud Al Burayh",
    "Marwane Saadane",
    "Faisal Darisi",
    "Hussain Salem",
    "Ziyad Al Jari",
    "Sattam Al Tumbukti",
    "Saeed Baattia",
    "Muntathir Al Shaqaq",
    "Ammar Al Hudaybi",
    "Abdulaziz Anwar Abdulrahman Al Suwailem",
    "Zaydou Youssef",
    "Othman Ramzi Jasim Al Othman",
    "Faisal Al Abdulwahed",
    "Abdulaziz Al Fawaz",
    "Ali Al Youssef",
    "Mohammed Al-Sahihi",
    "Fawaz Al-Hamad",
    "Hassan Ali Al Ghazal",
    "Mourad Batna",
    "Ali Al Masoud",
    "Fahad Zubaidi",
    "Saad Al-Shurafa",
    "Mahdi Al Obod",
    "Abdulaziz Al Dabas",
    "Jefferson Ramos",
    "Mohamed Refat",
    "Mohammed Bu Muaykil"
  ],
  "Al-Fayha": [
    "Orlando Mosquera",
    "Osama Al Thumairy",
    "Abdulraouf Al Dakheel",
    "Sattam Al Shammari",
    "Mohammed Al Baqawi",
    "Ziyad Al Sahafi",
    "Ahmed Bamasud",
    "Mukhir Al Rashidi",
    "Sami Al Khaibari",
    "Mohammed Al Dowaish",
    "Osama Al Turki",
    "Alfa Semedo",
    "Mansor Faiez Al-Beshe",
    "Nawaf Al-Harthi",
    "Danyal Al Habeeb",
    "Jason",
    "Silvére Ganvoula",
    "Fashion Sakala",
    "Malek Al Abdulmonam",
    "Rayan Enad",
    "Ammar Al Khaibari",
    "Saikou Secka"
  ],
  "Al-Hazem": [
    "Bruno Varela",
    "Majed Al Ghamdi",
    "Yazan Al Ruwaili",
    "Mohamed Amine Ben Hamida",
    "Ahmed Al-Nakhli",
    "Abdullah Al-Shanqiti",
    "Mohammed Issa",
    "Abdurahman Al-Dakheel",
    "Abdulaziz Al-Harbi",
    "Sultan Tanker",
    "Saud Al Rashed",
    "Khalid Al Subaie",
    "Amir Sayoud",
    "Youssouf Alio Oumarou",
    "Mory Konaté",
    "Abdulaziz Aldhuwayhi",
    "Bonheur Mugisha",
    "Ahmed Al-Shamrani",
    "Muhammad Al Darwish",
    "Aboubacar Bah",
    "Sofiane Bendebka",
    "Abdulrazzaq Awaji"
  ],
  "Al-Hilal": [
    "Yassine Bounou",
    "Mohammed Al-Owais",
    "Mohammed Al-Yami",
    "Rayan Al Dossary",
    "Mathieu Patouillet",
    "Kalidou Koulibaly",
    "Pablo Marí",
    "João Cancelo",
    "Theo Hernández",
    "Ali Al-Bulayhi",
    "Hassan Al-Tambakti",
    "Ali Lajami",
    "Hamad Al-Yami",
    "Moteb Al-Harbi",
    "Yusuf Akcicek",
    "Mohammed Al Muhaysh",
    "Saud Haroun",
    "Saad Khalid Al Muthary",
    "Saleh Barnawi",
    "Meshal Al Dawood",
    "Mohammed Al-Sarnoukh",
    "Salem Al-Dawsari",
    "Rúben Neves",
    "Sergej Milinkovic-Savic",
    "Mohamed Kanno",
    "Nasser Al-Dawsari",
    "Abdullah Safoud Alemzi",
    "Abdullah Al Zaid",
    "Suhayb Alzaid",
    "Nawaf Al-Habshi",
    "Mohammed Mahzari",
    "Saïmon Bouabré",
    "Murad Al Hawsawi",
    "Rayan Al Ghamdi",
    "Louay Labidi",
    "Karim Benzema",
    "Malcom",
    "Darwin Núñez",
    "Crysencio Summerville",
    "Sultan Mandash",
    "Turki Al Ghamil",
    "Ali Al Mahdawi",
    "Sabri Abdu Dahal",
    "Mohamed Meïté",
    "Abdulaziz Jurmush"
  ],
  "Al-Ittihad": [
    "Predrag Rajkovic",
    "Mohammed Alabsi",
    "Osama Al Marwash",
    "Danilo Pereira",
    "Hassan Kadish",
    "Ahmed Sharahili",
    "Muhannad Al-Shanqiti",
    "Stephane Paul Keller",
    "Fawaz Al Saqour",
    "Mohammed Ali Barnawi",
    "Jan-Carlo Simic",
    "Muath",
    "Ahmed Al-Julaydan",
    "Houssem Aouar",
    "Bryant Ortega",
    "Mahamadou Doumbia",
    "Faisal Al-Ghamdi",
    "Rakan Kaabi",
    "Farhah Al Shamrani",
    "Abdulelah Hawsawi",
    "Mohammed Fallatah",
    "Mateo Borrell",
    "Kassoum Koné",
    "Saleh Al-Shehri",
    "Steven Bergwijn",
    "Youssef En-Nesyri",
    "Moussa Diaby",
    "Abdulrahman Al-Obud",
    "Roger Fernandes",
    "Marwan Al-Sahafi",
    "George Ilenikhena",
    "Ahmed Al Ghamdi"
  ],
  "Al-Jabalain": [
    "Mohammed Al-Waked",
    "Abdulrahman Al-Ghubaini",
    "Fahad Al-Harbi",
    "Abdulelah Al-Bukhari",
    "Nawaf Al-Mutairi",
    "Hussain Al-Nuweqi",
    "Zaid Salem Al-Shammari",
    "Eyad Madani",
    "Ibrahim Al-Nakhli",
    "Ali Al-Mazied",
    "Yazeed Al-Rushaidan",
    "Khaled Sattam Al-Shammari"
  ],
  "Al-Jandal": [
    "Emanuel Novo",
    "Belal Mousa Ali Al Dawaa",
    "Abdul Al Sharari",
    "Batel Al Ruwaili",
    "Cheick Comara",
    "Faisal Darisi",
    "Mohammed Salah Belu",
    "Majed Al Khaibari",
    "Turki Namis",
    "Hammad Al Shartan",
    "Muaid Moaafa",
    "Leandrinho",
    "Hassan Abu Shaheen",
    "Ibrahim Al Harbi",
    "Faraj",
    "Abdullah Al Doknan",
    "Omar Al Rashed",
    "Abdulwahid Al Nakhli",
    "Chisom Egbuchulam",
    "Mohammed Al-Harthi",
    "Yassine Amri",
    "Abdullah Saeed",
    "Sajir-Al-Shammari",
    "Omar Al Sharari",
    "Mohammed Al Shahrani",
    "Meshari Al Khalif",
    "Ahmed Malfi Al Sharari"
  ],
  "Al-Jeel": [
    "Abdullah Al-Saleh",
    "Hussain Al-Tuti",
    "Ibrahim Al-Hafith",
    "Saud Fallatah",
    "Mohammed Al-Muhanna",
    "Haithem Ayouni",
    "Dilsinho",
    "Osama Al-Johar",
    "Abdullah Al-Suwaie",
    "Hussein Halawani",
    "Mohammed Al-Shaya",
    "Mohammed Al-Nafisah",
    "Ibrahim Jaafari",
    "Meshari Al-Qahtani",
    "Abu Dumbuya",
    "Mohammed Al-Fuhaid",
    "Abdulrahman Al-Faleh",
    "Hicham Nouali",
    "Abdulelah Al-Ashwan",
    "Rakan Al-Qahtani",
    "Léo Tilica",
    "Ibrahim Al-Attas",
    "Naif Al-Howaitan",
    "Stjepan Plazonja",
    "Yasser Daribi",
    "Ahmed Al-Nazeri",
    "Thamer Al-Arjan",
    "Nafea Al-Sumairi",
    "Sofiane Dia",
    "Ahmed Al-Shuwayfie",
    "Ali Al-Saqour",
    "Bakaki Anaël"
  ],
  "Al-Khaleej": [
    "Anthony Moris",
    "Marwan Al Haidari",
    "Mohammed Alghanem",
    "Abdullah Al Hafith",
    "Ahmad Asiri",
    "Rebocho",
    "Mohammed Khubrani",
    "Saeed Al Hamsal",
    "Hamad Al Jayzani",
    "Raed Firas Al Shanqiti",
    "Bader Munshi",
    "Majed Kanabah",
    "Mohammed Al Abdullah",
    "Ali Abdoulraouf Alabdrabalnabi",
    "Abdoulie Mboge",
    "Rakan Al Kabi",
    "Joshua King",
    "Saleh Al-Jamaan",
    "Mansour Hamzi",
    "Hussain Ahmed Al Issa",
    "Abdullah Turki Alzaynaldeen"
  ],
  "Al-Kholood": [
    "Muhannad Al Yahya",
    "Fares Bandar Al Zahrani",
    "Shaquille Pinas",
    "Edgaras Utkus",
    "Rashid Al Mutairi",
    "Sultan Al-Shehri",
    "Mansour Camara",
    "John Buckley",
    "Abdulrahman Al-Dossari",
    "Iker Kortajarena",
    "Muhammad Sawan",
    "Anas Al Otaibi",
    "Ibrahem Barabaa",
    "Salman Al Mosawa",
    "Adi",
    "Yousef Al Honaifesh",
    "Rakan Jaman",
    "Adam Berry",
    "Ramiro Enrique",
    "Abdulaziz Al-Aliwa",
    "Ramzi Solan",
    "Abdulmalik Al Harbi",
    "Abdullah Al Ajyan"
  ],
  "Al-Najmah": [
    "Bader Al-Khamali",
    "Khaled Al-Muqaitib",
    "Diogo Queirós",
    "Nasser Al-Haleel",
    "Khaled Al-Shammari",
    "Mohammed Al-Fatil",
    "Mohammed Al-Kunaydiri",
    "Khaled Al-Khathlan",
    "Vitor Vargas",
    "Abdullah Al-Hawsawi",
    "Omar Al-Oudah",
    "Nabil Dunga",
    "Afonso Taira",
    "Marin Prekodravac",
    "Abdulwahid Al-Nakhli",
    "Abdulaziz Al-Harabi",
    "Mohammed Al-Furaydi",
    "David Tijanic",
    "Abdulelah Al-Shammari",
    "Ammar Al-Najjar",
    "Mohammed Mansour"
  ],
  "Al-Nassr": [
    "Raghid Al-Najjar",
    "Bento",
    "Nawaf Al-Aqidi",
    "Mubarak Al Buainain",
    "Abdulrahman Al Otaibi",
    "Iñigo Martínez",
    "Abdulelah Al-Amri",
    "Sultan Al-Ghannam",
    "Mohamed Simakan",
    "Saad Al Nasser",
    "Nawaf Boushal",
    "Nader Al Sharari",
    "Salem Al Najdi",
    "Aser Abdulftah Hwsawi",
    "Majed Qasheesh",
    "Awad Aman",
    "Samú Costa",
    "Sami Al-Najei",
    "Abdullah Al-Khaibari",
    "Aiman Yahya",
    "Ali Al-Hassan",
    "Abdulmalik Al Jaber",
    "Hayder Abdulkareem",
    "Bassam Hazazi",
    "Rakan Al Ghamdi",
    "Mohammed Ahmed Almas",
    "Cristiano Ronaldo",
    "Sadio Mané",
    "Kingsley Coman",
    "Abdulrahman Ghareeb",
    "Haroune Camara",
    "João Félix",
    "Abdullah Al-Hamdan",
    "Mohammed Maran",
    "Ângelo Gabriel",
    "Saad Haqawi",
    "Faris Salem",
    "Youssef Mohammed Al Tahan",
    "Abdulrahman Sufyani"
  ],
  "Al-Okhdood": [
    "Rakan Najjar",
    "Hatem Aljuhani",
    "Saad Al Qarni",
    "Mohammed Abu Abd",
    "Mohanad Al Qaydhi",
    "Naif Asiri",
    "Hussain Al Zabdani",
    "Ahmed Ghassan",
    "Gökhan Gül",
    "Juan Pedroza",
    "Saleh Al-Harthi",
    "Mohammed Al Jahif",
    "Abdulaziz Al Hatila",
    "Saud Salem",
    "Saif Balhareth",
    "Mohammed Al Qahtani",
    "Ahmed Majrashi",
    "Ibrahim Ashi",
    "Khaled Narey",
    "Saleh Al Abbas",
    "Khaled Al-Lazam"
  ],
  "Al-Orobah": [
    "Rafi Al-Ruwaili",
    "Saud Al Ruwaili",
    "Abdulbari Al Daraan",
    "Jassim Al Ashban",
    "Ali Al-Sultan",
    "Mohammed Al-Amri",
    "Hussain Al Shuwaish",
    "Fahad Al Munaif",
    "Zeyad Al-Hunayti",
    "Hamed Al-Maqati",
    "Mishaal Al Ruwaili",
    "Mohammed Raed",
    "Khalid Abdulrahman",
    "Osama Al Rashed",
    "Darwin González",
    "Anass Najah",
    "Ahmed Al-Juwaid",
    "Fahad Al Reshedi",
    "Faraj",
    "Simy",
    "Aboubacar Doumbia",
    "Azzam Al Bishi",
    "Omar Al Sharari",
    "Mohammed Alhazmi",
    "Abdulaziz Masnom",
    "Rayan Al Hazmi",
    "Sultan Al Jarbi"
  ],
  "Al-Qadisiyah": [
    "Koen Casteels",
    "Ahmed Al-Kassar",
    "Meshari Sunyur",
    "Abgullah Almuhaysin",
    "Nacho",
    "Yasser Al-Shahrani",
    "Gastón Álvarez",
    "Mohammed Qasem",
    "Waleed Al-Ahmed",
    "Souffian El Karouani",
    "Jehad Thakri",
    "Otávio",
    "Julian Weigl",
    "Nahitan Nández",
    "Cameron Puertas",
    "Turki Al-Ammar",
    "Ali Abdullah Hazzazi",
    "Ibrahim Mahnashi",
    "Miguel Carvalho",
    "Musab Al-Juwayr",
    "Mohammed Abu Al-Shamat",
    "Aarón Martin Luis",
    "Eyad Houssa",
    "Julián Quiñones",
    "Mateo Retegui",
    "Abdullah Al-Salem",
    "Haitham Asiri",
    "Mohammed Al-Qahtani",
    "Christopher Bonsu Baah",
    "Gabriel Teixeira",
    "Jerry Afriyie"
  ],
  "Al-Raed": [
    "Saleh Alohaymid",
    "Feras Al Rajhi",
    "Mohamed Al Otaibi",
    "Mohammed Al Khaibari",
    "Oumar Gonzalez",
    "Abdullah Al Yousif",
    "Bander Whaeshi",
    "Faisal Abdulrazaq",
    "Abdullah Hazazi",
    "Tamim Al Shuqayran",
    "Basil Al Badawi",
    "Pedro Brito",
    "Yousri Bouzok",
    "Ali Al Shaikhi",
    "Saad Alsaluli",
    "Anas Al Zahrani",
    "Musleh Al Shaikh",
    "Ziyad Al Refaei",
    "Omar Ahmed Shami",
    "Salomon Tweh",
    "Abdullah Saeed Badogish",
    "Samer Al-Marwani",
    "Ayman Al-Balawi",
    "Karim Yoda",
    "Juan José Narváez",
    "Zinho Gano",
    "Yahya Sunbul"
  ],
  "Al-Riyadh": [
    "Milan Borjan",
    "Abdurahman Al Shammeri",
    "Emad Fidaa",
    "Jan Petek",
    "Abdullah Hassuna",
    "Mohammed Alkhaibari",
    "Sulaiman Hazazi",
    "Ahmed Khatir",
    "Marzouq Tambakti",
    "Osama Zaid Abdulaziz Al Bowardi",
    "Essam Bahri",
    "Saud Al Tumbukti",
    "Abdulaziz Al Asbahi",
    "Tozé",
    "Victor Lekhal",
    "Yahya Alshehri",
    "Khaled Ali",
    "Muhammad Sahlouli",
    "Salman Matar",
    "Faisal Al Subhi",
    "Mamadou Sylla",
    "Teddy Okou",
    "Nasser Al Bishi",
    "Leandro Antunes",
    "Luca Ramirez"
  ],
  "Al-Saqer": [
    "Azzam Al-Hussayen",
    "Hani Al-Nahedh",
    "Fares Al-Shammari",
    "Vinicius Milani",
    "Hussein Hawsawi",
    "Salman Al-Saeed",
    "Dawood Al-Tarif",
    "Abdulrahman Naji",
    "Hassan Al-Balawi",
    "João Erick",
    "Sulaiman Al-Dulaylan",
    "Nawaf Al-Reshoodi",
    "Manawa Emmanuel Kpatai",
    "Jasin Assehnoun",
    "Mohammed Al-Tuwaijri",
    "Mohanad Al-Shudukhi",
    "Fahad Al-Dawood",
    "Dennis Sesugh"
  ],
  "Al-Shabab": [
    "Abdulaziz Rahma",
    "Mohammed Al Mahasna",
    "Hussain Al-Sabiyani",
    "Mohammed Essa Harbush",
    "Mubarak Al-Rajeh",
    "Ali Makki",
    "Mohammed Al Shwirekh",
    "Mohammed Al Thani",
    "Sultan",
    "Yannick Carrasco",
    "Josh Brownhill",
    "Vincent Sierro",
    "Ali Al-Asmari",
    "Yacine Adli",
    "Nawaf Al Osaimi",
    "Carlos",
    "Daniel Podence",
    "Abdullah Saeed",
    "Hisham Al Dubais",
    "Hammam Al-Hammami",
    "Majed Abdullah"
  ],
  "Al-Taawoun": [
    "Mailson",
    "Abdullah Al-Jadani",
    "Abdul Rahman Al Ghamdi",
    "Abdulrahman Alsenaid",
    "Awn Al-Saluli",
    "Al Mufarrij",
    "Zineddine Belaïd",
    "Mohammed Al Hurayji",
    "Turki Al Jaadi",
    "Ibrahim Alshuayl",
    "Moustapha Sémbène",
    "Nawaf Mazen Al Hawairy",
    "Aschraf El Mahdioui",
    "Nedim Bajrami",
    "Ahmed Saleh Bahusayn",
    "Abdulrahman Hendi",
    "Turki Al Shaifan",
    "Abdulmalik Ghazzi Al Harbi",
    "Abderrazak Hamdallah",
    "Roger Martínez",
    "Fahad Alrashidi",
    "Mohammed Al Kuwaykibi",
    "Marin Petkov",
    "Mohammed Al Aqel",
    "Hamoud Bassam",
    "Saif Rashad Mohamed",
    "Bassem Al-Arini",
    "Anas Al Ghamdi",
    "Younes El Bahraoui"
  ],
  "Al-Tai": [
    "Victor Braga",
    "Moataz Al-Baqaawi",
    "Bader Nawaf",
    "Turki Fahad",
    "Enzo Roco",
    "Robert Bauer",
    "Ibrahim Alnakhli",
    "Abdulaziz Majrashi",
    "Tariq Mohammed",
    "Abdulmohsen Fallatah",
    "Hussain Salem",
    "Salem Al Toiawy",
    "Nawaf Al Qamiri",
    "Abdulkarim Sultan",
    "Safwan Saud S",
    "Mansour Alnakhli",
    "Salman Al-Moasher",
    "Alfa Semedo",
    "Mohammed Al-Qunaian",
    "Jamal Bajandouh",
    "Abdullah Al Shammari",
    "Abdulaziz Al Harabi",
    "Abdulrahman Al Harthi",
    "Bernard Mensah",
    "Hassan Alamri",
    "Abdulfattah Asiri",
    "Virgil Misidjan",
    "Marko Dugandzic",
    "Hazaa Al-Hazaa",
    "Andrei Cordea",
    "Rakan Shamlan",
    "Adeeb Al Haizan",
    "Amer Khalil"
  ],
  "Al-Wehda": [
    "Abdullah Al-Oaisher",
    "Abdulrahman Al-Shammeri",
    "Sultan Al Harbi",
    "Ahmed Al Rashidi",
    "Khaled Al Sharif",
    "Ali Adnan Kadhim",
    "Saeed Al-Mowalad",
    "Farouk Chafaï",
    "Hani Al-Subayani",
    "Abdulmohsen Fallatah",
    "Ahmed Saeed",
    "Masood Bekheet",
    "Adel Khodari",
    "Saad Al Qahtani",
    "Ridha Abdullah Ambadu",
    "Hattan Hadi Asiri",
    "Thamer Mahdali",
    "Rawaf Al Maqadi",
    "Salman Al-Moasher",
    "Augustine Oladepo",
    "Mehdi Boudjemaa",
    "Mohammed Al-Qunaian",
    "Khaled Majrashi",
    "Abdulaziz Majrashi",
    "Nawaf Bin Saleh Alazizi",
    "Salem Al-Maqadi",
    "Hazem Abdulrahim",
    "Demba Diallo",
    "Abdulaziz Makin",
    "Murad Khadari",
    "Fahad Al Taleb",
    "Satam Al Lehiyani",
    "Saif Al Amri"
  ],
  "Al-Zulfi": [
    "Abdullah Al-Saleh",
    "Saad Alsaleh",
    "Mohammed Al Ismail",
    "Mohammed Abdulrahman",
    "Antonio Gomez",
    "Yazeed Al Bakr",
    "Abdel Medioub",
    "Abdul Rahman Al Hajri",
    "Fahad Mustafa Aljayzani",
    "Saud Zaid Al Bawardi",
    "Salman Al Saeed",
    "Omar Al Zunaidi",
    "Hamza Barry",
    "Diego Miranda",
    "Abdulaziz Al Sharid",
    "Mutair Al Zahrani",
    "Thaar Al-Otaibi",
    "Ahmed Al-Anazi",
    "Maher Al Mutairi",
    "Abdulrahman Al Faleh",
    "Olanrewaju Kehinde",
    "Tilica",
    "Yahya Kharmi",
    "Eric Omondi",
    "Ben Malango",
    "Housseine Zakouani",
    "Nawaf Asiri",
    "Bassem Al Fanaital",
    "Abdullah Suwaid",
    "Majed Madani",
    "Ali Al Suqour"
  ],
  "Albacete": [
    "Diego Mariño",
    "Javier Moreno",
    "Jesús Vallejo",
    "Lluis López",
    "Fran Gamez",
    "Carlos Neva",
    "Pepe Sanchez",
    "Lorenzo Aguado",
    "Daniel Bernabeu",
    "Agus Medina",
    "Victor San Bartolomé",
    "Antonio Pacheco Ruiz",
    "Capi",
    "Javi Villar",
    "Higinio Marín",
    "Antonio Puertas",
    "Samuel Obeng",
    "Víctor Valverde Da Silva",
    "Marcos Moreno",
    "Álex Rubio",
    "Fran Gómez"
  ],
  "Albion": [
    "Danilo Lerda",
    "Pedro Jorge Ramallo Melo",
    "Sebastián Jaume Méndez",
    "Andrés Romero",
    "Matías De los Santos",
    "Federico Puente",
    "Francisco Couture",
    "Agustín Pereira",
    "Pablo Martín Lacoste Icardi",
    "Bautista Pérez Del Castillo Morales",
    "José Álvarez",
    "Ignacio Neira",
    "Hernán Toledo",
    "Francisco Ginella",
    "Carlos Airala",
    "Tomás Moschión",
    "Briam Acosta",
    "Lucas Rodríguez",
    "Santiago Costa",
    "Agustin Vera",
    "Pablo Alcoba",
    "Mateo Alcoba Daguirre",
    "Benjamin Rodríguez Álvarez",
    "Román Gutiérrez Corletto",
    "Álvaro López",
    "Tobías Figueroa",
    "Iker Zufiaurre",
    "Franco Abreu Firenze"
  ],
  "Aldosivi": [
    "Lucas Acosta",
    "Sebastian Moyano",
    "Ignacio Chicco",
    "Leonardo Sigali",
    "Lucas Rodríguez",
    "Néstor Breitenbruch",
    "Braian Cufré",
    "Nicolás Zalazar",
    "Rodrigo González",
    "Guillermo Enrique",
    "Elías López",
    "Joaquin Pombo",
    "Federico Laurelli",
    "Mateo Sebastián Vales",
    "Lucas Castro",
    "Nicolás Gaitán",
    "Roberto Bochi",
    "Federico Acevedo",
    "Franco Leys",
    "Nicolás Linares",
    "Lautaro Chávez",
    "Francisco Perruzzi",
    "Martín García",
    "Augusto Fernández",
    "Andrés Chávez",
    "Alan Sosa",
    "Andrés Vombergar",
    "Nicolás Cordero",
    "Matias Godoy",
    "Tomás Fernandez",
    "Emanuel Guzmán",
    "Blas Palavecino",
    "Bautista Dadín",
    "Felipe Anso"
  ],
  "Alemania": [
    "Manuel Neuer",
    "Oliver Baumann",
    "Alexander Nübel",
    "Nathaniel Brown",
    "Antonio Rüdiger",
    "Jonathan Tah",
    "Waldemar Anton",
    "David Raum",
    "Nico Schlotterbeck",
    "Malick Thiaw",
    "Pascal Gross",
    "Leon Goretzka",
    "Joshua Kimmich",
    "Nadiem Amiri",
    "Felix Nmecha",
    "Angelo Stiller",
    "Florian Wirtz",
    "Jamal Musiala",
    "Aleksandar Pavlovic",
    "Assan Ouédraogo",
    "Leroy Sané",
    "Kai Havertz",
    "Deniz Undav",
    "Maximilian Beier",
    "Jamie Leweling",
    "Nick Woltemade"
  ],
  "All Boys": [
    "Juan Pablo Noce",
    "Nicolás Carrizo",
    "Tobias Salas",
    "Maximiliano Coronel",
    "Emiliano Purita",
    "Franco Quiroz",
    "Alejo Tabares",
    "Ivan Zafarana",
    "Matías Rodríguez",
    "Gustavo Turraca",
    "Ricardo Blanco",
    "Santiago Caseres",
    "Ignacio Palacio",
    "Tomás Assennato",
    "Thiago Calone",
    "Santiago Apa",
    "Alexis Melo",
    "Bruno Medina",
    "Agustin Gallo",
    "Luciano Leguizamón",
    "Cristo Lozada Echenique"
  ],
  "Almagro": [
    "Emiliano Gonzalez",
    "Matías Cortave",
    "Gonzalo Asis",
    "Enzo Silcan",
    "Nicolás Tolosa",
    "Lautaro Busto",
    "Santiago Chamorro",
    "Julián Marchioni",
    "Julián Vitale",
    "Franco Bustamante",
    "Tobias Macies",
    "Joel Orlando",
    "Juan Fernández Pinto",
    "Joaquín Flores",
    "Pablo Palacio",
    "Thiago López",
    "Enzo Martínez"
  ],
  "Almería": [
    "Andrés Fernández",
    "Fernando Martínez",
    "Bruno Alemán",
    "Nélson Monte",
    "Rodrigo Ely",
    "Álex Muñoz",
    "Chumi",
    "Federico Bonini",
    "Daijiro Chirino",
    "Marcos Luna Marcos Ruiz",
    "Pedro Fidel",
    "Alejandro Pozo",
    "André Horta",
    "Nicolás Melamed",
    "Sergio Arribas",
    "Guilherme Borges Guedes",
    "Stefan Dzodic",
    "Léo Baptistão",
    "Adri Embarba",
    "Miguel de la Fuente",
    "Arvin Appiah",
    "Jon Morcillo",
    "Thalys"
  ],
  "Almirante Brown": [
    "Bruno Galván",
    "Augusto Bottini",
    "Gustavo Cabral",
    "Leonardo Jara",
    "Máximo Levi",
    "Ulises Abreliano",
    "Ramiro Fernández",
    "Tomás Villoldo",
    "Agustín Dattola",
    "Leonardo Escalante",
    "Gerardo Alegre",
    "Enzo Cardozo",
    "Giovanni Ferraina",
    "Alan Ramírez",
    "Jonathan Goya",
    "Joaquin Ibañez",
    "Facundo Quignón",
    "Santiago Vera",
    "Gaston Moreyra",
    "Gabriel Altamirano",
    "Leandro Iglesias",
    "Pedro Velurtas",
    "Mariano Santiago",
    "Luciano Pascual",
    "Joaquín Borja",
    "Santiago Gauna",
    "Tobias Quinteros",
    "Uriel Arena",
    "Julián López",
    "Ramón Gonzalez",
    "Facundo Garcia",
    "Tobías Zarate",
    "Matías Belloso",
    "Javier Martínez",
    "Lucas Vega",
    "Milton Zanotti"
  ],
  "AlUla": [
    "Abdulquddus Atiah",
    "Ahmed Al-Jubaya",
    "Salim Gabous",
    "Faris Afandy",
    "Yoann Barbet",
    "Ammar Al-Dohaim",
    "Yousef Haqawi",
    "Khaled Al-Ruwaili",
    "Hamdan Al-Shammrani",
    "Khaled Al-Shamrani",
    "Yasser Yaqoub",
    "Ammar Al-Harfi",
    "Ali Al-Zubaidi",
    "Danilo Barbosa",
    "Mohammed Al-Majhad",
    "Abdulmajeed Al-Sulayhim",
    "Nasser Al-Hadhood",
    "Faisal Al-Asmari",
    "Abdulaziz Al-Hatila",
    "Zaid Al-Anazi",
    "Michael",
    "Sumayhan Al-Nabit",
    "Ayman Al-Khulaif",
    "Thaar Al-Otaibi",
    "Fahad Al-Jumaiya",
    "Ahmad Al-Zain",
    "Mohammed Abbas Al-Nakhli",
    "Efthymios Koulouris",
    "Romell Quioto",
    "Abdulfattah Adam",
    "Aseel Abdulrazaq",
    "Freej Al-Jizani"
  ],
  "América Mineiro": [
    "Gustavo",
    "Bruno Brigido",
    "William",
    "Cássio",
    "Italo Brito",
    "Emerson Santos",
    "Ricardo Silva",
    "Alex",
    "Manoel",
    "Lucas Sosa",
    "Dalbert",
    "Wesley Augusto Henn Marth",
    "Tobías Ostchega",
    "Jhonny Cardinoti Pedro",
    "Rafael Barcelos",
    "Filipe Dahora",
    "Thallyson",
    "Luidy",
    "Gabriel De Oliveira Da Silva",
    "Fernando Elizari",
    "Jorge Roa",
    "Alê",
    "Eduardo Luiz Person",
    "Felipe Amaral",
    "Gabriel Domingos",
    "Yago Souza",
    "Thauan Willians Jesus Silva",
    "Otávio Gonçalves",
    "Julio César Leme Do Nascimento",
    "Murilo Rodrigues Povoa",
    "Willian",
    "Gonzalo Mastriani",
    "Guilherme Parede",
    "Rodrigo Piñeiro",
    "Matías Segovia",
    "Gabriel De Sousa Barros",
    "Paulo Victor",
    "Kaique Zizero",
    "Pedro Geovane Paranhos Santos",
    "Enrico Bernardes Ribeiro Prudencio",
    "Italo Gabriel Charbaje De Souza"
  ],
  "Angers": [
    "Melvin Zinga",
    "Oumar Pona",
    "Jordan Lefort",
    "Carlens Arcus",
    "Jacques Ekomie",
    "Lilian Raolisoa",
    "Yacine Gaya",
    "Marius Courcoul",
    "Marius Louãr",
    "Ousmane Camara",
    "Branco van den Boomen",
    "Haris Belkebla",
    "Louis Mouton",
    "Yassin Belkhdim",
    "Emmanuel Biumla",
    "Jim Allevinah",
    "Amine El Ouazzani",
    "Amine Sbaï",
    "Prosper Peter",
    "Harouna Djibirin"
  ],
  "Annecy": [
    "Florian Escales",
    "Thomas Callens",
    "Matéo Gonzalez",
    "Aymerick Nedelec",
    "Francois Lajugie",
    "Matteo Veillon",
    "Thibault Delphis",
    "Julien Kouadio",
    "Axel Drouhin",
    "Esteban Riou",
    "Esteban Marre",
    "Sacha Lima",
    "Ahmed Kashi",
    "Alexis Casadei",
    "Nolan Ferro",
    "Mohamed Koné",
    "Pascal Mozie",
    "Ibrahim Raache",
    "Kilyan Veniere",
    "Paul Venot",
    "Alan Mondesir",
    "Antoine Larose",
    "Clément Billemaz",
    "Thibault Rambaud",
    "Dion Moise Sahi",
    "Zepiqueno Redmond",
    "Kadan Young",
    "Ben Touré",
    "Adam Yahi"
  ],
  "Arabia Saudí": [
    "Ahmed Al-Kassar",
    "Mohammed Al-Owais",
    "Nawaf Al-Aqidi",
    "Hassan Kadish",
    "Hassan Al-Tambakti",
    "Abdulelah Al-Amri",
    "Saud Abdulhamid",
    "Ali Lajami",
    "Moteb Al-Harbi",
    "Nawaf Boushal",
    "Ali Majrashi",
    "Jehad Thakri",
    "Salem Al-Dawsari",
    "Mohamed Kanno",
    "Nasser Al-Dawsari",
    "Abdullah Al-Khaibari",
    "Aiman Yahya",
    "Ziyad Al-Johani",
    "Musab Al-Juwayr",
    "Ala Al-Hajji",
    "Mohammed Abu Al-Shamat",
    "Saleh Al-Shehri",
    "Feras Al-Brikan",
    "Sultan Mandash",
    "Khalid Al-Ghannam",
    "Abdullah Al-Hamdan"
  ],
  "Arezzo": [
    "Luca Trombini",
    "Amoris Galli",
    "Marco Chiosa",
    "Filippo De Col",
    "Mauro Coppolaro",
    "Samuele Righetti",
    "Fabio Tito",
    "Matias Casarosa",
    "Matteo Gilli",
    "Artur Ionita",
    "Shaka Mawuli",
    "Mattia Viviani",
    "Luca Chierico",
    "Alessandro Renzi",
    "Matteo Cortesi",
    "Camillo Tavernelli",
    "Mario Ravasio",
    "Pietro Cianci",
    "Muhamed Djamanca",
    "Emiliano Pattarello"
  ],
  "Argentina": [
    "Emiliano Martínez",
    "Gerónimo Rulli",
    "Juan Musso",
    "Cristian Romero",
    "Nicolás Otamendi",
    "Nicolás Tagliafico",
    "Nahuel Molina",
    "Gonzalo Montiel",
    "Lisandro Martínez",
    "Marcos Senesi",
    "Facundo Medina",
    "Leandro Paredes",
    "Rodrigo De Paul",
    "Giovani Lo Celso",
    "Exequiel Palacios",
    "Alexis Mac Allister",
    "Thiago Almada",
    "Enzo Fernández",
    "Valentín Barco",
    "José Manuel López",
    "Giuliano Simeone",
    "Lionel Messi",
    "Nico González",
    "Lautaro Martínez",
    "Julián Álvarez",
    "Nico Paz"
  ],
  "Argentinos Juniors": [
    "Diego Rodríguez",
    "Brayan Cortés",
    "Gonzalo Siri Payer",
    "Erik Godoy",
    "Sebastián Prieto",
    "Luciano Sánchez",
    "Claudio Bravo",
    "Francisco Álvarez",
    "Franco Paredes",
    "Kevin Coronel",
    "Thiago Gómez",
    "Facundo Carrizo",
    "Santino Gianini",
    "Facundo Gutiérrez",
    "Hernan Lopez",
    "Nicolás Oroz",
    "Gabriel Florentín",
    "Gino Infantino",
    "Joaquin Gho",
    "Emiliano Viveros",
    "Alan Lescano",
    "Alan Alcaraz",
    "Matías Giménez",
    "Tomás Molina",
    "Iván Morales",
    "Gastón Verón",
    "Ryoga Kida",
    "Diego Porcel",
    "Facundo Jainikoski",
    "Gastón Bouhier"
  ],
  "Arminia Bielefeld": [
    "Leo Oppermann",
    "Jonas Kersken",
    "Philip Hildesheim",
    "Maximilian Bauer",
    "Joe Felix",
    "Arne Sicker",
    "Tim Handwerker",
    "Maximilian Grober",
    "Leon Schneider",
    "Henri Koudossou",
    "Felix Hagmann",
    "Stefano Russo",
    "Marvin Mehlem",
    "Sam Schreck",
    "Lukas Kunze",
    "Jannik Rochelt",
    "Marius Worl",
    "Eyyüb Yasar",
    "Till Wegener",
    "Roberts Uldrikis",
    "Joel Grodowski",
    "Jeredy Hilterman",
    "Isaiah Young",
    "Monju Momuluh",
    "Benjamin Boakye",
    "Daniel Richter"
  ],
  "Arsenal": [
    "Kepa Arrizabalaga",
    "David Raya",
    "Illan Meslier",
    "Tommy Setford",
    "Gabriel Magalhães",
    "Ben White",
    "William Saliba",
    "Jurriën Timber",
    "Piero Hincapié",
    "Riccardo Calafiori",
    "Cristhian Mosquera",
    "Myles Lewis-Skelly",
    "Fabio Vieira",
    "Martin Ødegaard",
    "Mikel Merino",
    "Bruno Guimarães",
    "Declan Rice",
    "Eberechi Eze",
    "Martín Zubimendi",
    "Ethan Nwaneri",
    "Gabriel Jesus",
    "Reiss Nelson",
    "Kai Havertz",
    "Viktor Gyökeres",
    "Gabriel Martinelli",
    "Bukayo Saka",
    "Noni Madueke",
    "Christos Tzolis"
  ],
  "AS Nancy Lorraine": [
    "Enzo Basilio",
    "Kenzo Noel",
    "Nicholas Saint-Ruf",
    "Nehemiah Fernandez",
    "Thierno Balde",
    "Yannis Nahounou",
    "Elydjah Mendy",
    "Enzo Tacafred",
    "Jérémy Gelin",
    "Brandon Bokangu",
    "Oumar Sidibé",
    "Chafik El Hansar",
    "Yanis Delaveau",
    "Hugo Barbier",
    "Adrian Dabasse",
    "Walid Bouabdelli",
    "Zakaria Fdaouch",
    "Zakaria Ztouti",
    "Kouroufia Kebe"
  ],
  "AS Roma": [
    "Pierluigi Gollini",
    "Mile Svilar",
    "Giorgio De Marzi",
    "Gianluca Mancini",
    "Mario Hermoso",
    "Evan Ndicka",
    "Devyne Rensch",
    "Wesley",
    "Konstantinos Koulierakis",
    "Jan Ziólkowski",
    "Emanuele Lulli",
    "Mohamed Seck",
    "Bryan Cristante",
    "Lorenzo Pellegrini",
    "Manu Koné",
    "Neil El Aynaoui",
    "Niccolò Pisilli",
    "Muhammed Bah",
    "Francesco Panico",
    "Gioele Giammattei",
    "Paulo Dybala",
    "Matìas Soulè",
    "Robinio Vaz",
    "Antonio Arena",
    "Edoardo Morucci"
  ],
  "Ascoli": [
    "Davide Barosi",
    "Samuele Vitale",
    "Rok Brzan",
    "Marcos Curado",
    "Manuel Nicoletti",
    "Nicholas Rizzo",
    "Manuel Alagna",
    "Abdoul Guiebre",
    "Damiano Menna",
    "Samuele Damiani",
    "Giovanni Corradini",
    "Tommaso Milanese",
    "Ferdinando Del Sole",
    "Gabriele Gori",
    "Filippo Palazzino",
    "Andrea Silipo",
    "Simone D'Uffizi",
    "Mohammed Amine Chakir"
  ],
  "Aston Villa": [
    "Marco Bizot",
    "Emiliano Martínez",
    "James Wright",
    "Owen Asemota",
    "Tyrone Mings",
    "Victor Lindelöf",
    "Ezri Konsa",
    "Matty Cash",
    "Pau Torres",
    "Ian Maatsen",
    "Kosta Nedeljkovic",
    "Modou Cissé",
    "Ross Barkley",
    "John McGinn",
    "Emiliano Buendía",
    "Boubacar Kamara",
    "João Gomes",
    "Amadou Onana",
    "Lamare Bogarde",
    "Johan Manzambi",
    "Ollie Watkins",
    "Leon Bailey",
    "Tammy Abraham",
    "Evann Guessand",
    "Alejandro Garnacho",
    "Samuel Iling-Junior",
    "Alysson"
  ],
  "Atalanta": [
    "Francesco Rossi",
    "Marco Sportiello",
    "Marco Carnesecchi",
    "Sead Kolasinac",
    "Davide Zappacosta",
    "Mitchel Bakker",
    "Raoul Bellanova",
    "Odilon Kossounou",
    "Lorenzo Bernasconi",
    "Giorgio Scalvini",
    "Isak Hien",
    "Honest Ahanor",
    "Marten de Roon",
    "Mario Pasalic",
    "Éderson",
    "Nicola Zalewski",
    "Lazar Samardzic",
    "Sulemana",
    "Gianluca Scamacca",
    "Nikola Krstovic",
    "Giacomo Raspadori",
    "Charles De Ketelaere",
    "Kamaldeen Sulemana"
  ],
  "Atenas": [
    "Matías Soria",
    "Franco Pérez",
    "Mateo Ledesma",
    "Mauricio Mansilla",
    "Francisco Araya",
    "Alan Fernández",
    "Rafael Ríos",
    "Juan Ignacio Romero",
    "Agustín Arcando",
    "Augusto Macarrón",
    "Elías Quiroga",
    "Giuliano Guzmán",
    "Luciano Gutiérrez",
    "Valentín Duco",
    "Ignacio Rojas",
    "Francisco Herrera",
    "Mariano Martínez",
    "Marcos Rivadero",
    "Enzo Godoy",
    "Emiliano Gómez",
    "Agustín Suárez",
    "Carlos Rosales",
    "Martín Argüello",
    "Ignacio Castro",
    "Francisco Russo",
    "Martin Vera",
    "Diego Azcurra",
    "Juan Barrera",
    "Alejo Mainero",
    "Facundo Quiroga",
    "Emiliano Gomez",
    "Franco Schiavoni",
    "Lautaro Barile",
    "Mateo Felippa",
    "Mateo Maná",
    "Santiago Rins",
    "Tomás Fernández",
    "Thiago Pagliaricci",
    "Franco Perez",
    "Pablo Oballes",
    "Agustín Galeazzi",
    "Diego Oyola",
    "Ezequiel Morales",
    "Lionel Pedrueza",
    "Nicolás Bergalli",
    "Patricio Muchut",
    "Pascual Rivero",
    "Santiago Abayay"
  ],
  "Athletic Bilbao": [
    "Unai Simón",
    "Mikel Santos",
    "Álex Padilla",
    "Yuri Berchiche",
    "Aymeric Laporte",
    "Yeray",
    "Andoni Gorosabel",
    "Dani Vivian",
    "Jesús Areso",
    "Aitor Paredes",
    "Unai Egiluz",
    "Adama Boiro",
    "Iker Monreal",
    "Iñigo Ruiz de Galarreta",
    "Robert Navarro",
    "Oihan Sancet",
    "Beñat Prados",
    "Mikel Jauregizar",
    "Alejandro Rego",
    "Selton Sánchez",
    "Álex Berenguer",
    "Iñaki Williams",
    "Gorka Guruzeta",
    "Nico Williams",
    "Nico Serrano",
    "Maroan Sannadi",
    "Elijah Gift"
  ],
  "Athletic Club-MG": [
    "Luan Polli",
    "Jhonatan",
    "Zeca",
    "Diogo Batista",
    "Lucas Belezi",
    "Douglas",
    "Gustavinho",
    "Gian Cabezas",
    "Jota",
    "Pedro Oliveira",
    "Kauan Lindes",
    "João Miguel Da Costa Pereira",
    "Dixon Vera",
    "Otávio Bruno",
    "Kauan",
    "Max"
  ],
  "Athletico Paranaense": [
    "Santos",
    "Mycael",
    "Matheus Rocha",
    "Maksym Voronov",
    "Carlos Eduardo Souza De Barros",
    "Carlos Terán",
    "Gilberto",
    "Léo",
    "Juan Felipe Aguirre",
    "Gastón Benavídez",
    "Lucas Esquivel",
    "Filipinho",
    "Leonardo Derik",
    "Dantas",
    "Gilberto Junior",
    "Arthur Dias",
    "Victor Vinicius Teodoro Ferraz",
    "Claudinho",
    "Gustavo Veiga",
    "Arthur Monteiro",
    "Juan Portilla",
    "Luiz Gustavo",
    "Jádson",
    "Alejandro García",
    "Bruno Zapelli",
    "Eduardo",
    "João Cruz",
    "Chiqueti",
    "Diogo Riquelme",
    "Guilherme Back",
    "Bruninho",
    "Lucas Marezi",
    "Stiven Mendoza",
    "Kevin Viveros",
    "Renan",
    "Kerwin Vargas",
    "Isaac",
    "Jorge Rivaldo",
    "Lucas Amorim",
    "Leozinho"
  ],
  "Atlanta": [
    "Juan Rago",
    "Francisco Villafañe",
    "Rodrigo Moreira",
    "Leonel Galeano",
    "Martín García",
    "Javier Osatchuk",
    "Santino Pasini",
    "Román Herrera",
    "Dylan Argüello",
    "Rodrigo Sosa",
    "Federico Álvarez",
    "Nicolas Previtali",
    "Lautaro López",
    "Kevin Benitez",
    "Cristian Bernardi",
    "Braian Rivero",
    "Tomás Castro Ponce",
    "Federico Bisanz",
    "Jere Rodríguez",
    "Nahuel Urtasun",
    "Mateo Araujo",
    "Thiago Ruiz",
    "Julián Aquino",
    "Tiago Romero",
    "Matías Ibarra",
    "Gustavo Mendoza",
    "Alejandro Quintana",
    "Federico Castro",
    "Gonzalo Miranda",
    "Lautaro Fedele",
    "Ignacio Rodríguez"
  ],
  "Atlanta United": [
    "Lucas Hoyos",
    "Jayden Hibbert",
    "Matt Edwards",
    "Júnior Alonso",
    "Stian Gregersen",
    "Ronald Hernández",
    "Enea Mihaj",
    "Tomás Jacob",
    "Elías Baez",
    "Dominik Chong Qui",
    "Toto Majub",
    "Alexey Miranchuk",
    "Steven Alzate",
    "Tristan Muyumba",
    "Will Reilly",
    "Jay Fortune",
    "Luke Brennan",
    "Adrian Gill",
    "Adyn Torres",
    "Cooper Sanchez",
    "Santiago Pita",
    "Ignacio Suarez-Couri",
    "Miguel Almirón",
    "Fafà Picault",
    "Sergio Santos",
    "Cayman Togashi",
    "Arif Kovac"
  ],
  "Atlético de Rafaela": [
    "Mayco Bergia",
    "Máximo Spesso",
    "Gabriel Fernández",
    "Fernando Ponce",
    "Roque Ramirez",
    "Matias Morello",
    "Nicolás Ramos",
    "Agustín Solveyra",
    "Ariel Gonzalez",
    "Nicolás Utrera",
    "Luciano Echeverría",
    "Enzo Wattier",
    "Ignacio Grandoli",
    "Nicolás Wabeke",
    "Valentín Mondino",
    "Tomás Rojas",
    "Leonardo Flores",
    "Marcos Fernández",
    "Juan Ignacio Cavallaro",
    "Esteban Pepino",
    "Federico Jourdan",
    "Juan Capurro",
    "Facundo Soloa",
    "Nahuel Cainelli",
    "Ulises Yegros",
    "Damiano Jaime",
    "Valentino Arro",
    "Rodrigo Suárez",
    "Joel Bonifacio",
    "Matias Pardo",
    "Mauro Quiroga",
    "Lucas Albertengo",
    "Cristian Esparza",
    "Ijiel Protti",
    "Alexis Rodríguez",
    "Agustín Obando",
    "Martiniano Moreno",
    "Lorenzo Moscoloni",
    "Benjamin Moyano"
  ],
  "Atlético Goianiense": [
    "Paulo Henrique",
    "Vladimir",
    "Paulo Vítor",
    "Léo Medeiros",
    "Railson",
    "Yuri",
    "Geovane",
    "Guilherme Almeida",
    "Ewerton",
    "Adriano Martins",
    "Gebson",
    "Natã",
    "Junior Barreto",
    "Marcao",
    "Gustavo Daniel",
    "Matheus Bebeto",
    "Mateus Macedo",
    "Felipe Guimarães Da Silva",
    "Guillermo",
    "Isaac",
    "Kaio Cavalo",
    "Kauã Henrique Dos Santos",
    "Guilherme",
    "Igor Henrique",
    "Leandro Vilela",
    "Matheuzinho",
    "José Domingo Moraes Neto",
    "Bruno José",
    "Cristiano",
    "Henrique",
    "Gabriel Araujo",
    "Peixoto",
    "Assis",
    "Klebert De Oliveira Pereira",
    "Jampierre",
    "Sancho",
    "Geovany Soares",
    "Anthony Matheus",
    "Kaio Gois",
    "Mateus Aires",
    "Riquelme",
    "Marrony",
    "Léo Tocantins",
    "Gustavo Coutinho",
    "João Pedro",
    "Gustavo Maia",
    "Kahiser Lenis",
    "Daniel",
    "Leo Jacó",
    "Guilherme Henrique De Oliveira Morais",
    "Nathan",
    "Alan",
    "Eduardo Taumaturgo",
    "Gabriel Adão",
    "Gabriel Dias",
    "Gabriel Maranhão",
    "Gabriel Antonio Souza Silva",
    "Brenno Das Chagas Gomes"
  ],
  "Atlético Madrid": [
    "Jan Oblak",
    "Juan Musso",
    "Nahuel Molina",
    "José María Giménez",
    "Robin Le Normand",
    "Dávid Hancko",
    "Matteo Ruggeri",
    "Marc Pubill",
    "Rodrigo Mendoza",
    "Koke",
    "Marcos Llorente",
    "Lee Kang-In",
    "Morten Hjulmand",
    "Johnny Cardoso",
    "Álex Baena",
    "Obed Vargas",
    "Pablo Barrios",
    "Alexander Sørloth",
    "Ademola Lookman",
    "Julián Álvarez",
    "Giuliano Simeone",
    "Carlos Martín"
  ],
  "Atlético Mineiro": [
    "Éverson",
    "Gabriel Delfim",
    "Pedro Cobra",
    "Robert",
    "Kaio",
    "Vitor Hugo",
    "Lyanco",
    "Léo Duarte",
    "Renan Lodi",
    "Ángelo Preciado",
    "Ruan",
    "Natanael",
    "Samuel Barros",
    "Vitão",
    "Wanderson Junior De Souza Vaz",
    "Lucas Souza",
    "Pedro Tocantins",
    "Pedro Francisco Fachinetti Dos Santos",
    "Luís Gustavo",
    "Kauã Pascini",
    "Samuel Almeida",
    "Bernard",
    "Gustavo Scarpa",
    "Maycon",
    "Alan Franco",
    "Igor Gomes",
    "Reiner",
    "Victor Hugo",
    "Alexsander",
    "Patrick Silva",
    "Eric",
    "Hendel Dos Santos",
    "Mamady Cissé",
    "Mateus Romero",
    "João Pedro Porto Lucrécio",
    "Tomas Perez",
    "Dudu",
    "Mateo Casierra",
    "Tomás Cuello",
    "Thiago Borbas",
    "Alan Minda",
    "Lucas Louback",
    "Gabriel Veneno",
    "Wallysson Da Silva",
    "Cauã Soares",
    "Murillo Fernandes",
    "Riquelme Henrique",
    "João Teixeira"
  ],
  "Atlético Tucumán": [
    "Tomás Durso",
    "Luis Ingolotti",
    "Patricio Albornoz",
    "Leonel Di Plácido",
    "Juan Infante",
    "Gabriel Compagnucci",
    "Gastón Suso",
    "Juan Rodríguez",
    "Maxi Villa",
    "Gianluca Ferrari",
    "Ignacio Galván",
    "Clever Ferreira",
    "Luciano Vallejo",
    "Ramiro Paunero",
    "Julián Fernández",
    "Martín Benítez",
    "Ezequiel Ham",
    "Renzo Tesuri",
    "Ezequil Godoy",
    "Kevin Ortíz",
    "Lautaro Godoy",
    "Leonel Vega",
    "Tomás Jung",
    "Pedro Canelo",
    "Leandro Díaz",
    "Ramiro Ruiz Rodriguez",
    "Nicolás Laméndola",
    "Franco Albanell",
    "Lucas Román",
    "Facundo Pimienta",
    "Manuel Brondo",
    "Carlos Abeldano",
    "Rodrigo Granillo"
  ],
  "Augsburg": [
    "Finn Dahmen",
    "Nediljko Labrovic",
    "Jeffrey Gouweleeuw",
    "Mads Pedersen",
    "Keven Schlotterbeck",
    "Chrislain Matsima",
    "Robin Fellhauer",
    "Noahkai Banks",
    "Marius Wolf",
    "Alexis Claude-Maurice",
    "Kristijan Jakic",
    "Yannik Keitel",
    "Han-Noah Massengo",
    "Fabian Rieder",
    "Tim Breithaupt",
    "Anton Kade",
    "Mert Kömür",
    "Michael Gregoritsch",
    "Steve Mounié",
    "Rodrigo Ribeiro",
    "Thomas Kastanaras",
    "Uchenna Ogundu"
  ],
  "Austin FC": [
    "Brad Stuver",
    "Damian Las",
    "Charlie Farrar",
    "Oleksandr Svatok",
    "Mikkel Desler",
    "Jon Gallagher",
    "Brendan Hines-Ike",
    "Jon Bell",
    "Zan Kolmanic",
    "Guilherme Biro",
    "Riley Thomas",
    "Mateja Djordjevic",
    "Ilie Sánchez",
    "Besard Sabovic",
    "Joseph Rosales",
    "Przemyslaw Placheta",
    "Owen Wolff",
    "CJ Fodrey",
    "Micah Burton",
    "Jorge Alastuey",
    "Ervin Torres",
    "Facundo Torres",
    "Brandon Vázquez",
    "Christian Ramírez",
    "Myrto Uzuni",
    "Jayden Nelson"
  ],
  "Auxerre": [
    "Paul Nardi",
    "Mamadou Diop",
    "Louis Mezerette",
    "Francisco Sierralta",
    "Sekou Fofana",
    "Sinaly Diomande",
    "Marvin Senaya",
    "Fredrik Oppegard",
    "Bryan Okoh",
    "Lamine Sy",
    "Clément Akpa",
    "Christ Makosso",
    "Wei Xiangxin",
    "Telli Siwe",
    "Elikya Legros",
    "Assane Dioussé",
    "Elisha Owusu",
    "Romain Faivre",
    "Naouirou Ahamada",
    "Lasso Coulibaly",
    "Kévin Danois",
    "Arthur Piedfort",
    "Aristide Zossou",
    "Tidiane Devernois",
    "Danny Namaso",
    "Thelonius Bair",
    "Eros Maddy",
    "Josué Casimir",
    "Ryan Rodin"
  ],
  "Avaí": [
    "Igor José Bohn",
    "Otávio",
    "Leonardo",
    "Mateus Quaresma",
    "Reynaldo",
    "Allyson",
    "Douglas",
    "Jefferson",
    "Wallison",
    "Guilherme Aquino",
    "William Fernando",
    "Gabriel Simples",
    "Kauã Dias",
    "Kauã Fernandes",
    "Luiz Henrique",
    "Zé Ricardo",
    "Daniel Penha",
    "Jean Lucas Figueiredo",
    "Del Piage",
    "Wenderson",
    "Pedro Cuiabá",
    "Paulo Vitor",
    "Hyan",
    "Nicolas Tedesco",
    "Kevin",
    "Vinicius",
    "Léo Gamalho",
    "Isaías",
    "Thayllon",
    "Marcio Vitor",
    "João Vitor Oliveira",
    "Tucão",
    "Juan Rocha",
    "Gabriel Frederico Cipriano",
    "Caio Brazil Fonseca"
  ],
  "Avellino": [
    "Antony Iannarilli",
    "Marco Sala",
    "Armando Izzo",
    "Tommaso Cancellotti",
    "Lorenco Simic",
    "Patrick Enrici",
    "Alessandro Fontanarosa",
    "António Aloisi",
    "Umberto Volpe",
    "Dimitris Sounas",
    "Luca Palmiero",
    "Martin Palumbo",
    "Michele Besaggio",
    "Roberto Insigne",
    "Tommaso Biasci",
    "Cosimo Francesco Patierno",
    "Andrea Favilli",
    "Raffaele Russo"
  ],
  "Bahia": [
    "Léo",
    "Guido Herrera",
    "Ronaldo",
    "Victor",
    "Fabio",
    "Iuri Jean Carlo Neres Dos Santos",
    "Santiago Ramos",
    "David Duarte",
    "Kanu",
    "Marco Moreno",
    "Luciano Juba",
    "Marcos Victor",
    "Zé Guilherme",
    "Luiz Gustavo",
    "Román Gómez",
    "Fredi Lippert",
    "Gerald",
    "Éverton Ribeiro",
    "Michel Araújo",
    "Erick",
    "Rodrigo Nestor",
    "Jean Lucas",
    "Nicolás Acevedo",
    "Caio Alexandre",
    "Roger Gabriel",
    "Sidney",
    "David Martins",
    "Pedrinho",
    "Wendel Passos",
    "Cristian Olivera",
    "Everaldo",
    "Willian José",
    "Ademir",
    "Alejo Veliz",
    "Erick Pulga",
    "Mateo Sanabria",
    "Ruan Pablo",
    "Dell",
    "João Coni",
    "Kaue Furquim",
    "Lyan Araujo Santos",
    "Caio Suassuna",
    "Ryan Nascimento"
  ],
  "Banfield": [
    "Joaquín Molina",
    "Facundo Sanguinetti",
    "Gino Santilli",
    "Juan Alfaro",
    "Nicolás Meriano",
    "Luis Abraham",
    "Santiago Daniele",
    "Brandon Oviedo",
    "Marcos López",
    "Mateo Mendizabal",
    "Favio Álvarez",
    "Neyder Moreno",
    "Santiago López Garcia",
    "Lautaro Ríos",
    "Ignacio Pais",
    "Lautaro Villegas",
    "Tomás Adoryan",
    "Lucas Palavecino",
    "Federico Medina",
    "Lautaro Gómez",
    "Santiago Esquivel",
    "Isaías Bladimir Gutiérrez",
    "David Salazar",
    "Federico Anselmo",
    "Thomas Rodriguez",
    "Bruno Sepúlveda",
    "Lisandro Piñero",
    "Tiziano Perrota",
    "Valentín González",
    "Jeremiah Ezekiel Acosta Bobadilla"
  ],
  "Barcelona": [
    "Wojciech Szczesny",
    "Joan García",
    "Eric García",
    "Andreas Christensen",
    "Jules Koundé",
    "Gerard Martín",
    "Alejandro Balde",
    "Pau Cubarsí",
    "Frenkie de Jong",
    "Dani Olmo",
    "Pedri",
    "Gavi",
    "Marc Casadó",
    "Fermín López",
    "Marc Bernal",
    "Raphinha",
    "Ferran Torres",
    "Roony Bardghji",
    "Lamine Yamal"
  ],
  "Barracas Central": [
    "Juan Espínola",
    "Marcelo Miño",
    "Juan Insúa",
    "Fernando Tobio",
    "Damián Martínez",
    "Gastón Campi",
    "Rafael Barrios",
    "Yonatthan Rak",
    "Nicolás De Martini",
    "Elías Pereyra",
    "Rodrigo Insúa",
    "Kevin Jappert",
    "Nicolás Capraro",
    "Carlos Arce",
    "Dardo Miloc",
    "Yeison Gordillo",
    "Rodrigo Bogarín",
    "Gonzalo Maroni",
    "Iván Tapia",
    "Maximiliano Puig",
    "Tomás Porra",
    "Enzo Taborda",
    "Manuel Duarte",
    "Iván Guaraz",
    "Javier Morales",
    "Lucas Gamba",
    "Norberto Briasco",
    "Jhonatan Candia",
    "Facundo Bruera",
    "Juan Ignacio Barbieri",
    "Wilfredo Rivera",
    "Valentino Gandín",
    "Tomas Lavezzi"
  ],
  "Bayer Leverkusen": [
    "Janis Blaswich",
    "Niklas Lomb",
    "Mark Flekken",
    "Lucas Vázquez",
    "Edmond Tapsoba",
    "Miguel Gutiérrez",
    "Jarell Quansah",
    "Loïc Badé",
    "Jeanuël Belocian",
    "Arthur",
    "Tim Oermann",
    "Axel Tape",
    "Jonas Hofmann",
    "Robert Andrich",
    "Aleix García",
    "Exequiel Palacios",
    "Malik Tillman",
    "Ibrahim Maza",
    "Ezequiel Fernández",
    "Kennet Eichhorn",
    "Montrell Culbreath",
    "Patrik Schick",
    "Martin Terrier",
    "Nathan Tella",
    "Victor Boniface",
    "Ernest Poku",
    "Eliesse Ben Seghir",
    "Christian Kofane"
  ],
  "Bayern Munich": [
    "Manuel Neuer",
    "Sven Ulreich",
    "Jonas Urbig",
    "Leon Klanac",
    "David Podar-Stiube",
    "Hiroki Ito",
    "Kim Min-Jae",
    "Jonathan Tah",
    "Dayot Upamecano",
    "Alphonso Davies",
    "Josip Stanisic",
    "Richard Ajayi Oluwaseyi",
    "Konrad Laimer",
    "Joshua Kimmich",
    "Michael Olise",
    "Jamal Musiala",
    "Ismael Saibari",
    "Tom Bischof",
    "Aleksandar Pavlovic",
    "Lennart Karl",
    "Michael Matošević",
    "Harry Kane",
    "Serge Gnabry",
    "Luis Díaz",
    "Skender Nuraj"
  ],
  "Belgrano": [
    "Thiago Cardozo",
    "Manuel Vincentini",
    "Matías Daniele",
    "Santiago Ferez",
    "Lisandro López",
    "Federico Ricca",
    "Adrián Sporle",
    "Leonardo Morales",
    "Alexis Maldonado",
    "Alcides Benítez",
    "Álvaro Ocampo",
    "Agustín Falcón",
    "Agustín Griguol",
    "Joaquín Flandes",
    "Adrián Sánchez",
    "Franco Vázquez",
    "Marcos Ortiz",
    "Lucas Zelarayán",
    "Emiliano Rigoni",
    "Francisco Gonzalez Metilli",
    "Santiago Longo",
    "Ramiro Hernandes",
    "Santino Gatti",
    "Ramiro Tulián",
    "Thiago Cortés",
    "Lucas Passerini",
    "Nicolás Fernández",
    "Juan Velazquez",
    "Gonzalo Zelarayán",
    "Lautaro Gutierrez",
    "Luciano Agustin Bonomo Garcia",
    "Julián David Nuñez"
  ],
  "Benevento": [
    "Gianmarco Vannucchi",
    "Alioune Sylla",
    "Manuel Esposito",
    "Luca Caldirola",
    "Stefano Scognamillo",
    "Giacomo Ricci",
    "Leonardo Sernicola",
    "Pietro Beruatto",
    "Raffaele Celia",
    "Christian Dalle Mura",
    "Pietro Saio",
    "Edoardo Pierozzi",
    "Raffaele Romano",
    "Mattia Maita",
    "Christian Kouan",
    "Pier Luigi Simonetti",
    "Antonis Siatounis",
    "Emanuele Schimmenti",
    "Angelo Talia",
    "Antonio Prisco",
    "Lorenzo Carfora",
    "Dino Mehic",
    "Jacopo Manconi",
    "Francesco Salvemini",
    "Marco Tumminello",
    "Davide Lamesta",
    "Guglielmo Mignani",
    "Logan Gaspar Queiroz De Freitas"
  ],
  "Birmingham City": [
    "Ryan Allsop",
    "Bradley Mayo",
    "Jack Robinson",
    "Bright Osayi-Samuel",
    "Phil Neumann",
    "Alex Cochrane",
    "Christoph Klarer",
    "Lee Buchanan",
    "Ethan Laird",
    "William Burrell",
    "Patrick Roberts",
    "Paik Seung-Ho",
    "Kanya Fujimoto",
    "Tomoki Iwata",
    "Cobi Maddox",
    "Marvin Ducksch",
    "Carlos Vicente",
    "Demarai Gray",
    "Jay Stansfield",
    "August Priske",
    "Zaid Betteka",
    "Briar Bateman"
  ],
  "Blackburn Rovers": [
    "Aynsley Pears",
    "Balazs Toth",
    "Yuri Ribeiro",
    "Scott Wharton",
    "Harry Pickering",
    "Hayden Carter",
    "Sean McLoughlin",
    "Lewis Miller",
    "Ryan Alebiousu",
    "Dion De Neve",
    "Connor O'Riordan",
    "Tom Atcheson",
    "Matty Litherland",
    "George Pratt",
    "Adam Forshaw",
    "Todd Cantwell",
    "Sidnei Tavares",
    "Ryoya Morishita",
    "Axel Henriksson",
    "Jake Garrett",
    "Kristi Montgomery",
    "Moussa Baradji",
    "Oladapo Afolayan",
    "Mathias Jørgensen",
    "Augustus Kargbo",
    "Yuki Ohashi",
    "Jayden Fevrier",
    "Andri Gudjohnsen",
    "Igor Tyjon"
  ],
  "Boca Juniors": [
    "Javier García",
    "Álvaro Montero",
    "Agustín Marchesín",
    "Leandro Brey",
    "Fernando Rodríguez",
    "Jorge Figal",
    "Marcelo Weigandt",
    "Juan Barinaga",
    "Ayrton Costa",
    "Lautaro Blanco",
    "Marco Pellegrino",
    "Leandro Lozano",
    "Lautaro Di Lollo",
    "Dylan Gorosito",
    "Facundo Herrera",
    "Matías Satas",
    "Gian Paoli",
    "Baltazar Blum Macías",
    "Camilo Rey",
    "Rodrigo Battaglia",
    "Leandro Paredes",
    "Carlos Palacios",
    "Santiago Ascacibar",
    "Tomás Belmonte",
    "Malcom Braida",
    "William Alarcón",
    "Alan Velasco",
    "Kevin Zenón",
    "Milton Delgado",
    "Dante Gonzalez",
    "Tomás Aranda",
    "Santiago Zampieri",
    "Gonzalo Tomás Márquez",
    "Matias Calegari",
    "Lautaro Mendieta",
    "Sebastián Villa",
    "Ángel Romero",
    "Adam Bareiro",
    "Miguel Merentiel",
    "Exequiel Zeballos",
    "Milton Gimenez",
    "Juan Payal",
    "Joaquín Ruíz",
    "Leonel Flores",
    "Joaquín Piñeyro",
    "Kevin Ferreira",
    "Gonzalo Gelini",
    "Rodrigo Bacidalupe",
    "Miguel Ventos"
  ],
  "Bologna": [
    "Lukasz Skorupski",
    "Massimo Pessina",
    "Lorenzo De Silvestri",
    "Jhon Lucumí",
    "Nicolo Casale",
    "Juan Miranda",
    "Torbjørn Heggem",
    "Emil Holm",
    "Nadir Zortea",
    "Martin Vitík",
    "Eivind Helland",
    "Remo Freuler",
    "Lewis Ferguson",
    "Nikola Moro",
    "Tommaso Pobega",
    "Oussama El Azzouzi",
    "Jon Rowe",
    "Federico Bernardeschi",
    "Riccardo Orsolini",
    "Jesper Karlsson",
    "Jens Odgaard",
    "Thijs Dallinga",
    "Nicolò Cambiaghi",
    "Antonio Raimondo",
    "Benjamín Domínguez"
  ],
  "Bolton Wanderers": [
    "Jack Bonham",
    "Luke Hutchinson",
    "Nathan Broome",
    "David Harrington",
    "Cyrus Christie",
    "Ben Davies",
    "Akin Famewo",
    "Gaizka Larrazabal",
    "Eoin Toal",
    "Max Conway",
    "Christian Forino Joseph",
    "David Watson",
    "Josh Sheehan",
    "Ethan Erhahon",
    "Joel Randall",
    "Xavier Simons",
    "Luca Stephenson",
    "Ruben Rodrigues",
    "Sam Dalby",
    "John Mcatee",
    "Thierry Gale",
    "Kyliane Dong",
    "Charlie Warren"
  ],
  "Borussia Dortmund": [
    "Patrick Drewes",
    "Alexander Meyer",
    "Gregor Kobel",
    "Silas Ostrzinski",
    "Ramy Bensebaini",
    "Waldemar Anton",
    "Julian Ryerson",
    "Nico Schlotterbeck",
    "Daniel Svensson",
    "Kouakou Gadou",
    "Almugera Kabar",
    "Filippo Mané",
    "Kauã Prates",
    "Luca Reggiani",
    "Emre Can",
    "Marcel Sabitzer",
    "Felix Nmecha",
    "Carney Chukwuemeka",
    "Jobe Bellingham",
    "Konstantinos Karetsas",
    "Justin Lerma",
    "Mussa Kaba",
    "Serhou Guirassy",
    "Maximilian Beier",
    "Fábio Silva",
    "Mathis Albert",
    "Samuele Inácio"
  ],
  "Borussia Mönchengladbach": [
    "Tobias Sippel",
    "Daniel Batz",
    "Moritz Nicolas",
    "Jan Olschowsky",
    "Kevin Diks",
    "Nico Elvedi",
    "Joe Scally",
    "Yukhym Konoplia",
    "Fabio Chiarodia",
    "David Herold",
    "Lukas Ullrich",
    "Jan Leszczynski",
    "Kevin Stöger",
    "Franck Honorat",
    "Florian Neuhaus",
    "Robin Hack",
    "Philipp Sander",
    "Nathan N'Goumou",
    "Jens Castrop",
    "Hugo Bolin",
    "Zento Uno",
    "Enzo Leopold",
    "Wael Mohya",
    "Tim Kleindienst",
    "Isac Lidberg",
    "Shuto Machino",
    "Tomas Cvancara"
  ],
  "Boston River": [
    "Juan Ignacio González",
    "Bruno Antúnez",
    "Juan Acosta",
    "Martin González",
    "Marco Mancebo",
    "Jairo O'Neil",
    "Facundo Saravia",
    "Mateo Rivero",
    "Fredy Martínez",
    "Agustín Aguirre",
    "Ignacio Fernandez",
    "Gastón Ramírez",
    "Rodrigo Saravia",
    "Andy López",
    "Agustín Amado",
    "Facundo Muñoa",
    "Marco Oroná",
    "Federico Dafonte",
    "Marcelo Hornos",
    "Lautaro Vázquez",
    "Felipe Avenatti",
    "Franco Pérez",
    "Yair González",
    "Leandro Suhr",
    "Nicolás Siri",
    "Alexander González",
    "Francisco Bonfiglio",
    "Agustín Fernández"
  ],
  "Botafogo": [
    "Gabriel Batista",
    "Warleson",
    "Cristian Loor",
    "Cleber Lucas Chieppe Chagas",
    "Fernando Marçal",
    "Alex Telles",
    "Kaio",
    "Nahuel Ferraresi",
    "Paulo Victor",
    "Vitinho",
    "Lucas Monzón",
    "Mateo Ponte",
    "Jhoan Hernández",
    "Ythallo",
    "Caio Roque",
    "Anthony",
    "Kadu",
    "Marcos Vinagre",
    "Riquelme Felipe",
    "Gabriel Pereira Justino",
    "Gabriel Da Silva Abdias",
    "Kauã Serafim",
    "Herick Garcia Da Silva Neves",
    "Santiago Rodríguez",
    "Allan",
    "Edenilson",
    "Domingos",
    "Cristian Medina",
    "Danilo Santos",
    "Bernardo Valim",
    "Jordan Barrera",
    "Álvaro Montoro",
    "Wallace Davi",
    "Victor Hugo",
    "Cauã Zappelini",
    "Caio Valle",
    "Kauan Toledo",
    "Arthur Novaes",
    "Miguel Caldas",
    "Victor Hugo Gonçalves Dos Santos",
    "Arthur Cabral",
    "Júnior Santos",
    "Danilo",
    "Matheus Martins",
    "José Kadir",
    "Felipe Januário",
    "Arthur Izaque",
    "Matheusinho",
    "Lucas Emanuel Jales Do Nascimento"
  ],
  "Botafogo-SP": [
    "Jordan",
    "Victor Souza",
    "Brenno Faro Klippel",
    "Adriano Vasconcelos Da Silva Júnio",
    "Wallace",
    "Jonathan Lemos",
    "Patrick Brey",
    "Felipe Vieira",
    "Ericson",
    "Gabriel Inocencio",
    "Carlão",
    "Darlan",
    "Vilar",
    "Guilherme Mariano",
    "Hebert Willian Badaró Oliveira",
    "Pedro Henrique Souza Do Nascimento",
    "Henrique Lôvo Teles",
    "Leandro Maciel",
    "Matheus Sales",
    "Rafael Gava",
    "Everton Morelli",
    "Marco Antônio",
    "Erik Rebello De Castro",
    "Yuri",
    "Thiago Moraes",
    "Kelvin",
    "Hygor",
    "Guilherme Queiroz",
    "Arthur Caike",
    "Jefferson Nem",
    "Wesley Pinheiro",
    "Hugo",
    "Thalles",
    "Márcio Maranhão"
  ],
  "Boulogne": [
    "Xavier Lenogue",
    "Blondy Nna Noukeu",
    "Azamat Uriev",
    "Demba Thiam",
    "Julien Boyer",
    "Adrien Pinot",
    "Sonny Duflos",
    "Aurélien Platret",
    "Jonathan Kapenga",
    "Louis Siliadin",
    "Mohamed Soumah",
    "Ibrahim Kone",
    "Jonas Martin",
    "Zoran Moco",
    "Joffrey Bultel",
    "Sohan Paillard",
    "Nolan Binet",
    "Tom Dupont",
    "Noah Fatar",
    "Martin Lecolier",
    "Christian Kitenge",
    "Cheikh Ibrahim Dia"
  ],
  "Bournemouth": [
    "Fraser Forster",
    "William Dennis",
    "Djordje Petrovic",
    "Adam Smith",
    "James Hill",
    "Julián Araujo",
    "Bafodé Diakité",
    "Adrien Truffert",
    "Matai Akinmboni",
    "Julio Soler",
    "Veljko Milosavljevic",
    "David Brooks",
    "Ryan Christie",
    "Tyler Adams",
    "Lewis Cook",
    "Marcus Tavernier",
    "Alex Scott",
    "Alex Tóth",
    "Ben Winterburn",
    "Evanilson",
    "Enes Ünal",
    "Justin Kluivert",
    "Amine Adli",
    "Ben Gannon-Doak",
    "Álvaro Rodríguez",
    "Rayan",
    "Junior Kroupi",
    "Remy Rees-Dottin"
  ],
  "Bragantino": [
    "Tiago Volpi",
    "Cleiton",
    "Fabrício",
    "Fernando Costa",
    "Gustavo Reis",
    "Pedro Henrique",
    "Juninho Capixaba",
    "Agustín Sant'Anna",
    "Alix Vinicius",
    "Eduardo Santos",
    "Guzmán Rodríguez",
    "Vanderlan",
    "José Hurtado",
    "Gustavo Marques",
    "Weimar Vivas",
    "Caue Nascimento Santos",
    "Ryan Augusto",
    "Edgar González",
    "Breno de Moraes",
    "Gabriel",
    "Matheus Fernandes",
    "Lucas Barbosa",
    "Ramires",
    "Ignacio Laquintana",
    "Bruno Conceicão",
    "João Neto",
    "Fabinho",
    "Ignacio Sosa",
    "Rodriguinho",
    "Gustavinho",
    "Marcelinho Braz",
    "Rafael Lima",
    "Gabriel Lopes",
    "Marquinhos",
    "Davi Gomes",
    "Yuri",
    "Luis Gustavo",
    "Chrystian Delfino",
    "Vini Krygsman",
    "Eduardo Sasha",
    "Fernando",
    "Isidro Pitta",
    "Bruno Gonçalves",
    "Henry Mosquera",
    "José Herrera",
    "Yuri Leles",
    "Filipe",
    "Vinicinho",
    "Jhuan Nunes"
  ],
  "Brasil": [
    "Ederson",
    "Alisson Becker",
    "Weverton",
    "Alex Sandro",
    "Léo Pereira",
    "Marquinhos",
    "Danilo",
    "Douglas Santos",
    "Gabriel Magalhães",
    "Bremer",
    "Roger Ibañez",
    "Casemiro",
    "Fabinho",
    "Bruno Guimarães",
    "Lucas Paquetá",
    "Éderson",
    "Danilo Santos",
    "Luiz Henrique",
    "Neymar",
    "Raphinha",
    "Vinícius Júnior",
    "Matheus Cunha",
    "Gabriel Martinelli",
    "Igor Thiago",
    "Endrick",
    "Rayan"
  ],
  "Brentford": [
    "Ellery Balcombe",
    "Caoimhín Kelleher",
    "Hákon Valdimarsson",
    "Julian Eyestone",
    "Kristoffer Ajer",
    "Rico Henry",
    "Ethan Pinnock",
    "Sepp van den Berg",
    "Nathan Collins",
    "Aaron Hickey",
    "Michael Kayode",
    "Joshua Stephenson",
    "Ollie Shield",
    "Vitaly Janelt",
    "Mathias Jensen",
    "Fábio Carvalho",
    "Josh Dasilva",
    "Mikkel Damsgaard",
    "Kevin Schade",
    "Antoni Milambo",
    "Yehor Yarmoliuk",
    "Yunus Konak",
    "Luka Bentt",
    "Keane Lewis-Potter",
    "Igor Thiago",
    "Dango Ouattara",
    "Kaye Furo"
  ],
  "Brest": [
    "Grégoire Coudert",
    "Noah Jauny",
    "Noé Poillion",
    "Kenny Lala",
    "Brendan Chardonnet",
    "Bradley Locko",
    "Luc Zogbe",
    "Raphaël Le Guen",
    "Justin Bourgault",
    "Lucas Tousart",
    "Romain Del Castillo",
    "Hugo Magnetti",
    "Joris Chotard",
    "Axel Camblan",
    "Kamory Doumbia",
    "Joseph Nonge",
    "Hamidou Makalou",
    "Ludovic Ajorque",
    "Mama Baldé",
    "Pathé Mboup",
    "Ibrahim Kanté"
  ],
  "Brighton and Hove Albion": [
    "Jason Steele",
    "Tom McGill",
    "Bart Verbruggen",
    "Lewis Dunk",
    "Olivier Boscagli",
    "Igor Julio",
    "Ferdi Kadioglu",
    "Maxim De Cuyper",
    "Pascal Gross",
    "Diego Gómez",
    "Matt O'Riley",
    "Kaoru Mitoma",
    "Mats Wieffer",
    "Yasin Ayari",
    "Jack Hinshelwood",
    "Carlos Baleba",
    "Georginio Rutter",
    "Yankuba Minteh",
    "Stefanos Tzimas",
    "Charalambos Kostoulas"
  ],
  "Bristol City": [
    "Lewis Thomas",
    "Bradley Collins",
    "Sam Tickle",
    "Robert Atkinson",
    "Robert Dickie",
    "Cameron Pring",
    "George Tanner",
    "Noah Eile",
    "Luke McNally",
    "Sebastian Naylor",
    "Lisav Eissat",
    "Marley Thelwell",
    "Jason Knight",
    "Joe Williams",
    "Jed Wallace",
    "Scott Twine",
    "Max Bird",
    "Adam Randell",
    "Tomi Horvat",
    "Gibson Yah",
    "Elijah Morrison",
    "Daniel Ezendu",
    "Emil Riis Jakobsen",
    "Lorent Tolaj",
    "Sam Greenwood",
    "Sam Bell",
    "Yu Hirakawa"
  ],
  "Burgos": [
    "Ander Cantero",
    "Oier Luengo",
    "Gregorio Sierra",
    "Sergio González",
    "Brais Martínez",
    "Álex Lizancos",
    "Pablo Galdames",
    "Curro",
    "Kevin Appin",
    "Fermín García",
    "José Gragera",
    "Saúl del Cerro",
    "David González",
    "Marcelo Expósito",
    "Mario Cantero",
    "Victor Mollejo",
    "Mateo Mejia"
  ],
  "Burnley": [
    "Max Weiß",
    "Connor Edwards",
    "Kyle Walker",
    "Connor Roberts",
    "Axel Tuanzebe",
    "Joe Worrall",
    "Jordan Beyer",
    "Lucas Pires",
    "Hjalmar Ekdal",
    "Bashir Humphreys",
    "Josh Laurent",
    "Josh Cullen",
    "Hannibal Mejbri",
    "Ashley Barnes",
    "Marcus Edwards",
    "Jacob Bruun Larsen",
    "Zian Flemming",
    "Lyle Foster",
    "Mike Trésor",
    "Armando Broja",
    "Enock Agyei",
    "Zeki Amdouni"
  ],
  "Cádiz": [
    "David Gil",
    "Victor Aznar",
    "Iker Ortega",
    "Bojan Kovacevic",
    "Juan Díaz",
    "Sergio Arribas",
    "Manuel Rivera Domínguez",
    "Roberto Rosado Márquez",
    "Suso",
    "Moussa Diakité",
    "Javi Ontiveros",
    "Rominigue Kouamé",
    "Joaquín Felipe González Rodríguez",
    "Iuri Tabatadze",
    "Jerónimo Domina",
    "José Antonio De La Rosa",
    "Antonio Cordero",
    "Borja Vázquez",
    "García Pascual",
    "Marcos Denia",
    "Ismael Álvarez Martín",
    "Efe Ugiagbe"
  ],
  "Cagliari": [
    "Elia Caprile",
    "Alen Sherri",
    "Yerry Mina",
    "Gabriele Zappa",
    "Adam Obert",
    "Zé Pedro",
    "Juan Rodríguez",
    "Othniël Raterink",
    "Riyad Idrissi",
    "Matteo Prati",
    "Alessandro Deiola",
    "Michel Adopo",
    "Nicolò Cavuoti",
    "Joseph Liteta",
    "Ivan Sulev",
    "Mattia Felici",
    "Sebastiano Esposito",
    "Gennaro Borrelli",
    "Agustín Albarracín",
    "Yael Trepy",
    "Nicola Grandu",
    "Paul Mendy"
  ],
  "Cardiff City": [
    "Nathan Trott",
    "Matthew Turner",
    "Harry Tyrer",
    "Calum Chambers",
    "Perry Ng",
    "Gabriel Osho",
    "William Fish",
    "Joel Bagan",
    "Dylan Lawlor",
    "Ronan Kpakio",
    "Chris Willock",
    "David Turnbull",
    "Alex Robertson",
    "Rubin Colwill",
    "Eli King",
    "Joel Colwill",
    "Dakarai Mafico",
    "Callum Robinson",
    "Ollie Tanner",
    "Isaak Davies",
    "Yousef Salech",
    "Cian Ashford",
    "Tanatswa Nyakuhwa"
  ],
  "Carrarese": [
    "Vincenzo Fiorillo",
    "Marco Bleve",
    "Stefano Mazzini",
    "Giovanni Garofani",
    "Bartosz Salamon",
    "Marco Imperiale",
    "Fabio Ruggeri",
    "Filippo Oliana",
    "Devid Eugene Bouah",
    "Niccolò Belloni",
    "Nicholas Schiavi",
    "Filippo Melegoni",
    "Simone Zanon",
    "Gabriele Parlanti",
    "Antonio Troise",
    "Samuele Liberali",
    "Mattia Finotto",
    "Fabio Abiuso"
  ],
  "Castellón": [
    "Romain Matthys",
    "Sergi Torner",
    "Alberto",
    "Fabrizio Brignani",
    "Jeremy Mellot",
    "Agustín Sienra",
    "Martín Conde",
    "Santi Borikó",
    "Lucas Alcázar",
    "José Albert",
    "Michal Willmann",
    "Awer Mabil",
    "Diego Hernández Barriuso",
    "Israel Suero",
    "Marc-Oliver Doué",
    "Raúl Sánchez",
    "Adam Jakobsen",
    "Douglas Aurélio",
    "Varo",
    "Pablo Santiago",
    "Ousmane Camara"
  ],
  "Catanzaro": [
    "Mirko Pigliacelli",
    "Christian Marietta",
    "Edoardo Borrelli",
    "Lorenzo Madia",
    "Matias Antonini Lui",
    "Matteo Martino",
    "Gonçalo Esteves",
    "Mario Paura",
    "Costantino Favasuli",
    "Ruggero Frosinini",
    "Ervin Bashi",
    "Bruno Verrengia",
    "Carlo Rombola",
    "Jacopo Petriccione",
    "Marco D'Alessandro",
    "Pietro Iemmello",
    "N'Dri Koffi",
    "Filippo Pittarello",
    "Gabriele Alesi",
    "Kevin Gjoka"
  ],
  "CD Sabadell": [
    "Diego Fuoli",
    "Jose Ortega",
    "Carlos Alemán",
    "Juan Carlos Lázaro Cervera",
    "Gerard Fornés",
    "Arthur Bonaldo",
    "Quadri Liameed",
    "Eneko Aguilar",
    "Urri",
    "Javi López",
    "Miguel Ramírez",
    "Agustín Coscia",
    "Rodrigo Escudero",
    "Ton Ripoll",
    "Joel Priego",
    "Xavi Moreno"
  ],
  "Ceará": [
    "Richard",
    "Matheus Nogueira",
    "Jorge Meurer",
    "Gustavo Martins",
    "Rafael Ramos",
    "Luiz Otavio",
    "Sanchez",
    "Luiz Otávio",
    "Éder",
    "Savio",
    "Bryan",
    "Thalisson Gabriel",
    "Júlio César",
    "Stanley Boateng",
    "Vinicius Uchella",
    "Pedro Gilmar",
    "Aloísio",
    "Lucas Mugni",
    "Vinicius",
    "Richardson",
    "Giovanni Confreste",
    "Matheus Andrade",
    "Gustavo Prado",
    "Caio",
    "Gabriel",
    "Melk",
    "João Gabriel",
    "Renzo López",
    "Juan Alano",
    "Wendel",
    "Nicolás Ferreira",
    "Lucca",
    "Gabriel Amaral",
    "Giulio",
    "Enzo",
    "Kauã"
  ],
  "Celta Fortuna": [
    "Coke Carrillo",
    "Caio Albado Barone",
    "Marcos González",
    "Joel Lopez Salguero",
    "Jan Oliveras",
    "Yoel Lago",
    "Seyni Ndiaye",
    "Pablo Meixús",
    "Anxo Rodríguez",
    "Frank Germain Jonathan Miller",
    "Pablo Gavián Alonso",
    "Enrique Ribes",
    "Hugo Cuenca",
    "Adrià Capdevila",
    "Andrés Antañón",
    "Hugo Gonzalez",
    "Alvaro Marin",
    "Ángel Arcos",
    "Bernard Sarppong Somuah"
  ],
  "Celta Vigo": [
    "Andrei Radu",
    "Iván Villar",
    "Marcos González",
    "Marcos Alonso",
    "Carl Starfelt",
    "Sergio Carreira",
    "Carlos Domínguez",
    "Javi Rueda",
    "Álvaro Núñez",
    "Javi Rodríguez",
    "Yoel Lago",
    "Manuel Fernández",
    "Pablo Meixús",
    "Matías Vecino",
    "Hugo Álvarez",
    "Aleix Febas",
    "Ilaix Moriba",
    "Williot Swedberg",
    "Miguel Román",
    "Andrés Antañón",
    "Hugo Burcio",
    "Iago Aspas",
    "Pablo Durán",
    "Borja Iglesias",
    "Ferran Jutglà",
    "Jones El-Abdellaoui",
    "Óscar Marcos"
  ],
  "Central Córdoba de Santiago del Estero": [
    "Alan Aguerre",
    "Javier Vallejos",
    "Máximo Álvarez",
    "Felipe Aguilar",
    "Santiago Moyano",
    "Alejandro Maciel",
    "Dario Cáceres",
    "Leonardo Marchi",
    "Facundo Mansilla",
    "Fernando Martínez",
    "Juan Pablo Pignani",
    "José Goméz",
    "Lucas Bernabéu",
    "Yuri Casermeiro",
    "Agustín Romero",
    "Matías Vera",
    "Fernando Juárez",
    "Lucas González",
    "Marco Iacobellis",
    "Thiago Cravero",
    "Juan Cardozo",
    "Federico Rodriguez",
    "Michael Santos",
    "Leonardo Sequeira",
    "Horacio Tijanovich",
    "Diego Barrera",
    "Lucas Varaldo",
    "Ezequiel Naya",
    "Joaquín Flores",
    "Bautista Gerez",
    "Alan Laprida",
    "Martín Francisco Cuitiño"
  ],
  "Central Español": [
    "Rodolfo",
    "Emiliano Márquez Fernández",
    "Alan Benítez Alonso",
    "Matías González",
    "Nacho Rodríguez",
    "Alejandro Villoldo",
    "César",
    "Logan Francisco Ponce Barboza",
    "Luciano Fernández",
    "Mateo Urrutia",
    "Juan Ignacio Dupont Vaz",
    "Mateo Cantera Marsiglia",
    "Ernesto Aramburu Molina",
    "Lautaro Gandulfo Gómez",
    "Marcos Montiel",
    "Guill Gandolfo",
    "Lucas Pino",
    "Isaac Méndez Bidegaray",
    "Franco Martín Muñoz Rodríguez",
    "Máximo Alonso",
    "Jonathan Dellarossa",
    "Fernando Camarda",
    "Exequiel Mereles",
    "Santiago Sequeira Leguina",
    "Facundo Yocco Dilazaro",
    "Mariano Fernando Aguilera",
    "Facundo Nicolás Sosa Hoyo",
    "Raúl Andrés Tarragona Lemos"
  ],
  "Central Norte": [
    "Joaquin Hass",
    "Enzo Vázquez",
    "Pablo Rosales",
    "Arián Pucheta",
    "Leonardo Felissia",
    "Joaquín Vaquero",
    "Elías Calderón",
    "Ramiro Enríquez",
    "Matías Villareal",
    "Gianluca Mancuso",
    "Maximiliano Alvez",
    "Agustín Lamosa",
    "Matías Moravec",
    "Pedro Sanz",
    "Joaquin Mateo",
    "Franco Vedoya",
    "Francisco Borda"
  ],
  "Cerrito": [
    "Francisco Casanova",
    "Esteban Giraldo",
    "Luis Barbat",
    "Franko Ramos",
    "Emanuel Dall'Aglio",
    "Roberto Hernández",
    "Ezequiel Silveira",
    "Matías Soto",
    "Gabriel Ifrán",
    "Jonathan Ferrari",
    "Cristian González",
    "Santiago Pereira",
    "Luis Pereira",
    "Mateo Vista",
    "Santiago Ruiz",
    "Tiago Simoni",
    "Rodrigo Viera",
    "Andrés Schetino",
    "Facundo Barreto",
    "Franco Casuriaga",
    "Lucas Blanco",
    "Mateo Ayres",
    "Washington Silva",
    "Román Ugarriza",
    "Andrés Silveira",
    "Jonathan Isasmendi",
    "Owen Falconis",
    "Ignacio Yepez",
    "Luciano Batista",
    "Luis Machado",
    "Diego Rolán",
    "Simón Meza",
    "Anthony Segovia",
    "Joaquín Avilés"
  ],
  "Cerro": [
    "Yonatan Irrazabal",
    "Darío Denis",
    "Diego Capdevila",
    "Damián Suárez",
    "Iván Valenzuela",
    "Gianni Rodríguez",
    "Nahuel Arena",
    "Facundo Butti",
    "Juan Cruz Guasone",
    "Francisco Bregante",
    "Mateo Argüello",
    "Ariel Lima",
    "Martín Farías Palavecino",
    "Facundo Iraola Jaureguiverry",
    "Agustín Miranda",
    "Brahian Alemán",
    "Leonardo Pais",
    "Emiliano Sosa",
    "Jairo Amaro",
    "Rodrigo Mederos",
    "Alejo Macelli",
    "Rodolfo Sena",
    "Brian Agustín Quinteros Curbelo",
    "Jeison Iván Cubas Tarrillo",
    "Santiago Paiva",
    "Cristian Barros",
    "Diego Soria",
    "Pablo Nongoy",
    "Augusto Cambón",
    "Tiago Rijo",
    "Jorge Severo",
    "Axel Hernán Méndez Aguilera",
    "Alan Guzmán Zamurio Pereyra",
    "Bruno Daniel Morales Rodríguez"
  ],
  "Cerro Largo": [
    "Pedro González",
    "Lukas Maximiliano González Jackson",
    "Lucas Correa",
    "Santiago Franca",
    "Nicolás Ramos",
    "Julian Pou",
    "Axel Prado",
    "Mateo Monserrat",
    "Facundo Manuel Álvez Videla",
    "Jhonatan Alexis Piegas Núñez",
    "Facundo Acosta Moreno",
    "Alexander Hernández",
    "Nicolás Bertocchi",
    "Sebastián Assis",
    "Mario García",
    "Ihojan Pérez",
    "Santiago Marcel",
    "Emiliano Jourdan",
    "Alfonso De Luca",
    "Axel Michele Pandiani Quaglia",
    "Ezequiel Cabral Palacio",
    "Gustavo Viera",
    "Borys Barone",
    "Bruno Hernández",
    "Elías De León",
    "Andrés Córdoba",
    "Diego Daguerre Irazabal"
  ],
  "Cesena": [
    "Luca Ferretti",
    "Jonathan Klinsmann",
    "Alessandro Siano",
    "Simone Gianfanti",
    "Niccolò Fontana",
    "Massimiliano Mangraviti",
    "Gianluca Frabotta",
    "Andrea Ciofi",
    "Giovanni Zaro",
    "Matteo Piacentini",
    "Vittorio Magni",
    "Simone Abbondanza",
    "Mamadou Kebbeh",
    "Riccardo Domeniconi",
    "Michele Castagnetti",
    "Tommaso Arrigoni",
    "Dimitri Bisoli",
    "Matteo Francesconi",
    "Matteo Guidi",
    "Ibrahima Wade Papa",
    "Davide Zamagni",
    "Marco Olivieri",
    "Cristian Shpendi",
    "Filippo Galvagno",
    "Filippo Bertaccini"
  ],
  "Ceuta": [
    "Pedro López",
    "Guillermo",
    "Carlos Hernández",
    "Matos",
    "Redru",
    "Capa",
    "Yann Bodiger",
    "Anuar",
    "Marino Illescas",
    "Salvi",
    "Kuki Zalazar",
    "Kialy Kone"
  ],
  "CF Montréal": [
    "Sébastian Breza",
    "Thomas Gillier",
    "Emil Gazdov",
    "Samsy Keita",
    "Brayan Vera",
    "Luca Petrasso",
    "Bode Hidalgo",
    "Jalen Neal",
    "Brandan Craig",
    "Efraín Morales",
    "Dawid Bugaj",
    "Samuel Piette",
    "Matthew Longstaff",
    "Frankie Amaya",
    "Wikelman Carmona",
    "Dani Pereira",
    "Victor Loturi",
    "Noah Streit",
    "Ivan Losenko",
    "Hennadii Synchuk",
    "Josh-Duc Nteziryayo",
    "Fabian Herbers",
    "Prince Owusu",
    "Daniel Ríos",
    "Olger Escobar",
    "Owen Graham-Roache"
  ],
  "Chacarita Juniors": [
    "Enrique Bologna",
    "Federico Losas",
    "Nicolás Pantaleone",
    "Nicolás Chaves",
    "Milton Leyendeker",
    "Tomás Pérez Serra",
    "Francisco Facello",
    "Juan Cuevas",
    "Miguel Mellado",
    "Álvaro Cuello",
    "Mario Sanabria",
    "Maximiliano Meléndez",
    "Lucas Bustos",
    "Misael Jaime"
  ],
  "Chaco For Ever": [
    "Gastón Canuto",
    "Nicolás Andrés Caprio",
    "Eduardo Garcete",
    "David Valdez",
    "Lucas Pruzzo",
    "Jorge Zules",
    "Alan Luque",
    "Ricardo Garay",
    "Bahiano Garcia",
    "Mathías Silvera",
    "Lucas Mihovilcevich",
    "Gonzalo Melgarejo",
    "Franco Molina",
    "Juan Carrizo",
    "Germán Pacheco",
    "Brian Guerra",
    "Enzo Gaggi",
    "Andrés Lioi",
    "Brian Nievas",
    "Joaquín Jara",
    "Leandro Espejo",
    "Leandro Ojeda",
    "Santiago Valenzuela",
    "Santiago Villalba",
    "Tiago Chamorro",
    "Ezequiel Pacheco",
    "Leandro Fernandez",
    "Lisandro Alfonso",
    "Agustín Alonso",
    "Tomás Bolzicco",
    "Imanol Enriquez",
    "Juan Cruz Cerrudo",
    "Agustín Zabaleta",
    "Mateo Díaz Chaves"
  ],
  "Chapecoense": [
    "Rafael Santos",
    "Matheus",
    "Anderson Paixão",
    "Kainã",
    "Wellington",
    "Rafael Thyere",
    "Bruno Pacheco",
    "Victor Caetano",
    "Fernando",
    "João Paulo",
    "Everton",
    "Mancha",
    "Eduardo Doma",
    "Kauan",
    "Gustavo Talles",
    "Vinicius Eduardo De Almeida Gomes Da Silva",
    "Felipe",
    "Giovanni Augusto",
    "Bruno Matias",
    "Camilo",
    "Max",
    "Ênio",
    "Vinicius",
    "Rubens Tadeu Hartmann Ricoldi",
    "David",
    "Juan Ferreira Leite",
    "Marcinho",
    "Yannick Bolasie",
    "Kevin Ramírez",
    "Bruno",
    "Neto",
    "Maurício Garcez",
    "Franco Rossi",
    "Rafael Cavalheira",
    "Robert Santos",
    "Rodrigo Endrio Azevedo Tiago",
    "Kássio Da Silva De Jesus",
    "Túlio Eduardo Silva De Oliveira"
  ],
  "Charlotte FC": [
    "Tyler Miller",
    "Kristijan Kahlina",
    "Isaac Walker",
    "Tim Ream",
    "Nathan Byrne",
    "Harry Toffolo",
    "David Schnegg",
    "Henry Kessler",
    "Andrew Privett",
    "Mikah Thomas",
    "Jack Neeley",
    "Andrew Johnson",
    "Will Cleary",
    "Morrison Agyemang",
    "Ashley Westwood",
    "Luca de la Torre",
    "Brandt Bronico",
    "Pep Biel",
    "Djibril Diani",
    "Baye Coulibaly",
    "Aron John",
    "Allan Saint-Maximin",
    "Liel Abada",
    "Archie Goodwin",
    "Idan Toklomati",
    "Nathan Richmond",
    "Nimfasha Berchimas",
    "Tyger Smalls",
    "Rodolfo Aloko"
  ],
  "Charlton Athletic": [
    "Thomas Kaminski",
    "William Mannion",
    "Tiernan Brooks",
    "Lloyd Jones",
    "Amari'i Bell",
    "Reece Burke",
    "Dan McNamara",
    "Joshua Edwards",
    "Kayne Ramsay",
    "Ivan Mesik",
    "Billy Koumetio",
    "Collins Sichenje",
    "Alan Nwamba",
    "Nathaniel Chalobah",
    "Greg Docherty",
    "Joe Rankin-Costello",
    "Conor Coventry",
    "Sonny Carey",
    "Harvey Knibbs",
    "Ibrahim Fullah",
    "Karlan Grant",
    "Matthew Godden",
    "Charlie Kelman",
    "Millenic Alli",
    "Tyreece Campbell",
    "Miles Leaburn"
  ],
  "Chelsea": [
    "Robert Sánchez",
    "Gaga Slonina",
    "Teddy Sharman-Lowe",
    "Mike Penders",
    "Ted Curd",
    "Reece James",
    "Tosin Adarabioyo",
    "Wesley Fofana",
    "Benoît Badiashile",
    "Levi Colwill",
    "Malo Gusto",
    "Jorrel Hato",
    "Mamadou Sarr",
    "Marco Palestra",
    "Aaron Anselmino",
    "Josh Acheampong",
    "Landon Emenalo",
    "Calvin Diakite",
    "Olutayo Subuloye",
    "Morgan Rogers",
    "Enzo Fernández",
    "Moisés Caicedo",
    "Cole Palmer",
    "Romeo Lavia",
    "Dário Essugo",
    "Omari Kellyman",
    "Mahdi Nicoll-Jazuli",
    "Reggie Watson",
    "Reggie Walsh",
    "Pedro Neto",
    "João Pedro",
    "Liam Delap",
    "Nicolas Jackson",
    "Jamie Gittens",
    "Marc Guiu",
    "Estêvão",
    "Ryan Kavuma-Mcqueen"
  ],
  "Chicago Fire": [
    "Josh Cohen",
    "Chris Brady",
    "Jeff Gal",
    "Mauricio Pineda",
    "Jack Elliott",
    "Joel Waterman",
    "Andrew Gutman",
    "Samual Rogers",
    "Jonathan Dean",
    "Viktor Radojevic",
    "Christopher Cupps",
    "Jack Sandmeyer",
    "Leonardo Barroso",
    "Mbekezeli Mbokazi",
    "Anton Saletros",
    "Robin Lod",
    "Maren Haile-Selassie",
    "André Franco",
    "Sergio Oregel",
    "D'Avilla Dje Tah",
    "David Poreba",
    "Robert Turdean",
    "Robert Lewandowski",
    "Philip Zinckernagel",
    "Jonathan Bamba",
    "Chris Mueller",
    "Jason Shokalook",
    "Puso Dithejane",
    "Dylan Borso",
    "Dean Boltz"
  ],
  "Ciudad de Bolívar": [
    "Agustín Rufinetti",
    "Enzo Álvarez",
    "Jorge Ruiz",
    "Jonathan Chacón",
    "Nahuel Yeri",
    "Elías Martínez",
    "Ezequiel Navarro",
    "Axel Carrión",
    "Facundo Mucignat",
    "Federico Peralta",
    "Joel Ledesma",
    "Carlos Cuello",
    "Gonzalo Valderrama",
    "Arnaldo González",
    "Álex Díaz",
    "Elias Romero",
    "Tobias Fernandez",
    "Brian Quintana",
    "Thiago Rodríguez",
    "Agustín Paredes",
    "Tomás Alegre",
    "Marcos Sotelo",
    "Lautaro Villegas",
    "Maximiliano Gutiérrez",
    "Guillermo Sánchez",
    "Camilo García",
    "Jonathan Maciel",
    "Braian Duarte",
    "Khalil Caraballo",
    "Tomás Rambert",
    "Agustín Díaz",
    "Facundo Beretta",
    "José Abentín",
    "Valentin Lachalde"
  ],
  "Clermont Foot": [
    "Théo Guivarch",
    "Massamba Ndiaye",
    "Joan Raynaud",
    "Ibrahim Coulibaly",
    "Kenji-Van Boto",
    "Yoann Salmier",
    "Vital N'Simba",
    "Andy Pelmard",
    "Matys Donavin",
    "Ivan M'Bahia",
    "Ethan Kabeya",
    "Ilyes Hamdia",
    "Adrien Hunou",
    "Yuliwes Bellache",
    "Stan Berkani",
    "Julien Astic",
    "Mohamed-Amine Bouchenna",
    "Abdellah Baallal",
    "Allan Ackra",
    "El Hadj Koné",
    "Marouane Admar",
    "Noam Strotz",
    "Maidine Douane",
    "Ousmane Diop",
    "Jean Nyindong Tsamouna",
    "Enzo Cantero",
    "Arthur Saintorens"
  ],
  "Colegiales": [
    "Emilio Di Fulvio",
    "Augusto Alcorcel",
    "Gustavo Calderari",
    "Emanuel Insúa",
    "Ezequiel Aguirre",
    "Leandro Martínez",
    "Franco Malagueño",
    "Facundo Rivero",
    "Franco Hanashiro",
    "Leo Ortiz",
    "Gaston Cortes",
    "Fernando Miranda",
    "Enzo Trinidad",
    "Mateo Ramirez",
    "Federico Marín",
    "Franco Zicarelli",
    "Tomas Almada",
    "Elías Ocampo",
    "Facundo Montiel",
    "Ignacio Buenrostro",
    "Tomás Buenrostro",
    "Alejo Alan Acevedo",
    "Leonardo Gonzalez",
    "Mauro Albertengo",
    "Mateo Jose Mamani",
    "Nicolás Toloza",
    "Lucio Castillo",
    "Rodrigo Monserrat",
    "Tomás Perri",
    "Lucas Juárez",
    "Lucas Ricciotti"
  ],
  "Colón": [
    "Matías Budiño",
    "Tomás Giménez",
    "Pier Barrios",
    "Nicolás Thaller",
    "Facundo Castet",
    "Emanuel Beltran",
    "Conrado Ibarra",
    "Mauro Peinipil",
    "Sebastián Olmedo",
    "Matías Muñoz",
    "Ignacio Antonio",
    "Agustín Toledo",
    "Leandro Allende",
    "Mateo Cardozo",
    "Facundo Castro",
    "Lucas Cano",
    "Alan Bonansea",
    "Julián Marcioni",
    "Dario Sarmiento",
    "Ignacio Lagos"
  ],
  "Colón FC": [
    "Agustín Olavarría",
    "Martín Coirolo",
    "Mauricio Benítez",
    "Agustín de Armas",
    "Andrés Olivera",
    "Faustino Fernández",
    "Jairo Guerra",
    "Faustino Choca",
    "Agustín Chopitea",
    "Maximiliano Ohaco",
    "Diego Núñez",
    "Tomás Lerman",
    "Jim Morrison Varela",
    "Emiliano Vidart",
    "Bryan Paz",
    "Lisandro González",
    "Ronald Álvarez",
    "Kevin Rivero",
    "Leandro Méndez",
    "Juan Rivero",
    "Lucas Espinosa",
    "Ignacio Charruti",
    "Juan Ignacio D'Angelo",
    "Juan Palacio",
    "Ramiro Quintana",
    "Bruno Airaldi",
    "Agustín Rodríguez",
    "Facundo Barreto",
    "Lucas Suárez",
    "Bautista Cabrera"
  ],
  "Colorado Rapids": [
    "Zack Steffen",
    "Nico Hansen",
    "Adam Beaudry",
    "Zackory Campagnolo",
    "Rob Holding",
    "Keegan Rosenberry",
    "Reggie Cannon",
    "Miguel Navarro",
    "Kosi Thompson",
    "Noah Cobb",
    "Loic Williams",
    "Jackson Travis",
    "Lucas Herrington",
    "Jabari De Coteau",
    "Joshua Atencio",
    "Ted Ku-Dipietro",
    "Hamzat Ojediran",
    "Paxten Aaronson",
    "Ali Fadal",
    "Wayne Frederick",
    "Nathan Tchoumba",
    "Alex Harris",
    "Rafael Navarro",
    "Darren Yapi",
    "Dante Sealy",
    "Bryce Jamison",
    "Georgi Minoungou",
    "Kimani Stewart-Baynes",
    "Sydney Wathuta",
    "Donavan Phillip",
    "Mamadou Billo Diop"
  ],
  "Columbus Crew": [
    "Evan Bush",
    "Nicholas Hagen",
    "Patrick Schulte",
    "Luke Pruter",
    "Stanislav Lapkes",
    "Rudy Camacho",
    "Steven Moreira",
    "Brooks Lennon",
    "Malte Amundsen",
    "Andrés Herrera",
    "Mohamed Farsi",
    "Owen Presthus",
    "Cesar Ruvalcaba",
    "Tristan Brown",
    "André Gomes",
    "Amar Sejdic",
    "Dániel Gazdag",
    "Dylan Chambost",
    "Sean Zawadzki",
    "Johann Chirinos",
    "Sékou Tidiany Bangoura",
    "Hugo Picard",
    "Taha Habroune",
    "Cole Mrowka",
    "Tarun Karumanchi",
    "Jamal Thiaré",
    "Wessam Abou Ali",
    "Chase Adams",
    "Kevin Gbamblé"
  ],
  "Como": [
    "Mauro Vigorito",
    "Jean Butez",
    "Noel Törnqvist",
    "Marc-Oliver Kempf",
    "Edoardo Goldaniga",
    "Álex Valle",
    "Stefan Posch",
    "Alberto Dossena",
    "Ignace van der Brempt",
    "Ivan Smolcic",
    "Jacobo Ramón",
    "Maxence Caqueret",
    "Lucas Da Cunha",
    "Máximo Perrone",
    "Martin Baturina",
    "Adrian Lahdo",
    "Andréa Leborgne",
    "Álvaro Morata",
    "Nicolas Kühn",
    "Anastasios Douvikas",
    "Ivan Azón",
    "Alessandro Gabrielloni",
    "Jayden Addai",
    "Nico Paz",
    "Assane Diao",
    "Jesús Rodriguez"
  ],
  "Córdoba": [
    "Iker Álvarez",
    "Guilherme Fernandes",
    "Rubén González",
    "Carlos Albarrán",
    "Álex Martín",
    "Franck Fomeyem",
    "Dani Tasende",
    "Juan Gutiérrez",
    "Egoitz Muñoz",
    "Jacobo Martí",
    "Víctor Sánchez",
    "Isma Ruiz",
    "Theo Zidane",
    "Damián",
    "Youssouf Diarra",
    "Eder García",
    "Adilson",
    "Cristian Carracedo",
    "Diego Bri",
    "Kevin Villodres",
    "Percan",
    "Ibai Sanz",
    "Enol Rodríguez",
    "Salim El Jebari",
    "Adnane Ghailan"
  ],
  "Corinthians": [
    "Hugo Souza",
    "Kauê Camargo",
    "Felipe Longo",
    "Matheus Corrêa",
    "Gustavo Milani",
    "Gustavo Henrique",
    "Gabriel Paulista",
    "André Ramalho",
    "Fabrizio Angileri",
    "Mateuzinho",
    "Matheus Bidu",
    "Hugo",
    "Pedro Milans",
    "João Pedro",
    "Guilherme Pellegrin Almeida",
    "Jacaré",
    "Yago Veloso",
    "Iago Machado",
    "Levi Dias",
    "João Vitor",
    "André Carrillo",
    "Jesse Lingard",
    "Alex Santana",
    "Matheus Pereira",
    "Allan",
    "Raniele",
    "Charles",
    "Rodrigo Garro",
    "Breno Bidon",
    "Luiz Gustavo",
    "Dieguinho",
    "André",
    "Guilherme Amorim",
    "Luiz Fabio",
    "Pedro Thomas",
    "Guilherme Caraguá",
    "Lucca Arcolini Caramico",
    "Léonardo Rodrigues Silva",
    "Zakaria Labyad",
    "Memphis Depay",
    "Vitinho",
    "Pedro Raúl",
    "Yuri Alberto",
    "Kaio",
    "Kayke Ferrari",
    "Gui Negão",
    "Luiz Fernando",
    "Nícollas",
    "Nicolas Araújo",
    "Christian Santos",
    "Kayque"
  ],
  "Coritiba": [
    "Gabriel Leite",
    "Keiller",
    "Pedro Rangel",
    "Benassi",
    "Pedro Luccas",
    "Maicon",
    "Rodrigo Moledo",
    "Tinga",
    "Bruno Melo",
    "Jacy Maranhão",
    "Felipe Jonatan",
    "Tiago",
    "João Pedro Chermont",
    "João Almeida",
    "Lucas Taverna",
    "Sebastián Gómez",
    "Josué Pesqueira",
    "Thiago Santos",
    "Fernando Sobral",
    "Gustavo",
    "Thiago Azaf",
    "Tissi",
    "Alejandro Ararat",
    "Paulo Roberto",
    "Keno",
    "Pedro Rocha",
    "Breno",
    "Rodrigo Rodrigues",
    "Brian Ocampo",
    "Fabinho",
    "Vini Paulista",
    "Joaquín Lavega",
    "Renato Marques",
    "Lucas Ronier",
    "Matheus Dias",
    "Enzo Vágner",
    "David Alves"
  ],
  "Coventry City": [
    "Ben Wilson",
    "Oliver Dovin",
    "Jake Bidwell",
    "Jay Da Silva",
    "Joel Latibeaudiere",
    "Luke Woolfenden",
    "Liam Kitching",
    "Milan van Ewijk",
    "Kaine Kesler Hayden",
    "Bobby Thomas",
    "Miguel Ángel Brau",
    "Matt Grimes",
    "Victor Torp",
    "Frank Onyeka",
    "Josh Eccles",
    "Jack Rudoni",
    "Tatsuhiro Sakamoto",
    "Kai Andrews",
    "Haji Wright",
    "Brandon Thomas-Asante",
    "Ephron Mason-Clark",
    "Ellis Simms",
    "Raphael Borges Rodrigues"
  ],
  "CRB": [
    "Matheus",
    "Vitor Caetano",
    "Fábio",
    "Bressan",
    "Hereda",
    "Leonardo de Campos",
    "Lucas Lovat",
    "Kevin",
    "Reverson",
    "Fábio Augusto Schirmann",
    "Henri Santos",
    "Lyncon",
    "Maycon",
    "Ruy Marcos Levino De Oliveira",
    "João Pedro Salvador Kruger Pin",
    "Luizao",
    "Pedro Castro",
    "Danielzinho",
    "Crystopher",
    "Geovane",
    "Patrick de Lucca",
    "Cauã Carvalho",
    "Eduardo Mecena",
    "Dadá",
    "Luiz Phellype",
    "Douglas Baggio",
    "Luis Vinicius Nunes Cavalcante",
    "Mikael",
    "Thiago Fernandes",
    "Guilherme Pato",
    "Joao Neto",
    "Guilherme Kauan Lucio Ferreira"
  ],
  "Cremonese": [
    "Adrián Malovec",
    "Matteo Bianchetti",
    "Sebastiano Luperto",
    "Giuseppe Pezzella",
    "Tommaso Barbieri",
    "Federico Baschirotto",
    "Francesco Folino",
    "Tommaso Vigilati",
    "Jari Vandeputte",
    "Morten Thorsby",
    "Alberto Grassi",
    "Michele Collocolo",
    "Simone Lottici Tessadri",
    "Milan Djuric",
    "Antonio Sanabria",
    "Federico Bonazzoli",
    "David Okereke",
    "Adrian Lickunas",
    "Nouroudine Faye"
  ],
  "Criciúma": [
    "Airton",
    "Alisson",
    "Kauã Moroso",
    "Lucas Soratto",
    "Pedro",
    "Luciano Castan",
    "César",
    "Rodrigo",
    "Bruno Alves",
    "Marcelo Hermes",
    "Marcinho",
    "Willean Lepu",
    "Léo Mana",
    "Ruan Rodrigues Carvalho",
    "Rómulo Otero",
    "Fellipe Mateus",
    "Jean",
    "Eduardo",
    "Ronald",
    "Sandry",
    "Hiago",
    "Fabricio",
    "Steven Nufour",
    "Gui Lobo",
    "Lucas Vinicius Bugs",
    "Thiaguinho",
    "Nicolás",
    "Diego",
    "Waguininho",
    "Romarinho",
    "Cauê",
    "Jhonata Robert",
    "João Carlos",
    "Carlos Eduardo",
    "Thales Lourenço Rodrigues"
  ],
  "Cruzeiro": [
    "Cássio",
    "Otávio Costa",
    "Marcelo",
    "Vitor Lamounier",
    "Fagner",
    "William",
    "Fabrício Bruno",
    "Gabriel Rojas",
    "João Marcelo",
    "Jonathan Jesus",
    "Nicolas Pontes",
    "Kauã Moraes Silva",
    "Vitor Hugo",
    "Gustavo Carvalho",
    "Kelvin Coutinho",
    "Lucas Romero",
    "Lucas Silva",
    "Gerson",
    "Matheus Henrique",
    "Neyser Villareal",
    "Rhuan Gabriel",
    "Alessandro",
    "Zé Lucas",
    "Felipe Morais",
    "Eduardo Pape",
    "André Balbino",
    "Lucas Villalba",
    "Wanderson",
    "Luciano Rodríguez",
    "Chico",
    "Bruno Rodrigues",
    "Luis Sinisterra",
    "Kaio Jorge",
    "Gabriel Pec",
    "Marquinhos",
    "Wesley Ribeiro",
    "Keny Arroyo",
    "João Costa",
    "Ruan Silva Fonseca",
    "Kaique Kenji",
    "Pietro Tavares",
    "Rayan Lelis",
    "Danilo Gimenes",
    "Pablo"
  ],
  "Crystal Palace": [
    "Walter Benítez",
    "Remi Matthews",
    "Dean Henderson",
    "Joseph Whitworth",
    "Daniel Muñoz",
    "Borna Sosa",
    "Chris Richards",
    "Óscar Mingueza",
    "Tyrick Mitchell",
    "Tayo Adaramola",
    "Jaydee Canvot",
    "Will Hughes",
    "Jefferson Lerma",
    "Daichi Kamada",
    "Justin Devenny",
    "Yéremy Pino",
    "Adam Wharton",
    "David Ozoh",
    "Romain Esse",
    "Ismaïla Sarr",
    "Jean-Philippe Mateta",
    "Jørgen Strand Larsen",
    "Eddie Nketiah",
    "Jesurun Rak-Sakyi"
  ],
  "Cuiabá": [
    "João Carlos",
    "Marcelo Carné",
    "Jean",
    "Alan Empereur",
    "Marlon Lopes",
    "Joao Basso",
    "Vitor Mendes",
    "Igor",
    "Eric",
    "Luisão",
    "João Victor",
    "Lorenzo",
    "Marcos Júnior",
    "Raul",
    "Otávio",
    "Wesley Dias",
    "Pepê",
    "Weverson",
    "Calebe",
    "Railan",
    "David Miguel De Souza Arcanjo",
    "Pedro Felipetto",
    "Jean Dias",
    "Rodrigo",
    "Fábio",
    "Pedro",
    "Eliel",
    "Kauan",
    "Vinicius Peixoto Trindade Da Silva",
    "Nathan Cruz",
    "Mansano"
  ],
  "Damac": [
    "Kewin",
    "Moataz Al-Baqaawi",
    "Naser Al Ghamdi",
    "Meshal Al Shahrani",
    "Abdulrahman Al-Obaid",
    "Abdelkader Bedrane",
    "Tariq Mohammed",
    "Jamal Harkass",
    "Hassan Rabea",
    "Sanousi Al Hawsawi",
    "Noor Al Rashidi",
    "Dhari Al Anazi",
    "Abdul Rahman Al Khaibari",
    "Valentin Vada",
    "Riyadh Sharahili",
    "Khaled Al Samiri",
    "Abdullah Al Qahtani",
    "Nawaf Al Saadi",
    "Ahmed Omar",
    "Amidou Traore",
    "Ahmed Namazi",
    "Yakou Meite",
    "Morlaye Sylla",
    "Jonathan Okita",
    "Nabil Alioui",
    "Yahya Naji",
    "David Kaiki",
    "Hazzaa Al Ghamdi",
    "Arielson",
    "Mohammad Alsalkhadi",
    "Jawad Alhassan",
    "Zaher Makkawi"
  ],
  "Danubio": [
    "Mauro Goicoechea",
    "Kevin Martínez",
    "Miguel González",
    "Emiliano Velázquez",
    "Mauro Brasil",
    "Martín Jourdan",
    "Tomás Cavanagh",
    "Facundo Balatti",
    "Mateo Rinaldi",
    "Douglas Damián García Ferreira Gómez",
    "Felipe Biagio Cabrera Novelli",
    "Santiago Sosa",
    "Leandro Sosa",
    "Sebastian Rodriguez",
    "Juan Millán",
    "Iván Rossi",
    "Joaquín Trasante",
    "Maicol Ferreira",
    "Axel Montaña",
    "Luis Femia",
    "Alexander Velázquez",
    "Emiliano Figueroa Goncalves",
    "Pablo Rodrigo Cardozo De Los Santos",
    "Leonardo Germán Otaño Pereyra",
    "Mateo Peralta",
    "Sebastián Fernández",
    "Hugo Silveira",
    "John",
    "Ivo Costantino",
    "Bautista Tomatis",
    "Bautista Pereira",
    "Diego Piriz",
    "Nicolas Azambuja",
    "Enzo Cabrera Mauri",
    "Benjamín Azambuja Vargas"
  ],
  "Darmstadt": [
    "Marcel Schuhen",
    "Alexander Brunst-Zöllner",
    "Benedikt Börner",
    "Matthias Bader",
    "Raoul Petretta",
    "Patric Pfeiffer",
    "Aleksandar Vukotic",
    "Christopher Lannert",
    "Florian Kleinhansl",
    "Meldin Dreskovic",
    "Matej Maglica",
    "Yannik Lührs",
    "Grayson Dettoni",
    "Max Pfister",
    "Carlo Sickinger",
    "Lance Duijvestijn",
    "Kai Klefisch",
    "Fabian Nürnberger",
    "Merveille Papela",
    "Noah Weißhaupt",
    "Hiroki Akiyama",
    "Lars Kehl",
    "Nicolas Verkooijen",
    "Milian Herbst",
    "Luca Marseiler",
    "Ibrahim El Kadiri",
    "Fynn-Luca Lakenmacher",
    "Lee Ho-Jae",
    "Yosuke Furukawa",
    "Manolo Merx"
  ],
  "DC United": [
    "Sean Johnson",
    "Alex Bono",
    "Grant Leveille",
    "Silvan Hefti",
    "Kye Rowles",
    "Sean Nealis",
    "Conner Antley",
    "Keisuke Kurokawa",
    "Matti Peltola",
    "Lucas Bartlett",
    "Nikola Markovic",
    "Andre Dozzell",
    "Brandon Servania",
    "Jared Stroud",
    "Caden Clark",
    "Hosei Kijima",
    "Jackson Hopkins",
    "Gavin Turner",
    "Kamil Efraím Castillo Reynoso",
    "Louis Munteanu",
    "Gabriel Segal",
    "João Peglow",
    "Tai Baribo",
    "Nathan Ordaz",
    "Jacob Murrell",
    "Oscar Avilez"
  ],
  "Defensa y Justicia": [
    "Lautaro Amade",
    "Matias Borgogno",
    "Damián Fernández",
    "Fernando Román",
    "Héctor Martínez",
    "Lucas Souto",
    "Esteban Lucero",
    "Nazareno Roselli",
    "Mateo López",
    "Valentín Loza",
    "Ezequiel Burdin Márquez",
    "Julián López",
    "Éver Banega",
    "César Pérez",
    "Domingo Blanco",
    "Máximo Rodríguez",
    "Santiago Toloza",
    "Aaron Molinas",
    "Ayrton Portillo",
    "Maximiliano Porcel",
    "Mateo Aguiar",
    "Máximo Jonás Cabrera",
    "Leandro Miguel Fernandez",
    "David Barbona",
    "Facundo Altamira",
    "Juan Gutiérrez",
    "Agustin Hausch",
    "Tomas Perez",
    "Alan Coria",
    "Ramiro Gagliardi",
    "Emiliano Cantero",
    "Thiago Lionel Martínez"
  ],
  "Defensor Sporting": [
    "Kevin Dawson",
    "Lucas Machado",
    "Bruno Simone",
    "Guillermo de los Santos",
    "Edgar Elizalde",
    "Valentín Rodríguez",
    "Daniel Martínez",
    "Geanfranco Rodríguez",
    "Axel Frugone",
    "Francisco Sorondo",
    "Mateo Caballero",
    "Facundo Castro",
    "Martin Rabuñal",
    "Lucas de los Santos",
    "Diego Abella",
    "Tomás Pozzo",
    "Nicolás Medina",
    "Juan Jorge",
    "Lucas Agazzi",
    "Erico Cuello",
    "Germán Barrios",
    "Nicolás Wunsch",
    "Xavier Biscayzacú",
    "Santino Bruschi",
    "Brian Montenegro",
    "José Neris",
    "Juan Goicochea",
    "Alan Torterolo",
    "Lautaro Navarro",
    "Diego Toma",
    "Juan Díaz",
    "Nicolás Scotti",
    "Emiliano Alonso Segura",
    "Álex Emanuel Perdomo Nebu"
  ],
  "Defensores de Belgrano": [
    "Alejandro Medina",
    "Alexis Nocetti",
    "Ian Pérez",
    "Nicolás Vaquer",
    "Diego Magallanes",
    "Patricio Moyano",
    "Diego Garcia",
    "Luis Jerez Silva",
    "Juan De Tomasso",
    "Leandro Ciccollni",
    "Sergio Sánchez",
    "Agustín Benítez",
    "Ignacio Gutiérrez",
    "Jonathan Dellarossa",
    "Brian Gomez",
    "Gonzalo Aquilino",
    "Francisco Tcherkaski"
  ],
  "Deportivo Alavés": [
    "Adrián Rodríguez",
    "Antonio Sivera",
    "Jesús Owono",
    "Ville Koski",
    "Jonny",
    "Nikola Maras",
    "Facundo Garcés",
    "Nahuel Tenaglia",
    "Ángel Pérez",
    "Youssef Lekhedim",
    "Pablo Ibáñez",
    "Denis Suárez",
    "Carles Aleñá",
    "Carlos Protesoni",
    "Ander Guevara",
    "Antonio Blanco",
    "Lander Pinillos",
    "Moussa Diarra",
    "Toni Martínez",
    "Mariano",
    "Lucas Boyé",
    "Abde Rebbach",
    "Aitor Mañas"
  ],
  "Deportivo de A Coruña": [
    "Álvaro Fernández",
    "Germán Parreño",
    "Leo Román",
    "Eric Puerto",
    "Ximo Navarro",
    "Miguel Loureiro",
    "Giacomo Quagliata",
    "Arnau Comas",
    "Adrià Altimira",
    "Lucas Noubi",
    "Dani Barcia",
    "Pablo García",
    "Bright Ede",
    "José Ángel",
    "Riki Rodríguez",
    "Mario Soriano Carreno",
    "Charlie Patino",
    "Diego Villares",
    "Lorenzo Amatucci",
    "Teun Gijselhart",
    "Jonathan Asp Jensen",
    "Pierre-Emerick Aubameyang",
    "Zakaria Eddahchouri",
    "Yeremay Hernández",
    "Luis Cruz",
    "David Mella",
    "Bil Nsongo"
  ],
  "Deportivo Madryn": [
    "Yair Bonnín",
    "Mauricio Nievas",
    "Matias Montero",
    "Roberto Leon",
    "Lucas Toffoletti",
    "Diego Martínez",
    "Alex Cossi",
    "Víctor Cabrera",
    "Nicolás Ortíz",
    "Alejandro Gutierrez",
    "Franco Godoy",
    "Agustín Sosa",
    "Facundo Giacopuzzi",
    "Thiago Yossen",
    "Marcelo Meli",
    "Facundo Ospitaleche",
    "Nazareno Solis",
    "Federico Recalde",
    "Gabriel Gudiño",
    "Camilo Machado",
    "Yvo Calleros",
    "Estanislao Jara",
    "Elías Ayala",
    "Álvaro Dionisio",
    "Adriano Martinez",
    "Luis Silba",
    "Ezequiel Montagna",
    "Nicolás Servetto",
    "Juan Peinipil",
    "Yamil García"
  ],
  "Deportivo Maipú": [
    "Luciano Peraggini",
    "Nahuel Galardi",
    "Agustín Pavón",
    "Juan De La Reta",
    "Lucas Faggioli",
    "Nicolas Fernandez",
    "Mateo Ortale",
    "Luciano Arnijas",
    "Juan Arno",
    "Tiago Ferreyra",
    "Agustín Leiva",
    "Víctor Barrera",
    "Enzo Pérez",
    "Fausto Montero",
    "Diego Gaitan",
    "Matías Viguet",
    "Juan Pablo Gobetto",
    "Aron Agüero",
    "Gastón Mansilla",
    "Santiago Paulini",
    "Mirko Bonfigli",
    "Franco Saccone",
    "Julián Vera",
    "Lisandro Cabrera",
    "Tomás Silva",
    "Juan Cruz Giacone",
    "Luca Landriel",
    "Ian Sambueza"
  ],
  "Deportivo Maldonado": [
    "Diego Segovia",
    "Adriano Freitas",
    "Víctor Felipe Ortíz Ferreira",
    "Juan Ramos",
    "Facundo Tealde",
    "Hernán Menosse",
    "Hernán Petrik",
    "Joaquín Fernández",
    "Juan Martín Ginzo",
    "Nicolás Fuica",
    "Juan Martín Pirota",
    "Benjamín Cavenaghi Gaynor",
    "Franco Marino",
    "Carlos Núñez",
    "Camilo Mayada",
    "Gonzalo Sosa",
    "Maximiliano González",
    "Santiago Cartagena",
    "Lucas Núñez",
    "Gonzalo Larrazabal",
    "Sebastián González",
    "Bruno Centeno",
    "Sebastián Vicente Tormo Módena",
    "Thiago Facundo Correa Da Rosa",
    "Alis Maximiliano Noble Sequeira",
    "Lautaro Ibáñez Benítez",
    "Guillermo Lopez",
    "Renato César",
    "Christian Tabó",
    "Emiliano Mozzone",
    "Santiago Ramírez",
    "Cayetano Bolzán"
  ],
  "Deportivo Morón": [
    "Julio César Salvá",
    "Federico Díaz",
    "Maximo Casalinuovo",
    "Mariano Bíttolo",
    "Brian Salvareschi",
    "Emanuel Iñiguez",
    "Francisco Flores",
    "Leonel Ramírez",
    "Iván Vaquero",
    "Leonel Cardozo",
    "Joaquín Livera",
    "Maximiliano González",
    "Juan Manuel Olivares",
    "Gaston González",
    "Emiliano Franco",
    "Mauro Burruchaga",
    "Elías Contreras",
    "Santiago Kubiszyn",
    "Tomás Ramírez",
    "Valentino Huertas",
    "Franco Fagúndez",
    "Franco Toloza",
    "Matías Benítez",
    "Gonzalo Berterame",
    "Mateo Levato",
    "Juan Cruz Esquivel",
    "Joaquín Zappacosta"
  ],
  "Deportivo Riestra": [
    "Ignacio Arce",
    "Iván López",
    "Marino Arzamendia",
    "Gonzalo Flores",
    "Carlos Quintana",
    "Jeison Murillo",
    "Juan Cruz Randazzo",
    "Eric Tovo",
    "Pedro Ramirez",
    "Cristian Paz",
    "Nicolás Sansotre",
    "Jonathan Goitia",
    "Mariano Bracamonte",
    "Rodrigo Gallo",
    "Ignacio Gariglio",
    "Facundo Miño",
    "Manuel Aiello",
    "Matías García",
    "Milton Céliz",
    "Brian Sánchez",
    "Nicólas Watson",
    "Pablo Monje",
    "Benjamin Pérez",
    "Gabriel Obredor",
    "Thiago Lauro",
    "Alexander Díaz",
    "Miguel Graneros",
    "Nicolás Benegas",
    "Antony Alonso",
    "Ángel Stringa",
    "Tomás González",
    "Mauro Smarra",
    "Lautaro Duarte"
  ],
  "Derby County": [
    "Richard O'Donnell",
    "Josh Vickers",
    "Jacob Widell Zetterström",
    "Ryan Nyambe",
    "Craig Forsyth",
    "Matthew Clarke",
    "Dion Sanderson",
    "Derry John Murkin",
    "Max Johnston",
    "Sondre Langas",
    "Lewis Travis",
    "Joe Ward",
    "Oscar Fraulo",
    "Bobby Clark",
    "Owen Eames",
    "Patrick Agyemang",
    "Carlton Morris",
    "Lars Jorgen Salvesen",
    "Corey Taylor",
    "Rhian Brewster"
  ],
  "Dijon FCO": [
    "Paul Delecroix",
    "Enzo Ketterle",
    "Quentin Bernard",
    "Waly Diouf",
    "Lenny Lacroix",
    "Michael Barreto",
    "Jordan Marié",
    "Hugo Vargas Ríos",
    "Brandon Nsimba Ndezi",
    "Samy Chouchane",
    "Adel Lembezat",
    "Ben-Chayeel Hamada",
    "Paul Bellon",
    "César Obongo",
    "Júlio Tavares",
    "Yanis Barka",
    "Julien Domingues",
    "Alexis Ntamack",
    "Florian Rombogouera Gouzele"
  ],
  "Dunkerque": [
    "Mouhamed Sissokho",
    "Allan Linguet",
    "Bram Lagae",
    "Assane N'Doye",
    "Victor Mayela",
    "Maedine Makhloufi",
    "Lenny Loussilaho",
    "Matteo Bebey Sake",
    "Abner",
    "Opa Sanganté",
    "Théna Massock",
    "Jordan Morel",
    "Marco Decherf",
    "Pape Dieng",
    "Thomas Robinet",
    "Alex Daho",
    "Khalil Ayari",
    "Zaid Seha"
  ],
  "Dynamo Dresden": [
    "Daniel Mesenhöler",
    "Lennart Grill",
    "Tim Schreiber",
    "Elias Bethke",
    "Lukas Boeder",
    "Ahmet Muhamedbegovic",
    "Alexander Rossipal",
    "Simon Straudi",
    "Thomas Keller",
    "Jonas Sterner",
    "Brooklyn Ezeh",
    "Lars Bünning",
    "Kenneth Schmidt",
    "Till Neininger",
    "Friedrich Müller",
    "Nicolai Rapp",
    "Niklas Hauptmann",
    "Tobias Raschl",
    "Luca Herrmann",
    "Jakob Lemmer",
    "Robert Wagner",
    "Jonas Oehmichen",
    "Vincent Vermeij",
    "Nils Froling",
    "Christoph Daferner",
    "Ben Bobzien",
    "Kaan Inanoglu"
  ],
  "Eibar": [
    "Jon Mikel Magunagoitia",
    "Luis López",
    "Anaitz Arbilla",
    "Juan Bernat",
    "Unai Elgezabel",
    "Jair Amador Silos",
    "Álvaro Rodríguez Pérez",
    "Sergio Cubero",
    "Imanol García de Albéniz",
    "Arana",
    "Sergio Álvarez",
    "Lander Olaetxea",
    "Peru Nolaskoain",
    "Lucas Núñez",
    "Jon Magunacelaya",
    "Iván Gil",
    "Aleix Garrido",
    "Ander Madariaga",
    "Jon Guruzeta",
    "Jon Bautista",
    "Pejiño",
    "Javier Martón",
    "Malcom Adu Ares"
  ],
  "Eintracht Frankfurt": [
    "Jens Grahl",
    "Michael Zetterer",
    "Kauã Santos",
    "Amil Siljevic",
    "Robin Koch",
    "Niels Nkounkou",
    "Arthur Theate",
    "Nnamdi Collins",
    "Keita Kosugi",
    "Elias Baum",
    "Otávio",
    "Timothy Chandler",
    "Mario Götze",
    "Ellyes Skhiri",
    "Ritsu Doan",
    "Raphael Onyedika",
    "Hugo Larsson",
    "Farès Chaïbi",
    "Can Uzun",
    "Oscar Højlund",
    "Love Arrhov",
    "Michy Batshuayi",
    "Jonathan Burkardt",
    "Ansgar Knauff",
    "Jean-Mattéo Bahoya",
    "Younes Ebnoutalib",
    "Ayoube Amaimouni",
    "Malik Pimpong"
  ],
  "Elche": [
    "Matías Dituro",
    "Alejandro Iturbe",
    "Pedro Bigas",
    "Víctor Chust",
    "Bambo Diaby",
    "David Affengruber",
    "Buba Sangaré",
    "Josan",
    "Gonzalo Villar",
    "Marc Aguado",
    "Federico Redondo",
    "Martim Neto",
    "Grady Diangana",
    "José Antonio Morente",
    "Germán Valera",
    "Lucas Cepeda",
    "Yago Alonso",
    "Nordin Al Lal",
    "Ali Houary"
  ],
  "Eldense": [
    "Juan Palomares",
    "Antonio Pina",
    "Javier Olaizola",
    "Jordi Martín",
    "Floris Smand",
    "Álex Serra",
    "Julien Yanda",
    "Oscar Vega",
    "David Ruiz Montero",
    "Justin Smith",
    "Javier Martínez",
    "Marcos Bustillo",
    "Borja Calvo",
    "Carlos Guirao",
    "Guillermo Macho",
    "Fidel",
    "Manuel Nieto",
    "Jesus Clemente",
    "Rodrigo Val",
    "Jorge Rastrojo",
    "Pau Cabanes",
    "Mariano Carmona",
    "Álex Ibarrondo",
    "Lorenzo Santillan"
  ],
  "Elversberg": [
    "Frank Lehmann",
    "Tim Boss",
    "Nicolas Kristof",
    "Elias Etringer",
    "Jan Gyamerah",
    "Maximilian Rohr",
    "Florian Le Joncour",
    "Nicholas Mickelson",
    "Lasse Günther",
    "Felix Keidel",
    "Lukas Finn Pinckert",
    "Luis Seifert",
    "Luca Schnellbacher",
    "Amara Conde",
    "Lukasz Poreba",
    "Maurice Krattenmacher",
    "Noah Darvich",
    "Francis-Ikechukwu Onyeka",
    "Frederik Schmahl",
    "Luca Pfeiffer",
    "Jason Ceka",
    "Lukas Petkov",
    "Tom Zimmerschied",
    "Cole Campbell",
    "Filimon Gerezgiher",
    "David Mokwa",
    "Raif Adam"
  ],
  "Empoli": [
    "Samuele Perisan",
    "Francesco Versari",
    "Joseph Ceesay",
    "Marco Curto",
    "Gabriele Guarino",
    "Gabriele Indragoli",
    "Dawid Bembnista",
    "Kevin Pasalic",
    "Andrea Orlandi",
    "Salvatore Elia",
    "Gerard Yepes",
    "Duccio Degli Innocenti",
    "Edoardo Saporiti",
    "Alessio Baralla",
    "Danilo Busiello",
    "Ernesto Perin",
    "Flavio Junior Bianchi",
    "Steven Shpendi",
    "Bohdan Popov",
    "Thomas Campaniello",
    "Edoardo Zanaga"
  ],
  "Energie Cottbus": [
    "Marcel Lotka",
    "Kevin Kratzsch",
    "Max Böhnke",
    "Malte Wilke",
    "Axel Borgmann",
    "Anderson Lucoqui",
    "Tim Campulka",
    "Ryan Malone",
    "Henry Rorig",
    "King Manu",
    "Luca Erlein",
    "Fousseny Doumbia",
    "Hasan Jannis Zaydan",
    "Joey Taubeneck",
    "Leonardo Bittencourt",
    "Jonas Hofmann",
    "Tolcay Cigerci",
    "Dominik Pelivan",
    "Christian Kinsombi",
    "Julian Guttau",
    "Lukas Michelbrink",
    "Jannis Boziaris",
    "Yusuf Wardak",
    "Aaron Reschke",
    "Justin Butler",
    "Erik Engelhardt",
    "Ted Tattermusch",
    "Lucas Copado",
    "Moritz Hannemann"
  ],
  "Espanyol": [
    "Marko Dmitrovic",
    "Ángel Fortuño",
    "Pol Tristan",
    "Leandro Cabrera",
    "Miguel Rubio",
    "Omar El Hilali",
    "Rubén Sánchez",
    "Clemens Riedel",
    "Pere Milla",
    "Edu Expósito",
    "Pol Lozano",
    "Urko Gonzalez",
    "Enrique García",
    "Javier Puado",
    "Tyrhys Dolan",
    "Jofre Carreras",
    "Roberto Fernández"
  ],
  "España": [
    "David Raya",
    "Unai Simón",
    "Joan García",
    "Eric García",
    "Aymeric Laporte",
    "Alejandro Grimaldo",
    "Marc Cucurella",
    "Pedro Porro",
    "Marc Pubill",
    "Pau Cubarsí",
    "Marcos Llorente",
    "Mikel Merino",
    "Fabián Ruiz",
    "Dani Olmo",
    "Rodri",
    "Pedri",
    "Martín Zubimendi",
    "Yéremy Pino",
    "Álex Baena",
    "Gavi",
    "Borja Iglesias",
    "Mikel Oyarzabal",
    "Ferran Torres",
    "Nico Williams",
    "Lamine Yamal",
    "Víctor Muñoz"
  ],
  "Estados Unidos": [
    "Matt Freese",
    "Chris Brady",
    "Matt Turner",
    "Mark McKenzie",
    "Tim Ream",
    "Antonee Robinson",
    "Auston Trusty",
    "Alex Freeman",
    "Miles Robinson",
    "Sergiño Dest",
    "Joe Scally",
    "Chris Richards",
    "Cristian Roldan",
    "Tyler Adams",
    "Christian Pulisic",
    "Weston McKennie",
    "Brenden Aaronson",
    "Giovanni Reyna",
    "Sebastian Berhalter",
    "Malik Tillman",
    "Max Arfsten",
    "Alejandro Zendejas",
    "Haji Wright",
    "Timothy Weah",
    "Folarin Balogun",
    "Ricardo Pepi"
  ],
  "Estudiantes (Buenos Aires)": [
    "Juan Manuel Lungarzo",
    "Rodrigo Fumo",
    "Facundo Vila",
    "Jorge Benítez",
    "Nicolás Caro",
    "Franco Quinteros",
    "Facundo Ardiles",
    "Balthazar Bernardi",
    "Martín Albarracín",
    "Tomás Núñez",
    "Andrés Berizovsky",
    "Tomás Squie",
    "Gabriel Barca",
    "Juan Giménez",
    "Mateo Acosta",
    "Rodrigo Melo",
    "Enzo Acosta",
    "Santiago Camacho",
    "Juan Sánchez",
    "Matías Núñez",
    "Román Rodríguez",
    "Lucas Silva",
    "Valentino Pereyra",
    "Fernando Duré",
    "Federico Sena",
    "Bautista Degregorio",
    "Teo Cohen",
    "Jorge Correa",
    "Darío Rostagno",
    "Ezequiel Almirón",
    "Ian Vera",
    "Juan Cruz Vergara"
  ],
  "Estudiantes de La Plata": [
    "Fernando Muslera",
    "Fabricio Iacovich",
    "Rodrigo Borzone",
    "Tiziano Van Der Tuin",
    "Ramiro Funes Mori",
    "Leandro González Pírez",
    "Joaquín Pereyra",
    "Santiago Arzamendia",
    "Eric Meza",
    "Gastón Benedetti",
    "Eros Mancuso",
    "Santiago Núñez",
    "Valente Pierani",
    "Faustino Messina",
    "Matías Magdaleno",
    "Máximo Desábato",
    "Tomás Palacios",
    "Jorge Georgieff",
    "José Sosa",
    "Alexis Castro",
    "Ezequiel Piovi",
    "Gabriel Neves",
    "Facundo Farías",
    "Tiago Palacios",
    "Bautista Kociubinski",
    "Thiago González",
    "Lucas Cornejo",
    "Franco Basualdo",
    "Leonardo Naser",
    "Bautista Molinari",
    "Ciro Spalletta",
    "Benjamín Maliani",
    "Agustín Traina",
    "Guido Carrillo",
    "Lucas Alario",
    "Edwin Cetre",
    "Adolfo Gaich",
    "Brian Aguirre",
    "Fabricio Pérez",
    "Joaquín Tobio Burgos",
    "Benjamín Sagues",
    "Franco Dominguez",
    "Santino Crego",
    "Juan Fernández Soler",
    "Enzo Sanabria",
    "Thiago Serrano",
    "Francisco Silvetti"
  ],
  "Estudiantes de Río Cuarto": [
    "Lucas Bruera",
    "Agustín Lastra",
    "Francisco Gualtieri",
    "Sergio Ojeda",
    "Facundo Cobos",
    "Raúl Lozano",
    "Matías Ruiz Díaz",
    "Juan Antonini",
    "Alejandro Cabrera",
    "Gonzalo Maffini",
    "Fernando Rodríguez",
    "Gonzalo Gonzalez",
    "Agustin Quiroga",
    "Tomás Olmos",
    "Matías Valenti",
    "Jeremías Ramponi",
    "Matias Pagliaricci",
    "Francisco Romero",
    "Gabriel Alanís",
    "Nicolás Talpone",
    "Francesco Lo Celso",
    "Ibrahim Hesar",
    "Siro Rosané",
    "Ezequiel Forclaz",
    "Tomás González",
    "Lautaro Cepeha",
    "Juan Garro",
    "Yeison Murillo",
    "Javier Ferreira",
    "Ramón Ábila",
    "Mauro Molina",
    "Mateo Bajamich",
    "Mauro Valiente",
    "Martín Garnerone",
    "Francisco Galván",
    "Valentin Fenoglio",
    "Benjamin Moyano",
    "Joaquín Román Rivero"
  ],
  "Everton": [
    "Mark Travers",
    "Tom King",
    "Jordan Pickford",
    "Michael Keane",
    "James Tarkowski",
    "Vitaliy Mykolenko",
    "Nathan Patterson",
    "Jake O'Brien",
    "Jarrad Branthwaite",
    "Adam Aznou",
    "Christian Nørgaard",
    "Kiernan Dewsbury-Hall",
    "James Garner",
    "Carlos Alcaraz",
    "Tim Iroegbunam",
    "Merlin Röhl",
    "Tyler Dibling",
    "Harrison Armstrong",
    "Iliman Ndiaye",
    "Beto",
    "Thierno Barry",
    "Tyrique George"
  ],
  "FC Andorra": [
    "Pau López",
    "Nico Ratti",
    "Diego Alende",
    "Andoni López",
    "Thomas Carrique",
    "Marti Vila Garcia",
    "Gael Alonso",
    "Marc Bombardó",
    "Lautaro Spatz",
    "Juan Sebastian Serrano",
    "Sergio Molina",
    "Randy Schneider",
    "Théo Le Normand",
    "Jordi Cano",
    "Nacho Quintana",
    "Efe Akman",
    "Hugo Solozabal",
    "Lautaro De León",
    "Moró Sidibe",
    "Julian Rijkhoff",
    "Álex Calvo",
    "Aitor Uzkudun"
  ],
  "FC Cincinnati": [
    "Evan Louro",
    "Roman Celentano",
    "Fabian Mrozek",
    "Alvas Powell",
    "Matt Miazga",
    "Nick Hagglund",
    "Teenage Hadebe",
    "Bryan Ramirez",
    "Kyle Smith",
    "Miles Robinson",
    "Andrei Chirila",
    "Ayoub Lajhar",
    "Evander",
    "Tah Anunga",
    "Obinna Nwobodo",
    "Pavel Bucha",
    "Stiven Jimenez",
    "Gerardo Valenzuela",
    "Samuel Gidi",
    "Stefan Chirila",
    "Ademar Chavez",
    "Tom Barlow",
    "Kévin Denkey",
    "Ayoub Jabbari",
    "Kristian Fletcher",
    "Ender Echenique",
    "Kenji Mboma Dem"
  ],
  "FC Cologne": [
    "Ron-Robert Zieler",
    "Marvin Schwäbe",
    "Matthias Köbbing",
    "Luka Lochoshvili",
    "Timo Hübers",
    "Gideon Mensah",
    "Sebastian Sebulonsen",
    "Rav van den Berg",
    "Joel Schmied",
    "Jahmai Simpson-Pusey",
    "Julian Pauli",
    "Linton Maina",
    "Alessio Castro-Montes",
    "Tom Krauss",
    "Ísak Jóhannesson",
    "Jan Thielmann",
    "Fayssal Harchaoui",
    "Said El Mala",
    "Paul Okon-Engstler",
    "Luca Waldschmidt",
    "Ragnar Ache",
    "Marius Bulter",
    "Reigan Heskey",
    "Malek El Mala",
    "Youssoupha Niang"
  ],
  "FC Dallas": [
    "Daniel",
    "Jonathan Sirois",
    "Michael Collodi",
    "Shaq Moore",
    "Sebastien Ibeagha",
    "Lalas Abubakar",
    "Osaze Urhoghide",
    "Geovane Jesus",
    "Nolan Norris",
    "Slade Starnes",
    "Enzo Newman",
    "Álvaro Augusto",
    "Joshua Torquato",
    "Kaka Scabin",
    "Ramiro",
    "Clay Holstad",
    "Christian Cappis",
    "Patrickson Delgado",
    "Herman Johansson",
    "Diego García",
    "Joaquín Valiente",
    "Ran Binyamin",
    "Kaick",
    "Caleb Swann",
    "Anderson Julio",
    "Petar Musa",
    "Santiago Moreno",
    "Louicius Deedson",
    "Bernard Kamungo",
    "Samuel Sarver",
    "Logan Farrington",
    "Nicholas Simmonds",
    "Daniel Baran",
    "Jaidyn Contreras",
    "Ricky Louis",
    "Benjamin Flowers"
  ],
  "Fénix": [
    "Francisco Casanova",
    "Aaron Soria",
    "Juan Alvez",
    "Guillermo Pereira",
    "Jonathan Toledo",
    "Adrián Argachá",
    "Fernando Souza",
    "Agustín Lema",
    "Santiago Franca",
    "Kevin Alaniz",
    "Maureen Franco",
    "Ignacio Pereira",
    "Nicolás Machado",
    "Bruno Scorza",
    "Sebastián De Marco"
  ],
  "Ferro Carril Oeste": [
    "Fernando Monetti",
    "Lucas Ruiz",
    "Ángel González",
    "Gustavo Canto",
    "Fernando Torrent",
    "Sebastian Corda",
    "Misael Taron",
    "Federico Tévez",
    "Nazareno Kihm",
    "Gonzalo Castellani",
    "Emiliano Ozuna",
    "Matías Kabalin",
    "Enzo Hoyos",
    "Laureano Marra",
    "Felipe Obradovich",
    "Emanuel Dening",
    "Jonathan Menéndez",
    "Franco Garcia",
    "Lautaro Parisi"
  ],
  "Ferrocarril Midland": [
    "Mauro Leguiza",
    "Lucas Escobar",
    "Santiago García",
    "Gonzalo Gómez",
    "Luciano Recalde",
    "Emilio Porro",
    "Pablo Casarico",
    "Mariano Penepil",
    "Bautista Lamosa",
    "Mirko Olavarría",
    "Pedro Castoran",
    "Genaro Cepeda",
    "Tomás Muia",
    "Joel Canalda",
    "Mauro Frattini",
    "Ramiro Luna",
    "Matías Flores",
    "Jesus Camaño",
    "Matías Abbruzzese",
    "Lautaro Díaz Laharque",
    "Dylan Aguilar",
    "Nicolás Violini",
    "Facundo Marín",
    "Rodrigo Cao",
    "Amos Perales",
    "Marcos Roseti",
    "Matteo Cucinotta",
    "Santino Primante",
    "Uriel Guzmán",
    "Valentino Madalón",
    "David Bulacio"
  ],
  "Fiorentina": [
    "David de Gea",
    "Luca Lezzerini",
    "Oliver Christensen",
    "Dodô",
    "Marin Pongracic",
    "Luca Ranieri",
    "Fabiano Parisi",
    "Niccolò Fortini",
    "Eman Kospo",
    "Rolando Mandragora",
    "Marco Brescianini",
    "Nicolò Fagioli",
    "Giovanni Fabbian",
    "Cher Ndour",
    "Albert Gudmundsson",
    "Moise Kean",
    "Roberto Piccoli",
    "Riccardo Braschi"
  ],
  "Flamengo": [
    "Agustín Rossi",
    "Andrew",
    "Dyogo Alves",
    "Leó Nannetti",
    "Gabriel Laizo  Werneck",
    "Luiz Da Silva",
    "Alex Sandro",
    "Léo Pereira",
    "Danilo",
    "Guillermo Varela",
    "Ayrton Lucas",
    "Emerson Royal",
    "Léo Ortiz",
    "Vitão",
    "Daniel Sales",
    "João Victor",
    "Gusttavo Sousa",
    "Johnny Monteiro Góes",
    "Daniel Carvalho Marinho Da Silva",
    "Ernest Muñoz",
    "Jorginho",
    "Saúl Ñíguez",
    "Giorgian de Arrascaeta",
    "Erick Pulgar",
    "Jorge Carrascal",
    "Lucas Paquetá",
    "Nicolás de la Cruz",
    "Samuel Lino",
    "Evertton",
    "Lorran",
    "Guilherme Gomes",
    "Pablo Lucio",
    "Lucas Santos",
    "Luiz Felipe",
    "Joshua",
    "Jhefinho",
    "Kaio Nóbrega",
    "João Vitor Andrade Couto Lauredo",
    "Gabriel Amancio",
    "Juan Sayago",
    "Everton",
    "Bruno Henrique",
    "Luiz Araújo",
    "Pedro",
    "Gonzalo Plata",
    "Wallace Yan",
    "Diego Reyes",
    "Douglas Telles",
    "João",
    "Josmar",
    "Gustavo Rodrigues Nunes",
    "Alan Santos",
    "Isaac Gomes Rodrigues Da Silva"
  ],
  "Fluminense": [
    "Fábio",
    "Vitor Eudes",
    "Marcelo Pitaluga",
    "Gustavo Felix",
    "Thiago Silva",
    "Samuel Xavier",
    "René",
    "Guilherme Arana",
    "Igor Rabello",
    "Julian Millan",
    "Guga",
    "Juan Freytes",
    "Ignácio",
    "Julio Fidelis",
    "Jemmes",
    "Breno",
    "Kaio Borges",
    "Gorgulho",
    "Ganso",
    "Alisson",
    "Luciano Acosta",
    "Otávio",
    "David Terans",
    "Nonato",
    "Martinelli",
    "Hércules",
    "Davi Melo",
    "Vagno",
    "Naarã",
    "Peter",
    "Paulo Guilherme",
    "Ruan Sales",
    "Rodrigo Castillo",
    "Hulk",
    "Germán Cano",
    "Jefferson Savarino",
    "Yeferson Soteldo",
    "Agustín Canobbio",
    "Kevin Serna",
    "John Kennedy",
    "João Pedro Silverio Lourenco",
    "Matheus Reis",
    "Isack Pelé",
    "Riquelme",
    "Wesley Natã",
    "Keven Samuel",
    "Enzo"
  ],
  "Fortaleza": [
    "Vinicius",
    "João Ricardo",
    "Magrão",
    "Neris",
    "Tomás Cardona",
    "Gabriel Fuentes",
    "Maílton dos Santos",
    "Luan",
    "Maurício Júnior",
    "Guilherme",
    "Lucas Xavier Gazal",
    "Paulo Ricardo",
    "Cristovam",
    "Kaua",
    "Lucas Sasha",
    "Lucas Crispim",
    "Matheus Rossetto",
    "Pierre",
    "Rodriguinho",
    "Lucca",
    "Ryan",
    "Ronald Falkoski",
    "Rodrigo Santos",
    "Bruninho",
    "Welliton",
    "Pedro Henrique",
    "Luiz Fernando",
    "Nathan Fogaça",
    "Juan Miritello",
    "Vitinho",
    "Paulo Baya",
    "Tomás Roco",
    "Caio Wesley",
    "Lucas Emanoel"
  ],
  "Francia": [
    "Brice Samba",
    "Mike Maignan",
    "Robin Risser",
    "Lucas Digne",
    "Lucas Hernández",
    "Dayot Upamecano",
    "Jules Koundé",
    "Theo Hernández",
    "Ibrahima Konaté",
    "Maxence Lacroix",
    "William Saliba",
    "Malo Gusto",
    "N'Golo Kanté",
    "Adrien Rabiot",
    "Aurélien Tchouaméni",
    "Manu Koné",
    "Michael Olise",
    "Rayan Cherki",
    "Maghnes Akliouche",
    "Warren Zaïre-Emery",
    "Marcus Thuram",
    "Ousmane Dembélé",
    "Kylian Mbappé",
    "Jean-Philippe Mateta",
    "Bradley Barcola",
    "Désiré Doué"
  ],
  "Freiburg": [
    "Florian Müller",
    "Jannik Huth",
    "Noah Atubolu",
    "Anthony Jung",
    "Matthias Ginter",
    "Lukas Kübler",
    "Christian Günter",
    "Philipp Lienhart",
    "Niklas Beste",
    "Philipp Treu",
    "Max Rosenfelder",
    "Jordy Makengo",
    "Berkay Yilmaz",
    "Ifechukwu Ogbus",
    "Karl Steinmann",
    "Vincenzo Grifo",
    "Maximilian Eggestein",
    "Florent Muslija",
    "Patrick Osterhage",
    "Yuito Suzuki",
    "Yannick Engelhardt",
    "Rihito Yamamoto",
    "Rouven Tarnutzer",
    "Lucas Höler",
    "Igor Matanovic",
    "Eren Dinkci",
    "Keisuke Goto",
    "Derry Scherhant",
    "Cyriaque Irié"
  ],
  "Frosinone": [
    "Matteo Pisseri",
    "Lorenzo Palmisani",
    "Eldin Lolic",
    "Edoardo Masciangelo",
    "Sergio Kalaj",
    "Niccolò Corrado",
    "Ilario Monterisi",
    "Anthony Oyono",
    "Giorgio Cittadini",
    "Gabriele Bracaglia",
    "Jérémy Oyono",
    "Jacopo Gelli",
    "Giacomo Calo",
    "Ben Lhassine Kone",
    "Ilias Koutsoupias",
    "Francesco Gelli",
    "Matteo Cichella",
    "Filippo Grosso",
    "Edoardo Vergani",
    "Farès Ghedjemis",
    "Giorgi Kvernadze",
    "Alejandro Cichero",
    "Kevin Barcella"
  ],
  "Fulham": [
    "Benjamin Lecomte",
    "Bernd Leno",
    "Kenny Tete",
    "Joachim Andersen",
    "Timothy Castagne",
    "Antonee Robinson",
    "Jorge Cuenca",
    "Calvin Bassey",
    "Tom Cairney",
    "Harrison Reed",
    "Sander Berge",
    "Ryan Sessegnon",
    "Emile Smith Rowe",
    "Oscar Bobb",
    "Josh King",
    "Alex Iwobi",
    "Rodrigo Muniz",
    "Kevin",
    "Jonah Kusi-Asare"
  ],
  "Genoa": [
    "Justin Bijlow",
    "Daniele Sommariva",
    "Ernestas Lysionok",
    "Stefano Sabelli",
    "Aarón Martín",
    "Johan Vásquez",
    "Leo Østigard",
    "Brooke Norton-Cuffy",
    "Sebastian Otoa",
    "Alessandro Marcandalli",
    "Mamedi Doucouré",
    "Wedtoin Ouedraogo",
    "Morten Frendrup",
    "Mikael Ellertsson",
    "Alexsandro Amorim",
    "Caleb Ekuban",
    "Junior Messias",
    "Lorenzo Colombo",
    "Joi Nuredini",
    "Vitinha"
  ],
  "Getafe": [
    "David Soria",
    "Jirí Letácek",
    "Kiko Femenía",
    "Djené",
    "Abdel Abqar",
    "Zaid Romero",
    "Davinchi",
    "Javi Muñoz",
    "Yvan Neyou",
    "Christantus Uche",
    "Juanmi",
    "Borja Mayoral",
    "Álex Sancris",
    "Ebrahima Drammeh Jaiteh"
  ],
  "Gimnasia y Esgrima (Jujuy)": [
    "Milton Álvarez",
    "Matías Ramos Mingo",
    "Nicolás Dematei",
    "Guillermo Cosaro",
    "Diego Lopez",
    "Sebastián Sánchez",
    "Jesús Endrizzi",
    "Héctor Varela",
    "Delfor Minervino",
    "Juan Pablo Córdoba",
    "Franco Camargo",
    "Martin Lazarte",
    "Gonzalo Villarreal",
    "Facundo Maldonado",
    "Hugo Soria",
    "Claudio Pombo",
    "Francisco Molina",
    "Francisco Maidana",
    "Federico Paradela",
    "Héctor Zapatiel",
    "Emiliano Zambrano",
    "Pablo Toledo",
    "Cristian Menéndez",
    "David Gallardo",
    "Maximiliano Casa",
    "Juan Franzoni",
    "Pablo Argañaraz",
    "Mauro Daniel Cachi",
    "Octavio Bianchi",
    "Rodrigo Velázquez",
    "Gonzalo Puntano"
  ],
  "Gimnasia y Esgrima La Plata": [
    "Nelson Insfran",
    "Harlen Castillo",
    "Julián Kadijevic",
    "Patricio Schroeder",
    "Máximo Cabrera",
    "Enzo Martínez",
    "Germán Conti",
    "Pedro Silva Torrejón",
    "Matías Melluso",
    "Renzo Giampaoli",
    "Gonzalo Errecalde",
    "Bautista Barros Schelotto",
    "Juan Cortazzo",
    "Alejo Gelsomino",
    "Mariano Ojeda",
    "Jeremías Ezequiel Langa",
    "Lucas Lamella",
    "Ignacio Fernández",
    "Augusto Max",
    "Santiago Villarreal",
    "Ignacio Miramon",
    "Mateo Seoane",
    "Alexis Steimbach",
    "Juan Perez",
    "Nicolas Schelotto",
    "Jeremias Merlo",
    "Facundo Di Biasi",
    "Pablo Aguiar",
    "Marcelo Torres",
    "Lucas Janson",
    "Maximiliano Zalazar",
    "Manuel Panaro",
    "Ivo Mammini",
    "Agustin Colazo",
    "Franco Torres",
    "Agustín Auzmendi",
    "Jorge De Asís"
  ],
  "Gimnasia y Esgrima Mendoza": [
    "César Rigamonti",
    "Lautaro Petruchi",
    "Ezequiel Muñoz",
    "Juan Franco",
    "Imanol Gonzalez",
    "Diego Mondino",
    "Germán Guiffrey",
    "Franco Saavedra",
    "Ismael Cortez",
    "Luciano Paredes",
    "Martín Úbeda",
    "Gerónimo Patritti",
    "Fermín Antonini",
    "Tomás Ortiz",
    "Ulises Sánchez",
    "Esteban Fernández",
    "Facundo Lencioni",
    "Matías Recalde",
    "Tomas O'Connor",
    "Nahuel Barboza",
    "Julián Ceballos",
    "Lautaro Carrera",
    "Santiago Rodríguez",
    "Brian Andrada",
    "Blas Armoa",
    "Nicolás Romano",
    "Luciano Cingolani",
    "Brian Nicolas Ferreyra",
    "Ignacio Charparin",
    "Agustín Módica",
    "Valentino Simoni"
  ],
  "Gimnasia y Tiro (Salta)": [
    "Federico Cosentino",
    "Joaquin Papaleo",
    "Gonzalo Soto",
    "Gabriel Díaz",
    "Juan Oviedo",
    "Manuel Guanini",
    "Lautaro Montoya",
    "Juan Galetto",
    "Adolfo Tallura",
    "Joel Gordillo",
    "Rubén Villarreal",
    "Roberto Birge",
    "Jonás Aguirre",
    "Nicolás Rinaldi",
    "Walter Montoya",
    "Ivo Chaves",
    "Franco Sivetti",
    "Tiago Banega",
    "Tiago Borquez",
    "Ignacio Batista",
    "Pablo Rodriguez",
    "Felipe Karabulut",
    "Leandro Contin",
    "Lautaro Gordillo",
    "Juan Rocca",
    "Fabricio Rojas",
    "Juan Capano",
    "Camilo Pantoja",
    "Juan Turletti"
  ],
  "Girona": [
    "Paulo Gazzaniga",
    "Vladyslav Krapyvtsov",
    "Álex Moreno",
    "David López",
    "Alejandro Francés",
    "Arnau Martínez",
    "Gibert Jordana",
    "Antonio Salguero",
    "Guillem Badía Gutiérrez",
    "Donny van de Beek",
    "Fran Beltrán",
    "Azzedine Ounahi",
    "Ricard Artero",
    "Iván Martín",
    "Gabriel Misehouy",
    "Lancinet Kourouma",
    "Cristhian Stuani",
    "Viktor Tsygankov",
    "Abel Ruiz",
    "Bryan Gil",
    "Yáser Asprilla",
    "Vladyslav Vanat",
    "Dawda Camara",
    "Javier Sarasa"
  ],
  "Godoy Cruz Antonio Tomba": [
    "Roberto Ramirez",
    "Juan Strumia",
    "Nicolás Cláa",
    "Juan Morán",
    "Diego Viera",
    "Esteban Burgos",
    "Federico Milo",
    "Mateo Mendoza",
    "Francisco Gerometta",
    "Leandro Quiroz",
    "Lucas Arce",
    "Tomas Rossi",
    "Nahuel Brunet",
    "Gerónimo Montivero",
    "Gonzalo Quinteros",
    "Gastón Gil Romero",
    "Juan Andrada",
    "Brian Orosco",
    "Felipe Cairus",
    "Vicente Poggi",
    "Benjamín Schamine",
    "Claudio Valverde",
    "Misael Sosa",
    "Santiago Martínez",
    "Camilo Alessandría",
    "Ezequiel Tejada",
    "Antonio Guerrero",
    "Julián Ernesto Alberti",
    "Benjamín Rojas Moya",
    "Rodrigo Fernández",
    "Axel Rodriguez",
    "Martín Pino",
    "Juan Bautista Cejas",
    "Silvio Ulariaga",
    "Enzo Barrionuevo",
    "Óscar González",
    "Willian Riquelme",
    "Kevin Valdez"
  ],
  "Goiás": [
    "Tadeu",
    "Thiago Rodrigues",
    "Ezequiel",
    "Murillo Carvalho Victorio",
    "Rodrigo",
    "Ramon Menezes",
    "Luiz Felipe",
    "Nicolas",
    "Marcos Vinicius",
    "Lucas Ribeiro",
    "Silva",
    "Luis Fellipe",
    "Danilo Cunha",
    "Murilo Camara",
    "Assis",
    "Lucas Lima",
    "Juninho",
    "Gegê",
    "Wellington Rato",
    "Machado",
    "Lourenco",
    "Jean Carlos Alves Ferreira",
    "Guilherme Baldória",
    "Luquinhas",
    "Brayann",
    "Hygor",
    "Anselmo Ramon",
    "Pedrinho",
    "Esli Garcia",
    "Cadu",
    "Halerrandrio",
    "Kadu",
    "Willie"
  ],
  "Granada": [
    "Manu Lama",
    "Baila Diallo",
    "Pau Casadesús",
    "Diego Hormigo",
    "Oscar Naasei Oppong",
    "Rubén Alcaraz",
    "Pedro Alemañ",
    "Mario Jiménez Gambin",
    "José Arnaiz",
    "Jorge Pascual Medina",
    "Sergio Rodelas"
  ],
  "Grêmio": [
    "Weverton",
    "Gabriel Grando",
    "Thiago Stallbaum",
    "João Victor Castelo",
    "Gabriel Menegon",
    "Caio Paulista",
    "Wálter Kannemann",
    "Marcos Rocha",
    "Fabián Balbuena",
    "João Pedro",
    "Marlon",
    "Wagner Leonardo",
    "Gustavo Martins",
    "Diego Caito",
    "Wallace",
    "Pedro Gabriel",
    "Luis Eduardo",
    "Vitor Ramon",
    "Vagner",
    "Emanuel Mariano",
    "Willian",
    "Dodi",
    "Mathías Villasanti",
    "Juan Nardoni",
    "Erick Noriega",
    "Miguel Monsalve",
    "Leonel Pérez",
    "Riquelme Freitas",
    "Tiaguinho",
    "Bernardo Zortea",
    "Jeferson Forneck",
    "Roger",
    "João Borne",
    "Danillo",
    "Harlley",
    "Artur Junior",
    "Lago Menezes",
    "Adrielson",
    "Cristian Pavón",
    "Martin Braithwaite",
    "Jovane Cabral",
    "Carlos Vinícius",
    "Francis Amuzu",
    "José Enamorado",
    "Mateus Tetê",
    "Matheus Nascimento",
    "Gabriel Mec",
    "Arnaldo",
    "Lucca",
    "Benjamin",
    "Fellipe Magalhães"
  ],
  "Grenoble": [
    "Bobby Allain",
    "Alexandre Olliero",
    "Clément Vidal",
    "Allan Tchaptchet",
    "Farouq Limouri",
    "Mattheo Xantippe",
    "Nesta Zahui",
    "Efe Sarikaya",
    "Ange Loïc N’Gatta",
    "Mathieu Mion",
    "Sakhalou Niakaté",
    "Abdel Medroub",
    "Mael Corboz",
    "Yohann Magnin",
    "Lucas Bernadou",
    "Baptiste Mouazan",
    "Samba Diba",
    "Charlie Dressel",
    "Moussa Djitté",
    "Ugo Bonnet",
    "Dillion Hoogerwerf",
    "Mamady Bangré",
    "Yadaly Diaby",
    "Zé Leite",
    "Evans Maurin",
    "Arthur Lallias",
    "Mohamed Bechikh",
    "Kyliann Fofana"
  ],
  "Greuther Fürth": [
    "Christian Ortag",
    "Silas Prüfrock",
    "Florian Hellstern",
    "Jannick Dehm",
    "Gian-Luca Itter",
    "Jannis Heuer",
    "Noah Konig",
    "Maxim Dal",
    "Krisztián Keresztes",
    "Lukas Reich",
    "Felix Klaus",
    "Paul Will",
    "Shinta Appelkamp",
    "Doni Arifi",
    "Ole Pohlmann",
    "Omar Megeed",
    "Aaron Keller",
    "Philipp Muller",
    "Sacha Bansé",
    "Mika Wallentowitz",
    "Mehmet Avlayici",
    "Dennis Srbeny",
    "Omar Sillah"
  ],
  "Güemes": [
    "Leonardo Finochietto",
    "Laureano Lezcano",
    "Marcelo Benítez",
    "Alan González",
    "Facundo Melillan",
    "Axel Bordón",
    "Tomás Oneto",
    "Emilio Lazza",
    "Rodrigo Arnay",
    "Maico Quiróz",
    "David Veliz",
    "Walter Juárez",
    "Milton Gerez",
    "Santiago Farrera",
    "Julián Juárez",
    "Gianluca Pugliese",
    "Gaston Espósito",
    "Santiago Gabriel Sala"
  ],
  "Guingamp": [
    "Adrià Ortolá",
    "Teddy Bartouche",
    "Noah Marec",
    "Gaspard Messobo",
    "Erwin Koffi",
    "Akim Abdallah",
    "Jeovanni Dianganga",
    "Albin Demouchy",
    "Donatien Gomis",
    "Vimoj Muntu Wa Mungu",
    "Jérémie Matumona",
    "Nathan Fondja",
    "Dylan Lousierre",
    "Tom Ducrocq",
    "Darly Nlandu",
    "Florent Da Silva",
    "Amine Hemia",
    "Stanislas Kielt",
    "Tanguy Ahile",
    "Ibrahima Diakité",
    "Joël Matondo",
    "Samir Ben Brahim",
    "Ewan Aucan",
    "Gauthier Ott",
    "Amadou Samoura",
    "Teddy Averlant",
    "Jasser Chamakh",
    "Jean-Yves Djegou"
  ],
  "Hajer": [
    "Mohammed Al Maqhawi",
    "Hatem Aljuhani",
    "Jamal Al-Dhefiri",
    "Bakary Coulibaly",
    "Mubarak Al Dossary",
    "Mohammed Al Dossari",
    "Mohammed Dagriri",
    "Srdjan Spiridonovic",
    "Nikola Jambor",
    "Abderrahmane Bourdim",
    "Omar Almezael",
    "Mutair Al Zahrani",
    "Abdulkareem Maghrabi",
    "Hassen Jaaferi",
    "Hamad Al Quwayzani",
    "Mohammed Bin Suleiman Al Tofail",
    "Asaid Al Duhailan",
    "Ali Al Abdulsalam",
    "Nasser Al Khalifa",
    "Ammar Ahnmed",
    "Hussein Al Sheikh",
    "Clarence Bitang",
    "Yasser Al Musa",
    "Adriano Pardal",
    "Ronald Ngah",
    "Talal Majrashi",
    "Abdullah Khattab",
    "Abdulla Al Mubarak",
    "Nawaf Bo Amer"
  ],
  "Hamburg": [
    "Daniel Heuer Fernandes",
    "Sander Tangvik",
    "Fernando Dickes",
    "Miro Muheim",
    "Jordan Torunarigha",
    "Warmed Omari",
    "Louis Lemke",
    "Shafiq Nandja",
    "Bakery Jatta",
    "Albert Sambi Lokonga",
    "Nicolás Capaldo",
    "Immanuel Pherai",
    "Albert Grønbaek",
    "Nicolai Remberg",
    "Daniel Elfadli",
    "Yussuf Poulsen",
    "Jean-Luc Dompé",
    "Emir Sahiti",
    "Rayan Philippe",
    "Otto Stange",
    "Alexander Røssing-Lelesiit",
    "Fabio Baldé"
  ],
  "Hannover 96": [
    "Leo Weinkauf",
    "Pascal Loretz",
    "Jonas Schwanke",
    "Virgil Ghita",
    "Boris Tomiak",
    "Williams Kokolo",
    "Jean Hugonet",
    "Maurice Neubauer",
    "Bastian Allgeier",
    "Hayate Matsuda",
    "Ime Okon",
    "Yunus Ünal",
    "Joschua Caspar Siewert",
    "Waniss Taibi",
    "Stefán Teitur Thórdarson",
    "Franz Roggow",
    "Kolja Oudenne",
    "Lars Gindorf",
    "Noah Engelbreth",
    "Mwisho Mhango",
    "Alexander Vogel",
    "Mustapha Bundu",
    "Benjamin Kallman",
    "Benedikt Pichler",
    "Husseyn Chakroun",
    "Taycan Kurt",
    "Denis Husser",
    "Tom Hobrecht",
    "Taycan Macid Etcibasi"
  ],
  "Hellas Verona": [
    "Lorenzo Montipò",
    "Simone Perilli",
    "Giacomo Toniolo",
    "Mirko Castagnini",
    "Arthur Borghi",
    "Pol Lirola",
    "Martin Frese",
    "Domagoj Bradaric",
    "Daniel Oyegoke",
    "Andrias Edmundsson",
    "Tobias Slotsager",
    "Rafik Belghali",
    "William Feola",
    "Davide De Battisti",
    "Fallou Cham",
    "Andrej Popovic",
    "Jean-Daniel Akpa Akpro",
    "Roberto Gagliardini",
    "Suat Serdar",
    "Antoine Bernede",
    "Abdou Harroui",
    "Cheikh Niasse",
    "Tomás Suslov",
    "Luca Monticelli",
    "Luca Szimionas",
    "Ruben Akalé",
    "Jurgen Peci",
    "Daniel Mosquera",
    "Amin Sarr",
    "Ioan Vermesan",
    "Isaac"
  ],
  "Hertha": [
    "Marius Gersbeck",
    "Konstantin Heide",
    "Tim Goller",
    "Niklas Kolbe",
    "Deyovaiso Zeefuik",
    "Márton Dárdai",
    "Linus Gechter",
    "Julian Eitscberger",
    "Pascal Klemens",
    "Jerome Diallo",
    "Mayson Grothe",
    "Paul Seguin",
    "Kevin Sessa",
    "Leon Jensen",
    "Selim Telib",
    "Boris Lum",
    "Soufian Gouram",
    "Kian Leon Todoroviç",
    "Josip Brekalo",
    "Sebastian Gronning",
    "Jon Dagur Thorsteinsson",
    "Jan-Luca Schuler",
    "Marten Winkler",
    "Gustav Christensen",
    "Oluwaseun Adewumi",
    "Jelani Ndi",
    "Niklas Hildebrandt"
  ],
  "Hoffenheim": [
    "Oliver Baumann",
    "Luca Philipp",
    "Lúkas Petersson",
    "Vladimír Coufal",
    "Bernardo",
    "Koki Machida",
    "Ozan Kabak",
    "Valentin Gendrey",
    "Albian Hajdari",
    "Arthur Chaves",
    "Alexander Prass",
    "Robin Hranác",
    "Mats Rots",
    "Natnael Abraha",
    "Sean Dulic",
    "Wouter Burger",
    "Patrick Wimmer",
    "Bambasé Conté",
    "Umut Tohumcu",
    "Leon Avdullahu",
    "Luis Engelns",
    "Nathan De Cat",
    "Cajetan Lenz",
    "Andrej Kramaric",
    "Adam Hlozek",
    "Tim Lemperle",
    "Fisnik Asllani",
    "Max Moerstedt",
    "Deniz Zeitler",
    "Alessandro Vogt"
  ],
  "Holstein Kiel": [
    "Marcel Engelhardt",
    "Timon Weiner",
    "Lio Rothenhagen",
    "Ben Schmit",
    "Sebastian Schonlau",
    "John Tolkin",
    "David Zec",
    "Marko Ivezic",
    "Lasse Rosenboom",
    "Frederik Roslyng",
    "Hiroki Sekine",
    "Ivan Nekic",
    "Leon Parduzi",
    "Caspar Julius Medlin",
    "Jonas Meffert",
    "Guillermo Balzi",
    "Jonas Therkelsen",
    "Taisei Abe",
    "Kasper Davidsen",
    "Andu Kelati",
    "Hamza Muqaj",
    "Ikem Ugoh",
    "Tayar Tasdelen",
    "Moritz Reimers",
    "Till Wiese",
    "Mark Richter Montserrat",
    "Steven Skrzybski",
    "Giorgi Kvilitaia",
    "Alexander Bernhardsson",
    "Adrian Kapralik",
    "Phil Harres",
    "Faride Alidou",
    "Marcus Müller"
  ],
  "Houston Dynamo FC": [
    "Jonathan Bond",
    "Jimmy Maurer",
    "Blake Gillingham",
    "Antônio Carlos",
    "Erik Sviatchenko",
    "Franco Negri",
    "Sam Vines",
    "Lucas Halter",
    "Felipe Andrade",
    "Reese Miller",
    "Agustín Resch",
    "Vinicius Rodrigues Da Silva",
    "Héctor Herrera",
    "Duane Holmes",
    "Diadie Samassekou",
    "Agustín Bouzat",
    "Artur",
    "Ondrej Lingr",
    "Mateusz Bogusz",
    "Jack McGlynn",
    "Matthew Arana",
    "Ezequiel Ponce",
    "Ibrahim Aliyu",
    "Duncan McGuire",
    "Lawrence Ennali",
    "Nelson Quiñones",
    "Nicholas Markanich"
  ],
  "Hull City": [
    "Dillon Phillips",
    "John Egan",
    "Semi Ajayi",
    "Paddy McNair",
    "Lewie Coyle",
    "Ryan Giles",
    "Cody Drameh",
    "Matty Jacob",
    "Charlie Hughes",
    "Matt Crooks",
    "Kieran Dowell",
    "Regan Slater",
    "Eliot Matazo",
    "Darko Gyabi",
    "Oliver McBurnie",
    "Babajide David",
    "Liam Millar",
    "Enis Destan",
    "Mohamed Belloumi"
  ],
  "Huracán": [
    "Hernán Galíndez",
    "Sebastián Meza",
    "Nazareno Durán",
    "Hugo Nervo",
    "Nehuén Paz",
    "Lucas Carrizo",
    "Lucas Blondel",
    "Fabio Pereyra",
    "Federico Vera",
    "Cesar Ibañez",
    "Daniel Zabala",
    "Leandro Lescano",
    "Ignacio Campo",
    "Máximo Palazzo",
    "Martín Soto",
    "Fabrizio Martínez",
    "Leonardo Gil",
    "Rodrigo Fernández",
    "Óscar Romero",
    "Emmanuel Ojeda",
    "Facundo Waller",
    "Silvio Martínez",
    "Luca Babino",
    "Thaiel Peralta",
    "Facundo Kalinger",
    "Santino Raynelli",
    "Ignacio Pussetto",
    "Jordy Caicedo",
    "Juan Bisanz",
    "Oscar Cortés",
    "Lautaro Mora",
    "Tomás Natanael Uribe Sanders"
  ],
  "Huracán FC": [
    "Nicolás Gentilio",
    "Aarón Soria",
    "Maximiliano Barrios",
    "Alejandro Moreira",
    "Joaquín Machado",
    "Federico Alonso",
    "Felipe Celli",
    "Emiliano García",
    "Leonardo Osorio",
    "Julián Pedrosa",
    "Axel Müller",
    "Joaquín Robatto",
    "Jairo Coronel",
    "Facundo Greno",
    "Iván Salazar",
    "Maximiliano Rodríguez",
    "Franco Mederos",
    "Maximiliano Lombardi",
    "Santiago Syzard",
    "Facundo Silvera",
    "Anthony Cutti",
    "David Juárez",
    "Rodrigo Rey",
    "Mateo Aramburu",
    "Joaquín Gómez Mattar"
  ],
  "Independiente": [
    "Rodrigo Rey",
    "Joaquín Blázquez",
    "Leonardo Godoy",
    "Juan Fedorco",
    "Kevin Lomónaco",
    "Facundo Zabala",
    "Jonathan De Irastorza",
    "Gonzalo Bordón",
    "Fernando Closter",
    "Luciano Barros",
    "Juan Migue Arrayago",
    "Santiago Arias",
    "Sebastián Valdez",
    "Iván Marcone",
    "Luciano Cabral",
    "Mateo Pérez",
    "Ruben Martinez",
    "Tomás Parmo",
    "Lautaro Millán",
    "Joel Medina",
    "Josias Palais",
    "Facundo Lionel Cruz",
    "Maximiliano Meza",
    "Gabriel Ávalos",
    "Maximiliano Gutiérrez",
    "Imanol Machuca",
    "Santiago Montiel",
    "Matías Abaldo",
    "Facundo Valdéz",
    "Simón Bodnar",
    "Felipe Tempone"
  ],
  "Independiente Rivadavia": [
    "Ramiro Macagno",
    "Emmanuel Gómez Riga",
    "Nicolás Bolcato",
    "Fernando Bravo",
    "Kevin Pagliaroli",
    "Alexander Lucero",
    "Ezequiel Bonifacio",
    "Luciano Gómez",
    "Juan Manuel Elordi",
    "Ivan Villalba",
    "Sheyko Studer",
    "Alejo Osella",
    "Leonard Costa",
    "Santiago Cena",
    "Matías Salvo",
    "Amaro Maya",
    "Tiago Sosa",
    "Matías Fernández",
    "Luis Sequeira",
    "José Florentín",
    "Kevin Vázquez",
    "Sebastian Muñoz",
    "Leonel Bucca",
    "Diego Crego",
    "Tomás Bottari",
    "Stefano Moreyra",
    "Gonzalo Rios",
    "Alessandro Riep",
    "Alex Aguado",
    "Tobías Ganduglia",
    "Facundo Ortiz",
    "Tomas Arias",
    "Agustín Domínguez",
    "Benjamín Olivarez",
    "Agustín Rognoni",
    "Julian Reyna",
    "Victorio Ramis",
    "Maximiliano Salas",
    "Alex Arce",
    "Fabrizio Sartori Prieto",
    "Rodrigo Atencio",
    "Luis Díaz",
    "Lautaro Torres",
    "Luciano Sábato",
    "Axel Leiva",
    "Román Ruíz",
    "Jan Díaz Inzirillo"
  ],
  "Inglaterra": [
    "Jordan Pickford",
    "Dean Henderson",
    "James Trafford",
    "John Stones",
    "Reece James",
    "Dan Burn",
    "Trevoh Chalobah",
    "Ezri Konsa",
    "Marc Guéhi",
    "Djed Spence",
    "Jarell Quansah",
    "Nico O'Reilly",
    "Jordan Henderson",
    "Declan Rice",
    "Elliot Anderson",
    "Eberechi Eze",
    "Morgan Rogers",
    "Jude Bellingham",
    "Kobbie Mainoo",
    "Harry Kane",
    "Ivan Toney",
    "Ollie Watkins",
    "Marcus Rashford",
    "Anthony Gordon",
    "Bukayo Saka",
    "Noni Madueke"
  ],
  "Instituto": [
    "Marcos Ledesma",
    "Emanuel Sittaro",
    "Raúl Maldonado",
    "Diego Sosa",
    "Jonathan Galván",
    "Fernando Alarcón",
    "Leonel Mosevich",
    "Hernán De La Fuente",
    "Iván Erquiaga",
    "Agustín Bravo",
    "Juan Meli",
    "Giuliano Cerato",
    "Agustín Massaccesi",
    "Genaro Ordóñez",
    "Alex Luna",
    "Juan Mendez",
    "Jhon Córdoba",
    "Gustavo Abregú",
    "Franco Moyano",
    "Jonás Acevedo",
    "Gastón Lodico",
    "Matías Gallardo",
    "Jeremías Lázaro",
    "Ignacio Rossi",
    "Joaquín Medina",
    "Pedro Baster",
    "Augusto Coronel",
    "Matias Tissera",
    "Nicolás Guerra",
    "Facundo Suárez",
    "Matias Fonseca",
    "Lorenzo Albarracín",
    "Luca Rafaelli"
  ],
  "Inter Miami CF": [
    "Dayne St. Clair",
    "Luis Barraza",
    "Rocco Ríos Novo",
    "Sergio Reguilón",
    "Facundo Mura",
    "Maximiliano Falcón",
    "Micael",
    "Gonzalo Luján",
    "Ian Fray",
    "Noah Allen",
    "Israel Boatwright",
    "Tyler Hall",
    "Cesar Abadia-Reda",
    "Daniel Sumalla",
    "Fricio Caicedo",
    "Santiago Morales",
    "Casemiro",
    "Rodrigo De Paul",
    "David Ayala",
    "Telasco Segovia",
    "Yannick Bright",
    "Joseph Convers",
    "Ian Urkidi",
    "Preston Plambeck",
    "Alexander Shaw",
    "David Ruiz",
    "Lionel Messi",
    "Luis Suárez",
    "Germán Berterame",
    "Tadeo Allende",
    "Lovens Delinois",
    "Mateo Silvetti",
    "Dániel Pintér",
    "Diego Rey"
  ],
  "Inter Milan": [
    "Raffaele Di Gennaro",
    "Josep Martínez",
    "Matteo Farronato",
    "Federico Dimarco",
    "Manuel Akanji",
    "Benjamin Pavard",
    "Alessandro Bastoni",
    "Yann Bisseck",
    "Carlos Augusto",
    "Mattia Marello",
    "Henrikh Mkhitaryan",
    "Hakan Çalhanoglu",
    "Piotr Zielinski",
    "Nicolò Barella",
    "Davide Frattesi",
    "Kristjan Asllani",
    "Andy Diouf",
    "Petar Sucic",
    "Luka Topalovic",
    "Marcus Thuram",
    "Lautaro Martínez",
    "Luis Henrique",
    "Ange-Yoan Bonny",
    "Pio Esposito",
    "Matteo Lavelli",
    "Mattia Mosconi"
  ],
  "Internacional": [
    "Sergio Rochet",
    "Matheus Cunha Queiroz",
    "Anthoni",
    "Kauan",
    "Diego Esser",
    "Filipe Borba Sirio",
    "Gabriel Mercado",
    "Guillermo Maripán",
    "Juninho",
    "Félix Torres",
    "Alexander Bernabei",
    "Matheus Bahia",
    "Victor Gabriel",
    "Clayton",
    "Pedro Kauã",
    "Alisson",
    "Denis Marfo",
    "Luiz Felipe De Morais Francisco",
    "Alan Patrick",
    "Bruno Henrique",
    "Richard",
    "Thiago Maia",
    "Ronaldo",
    "Rodrigo Villagra",
    "Paulinho",
    "Bruno Gomes",
    "Calebe",
    "Allex",
    "Kauan Alves",
    "Benjamin Arhin",
    "João Kempes",
    "Gabriel Vinicius Oliveira Da Silva",
    "Brian Aguirre",
    "Johan Carbonero",
    "Alerrando",
    "Vitinho",
    "Kayky Chagas",
    "Yago",
    "João Victor",
    "Raykkonen",
    "João Bezerra",
    "Fabricio Prado"
  ],
  "Ipswich Town": [
    "David Button",
    "Christian Walton",
    "Alex Palmer",
    "Ben Johnson",
    "Darnell Furlong",
    "Dara O'Shea",
    "Cedric Kipre",
    "Leif Davis",
    "Jacob Greaves",
    "Harrison Clarke",
    "Jack Taylor",
    "Cameron Humphreys",
    "Azor Matusiwa",
    "Marcelino Núñez",
    "Kasey McAteer",
    "Anis Mehmeti",
    "Chuba Akpom",
    "Chiedozie Ogbene",
    "George Hirst",
    "Jack Clarke",
    "Jaden Philogene",
    "Sindre Walle Egeli",
    "Ali Al-Hamadi"
  ],
  "Italia": [
    "Gianluigi Donnarumma",
    "Lorenzo Palmisani",
    "Giovanni Daffara",
    "Fabio Chiarodia",
    "Davide Bartesaghi",
    "Costantino Favasuli",
    "Pietro Comuzzo",
    "Niccolò Fortini",
    "Filippo Mané",
    "Honest Ahanor",
    "Luca Reggiani",
    "Tommaso Berti",
    "Giacomo Faticanti",
    "Luca Lipani",
    "Cher Ndour",
    "Niccolò Pisilli",
    "Matteo Dagasso",
    "Luca Koleosho",
    "Seydou Fini",
    "Pio Esposito",
    "Francesco Camarda",
    "Jeff Ekhator",
    "Alessio Cacciamani",
    "Samuele Inácio"
  ],
  "Jeddah": [
    "Yasser Al-Mosailem",
    "Abdulaziz Al-Tekrouni",
    "Fares Al-Juhani",
    "Abdulrahman Al Humayri",
    "Rayan Bakhashwain",
    "Faisal Othman",
    "Fahad Al-Sahafi",
    "Ahmed Al Shamrani",
    "Wesam Al Hawsawi",
    "Kevin Kennedy",
    "Faisal Al Dhubyani",
    "Giorgi Aburjania",
    "Yousef Alharbi",
    "Abdullah bin Burayh",
    "Rayan Al Harbi",
    "Yasser Al Musa",
    "Hazaa Al Asiri",
    "Rafi Matmi",
    "Muhammad Al Hussein",
    "Abdullah Al Amoudi",
    "Mohamed Rageh",
    "Walmerson Garcia Praia",
    "Mohammed Al-Harthi",
    "Bonfils-Caleb Bimenyimana",
    "Abdullah Bader Mahbub",
    "Hussain Al-Meani",
    "Al Baraa Baazeem",
    "Hassan Mukhtar",
    "Jawad Haidar",
    "Muhammad Ibrahim"
  ],
  "Juve Stabia": [
    "Alessandro Confente",
    "Pietro Boer",
    "Antonio Vetro",
    "Marco Bellich",
    "Omar Correia",
    "Nicola Mosti",
    "Emanuele Torrasi",
    "Thomas Battistella",
    "Christian Pierobon",
    "Leonardo Candellone",
    "Matheus dos Santos"
  ],
  "Juventud Las Piedras": [
    "Sebastián Sosa",
    "Fabrizio Correa",
    "Nicolás Ruotola",
    "Manuel Idiarte",
    "Martín Cáceres",
    "Emmanuel Más",
    "Federico Barrandeguy",
    "Patricio Pernicone",
    "Kevin Rolon",
    "Franco Risso",
    "Renzo Rabino",
    "Angel Morosini",
    "Ignacio Mujica",
    "Diego Simoes",
    "Valentin Barrios Figueredo",
    "Lucas Agustín Pérez Álvarez",
    "Mauricio Rodríguez Luján",
    "Gastón Pereiro",
    "Emanuel Cecchini",
    "Ramiro Peralta",
    "Rodrigo Chagas",
    "Leonel Roldán",
    "Facundo Pérez",
    "Pablo Lago",
    "Gonzalo Gómez",
    "Alejo Cruz Techera",
    "Bruno Arady",
    "Agustín Alaniz",
    "Fernando Mimbacas",
    "Bruno Larregui",
    "Juan Martín Boselli",
    "Facundo Domínguez"
  ],
  "Juventude": [
    "Pedro",
    "Jandrei",
    "Ruan",
    "Zé Henrique",
    "Titi",
    "Alan Ruschel",
    "Diogo Barbosa",
    "Messias",
    "Rodrigo Sam",
    "Aderlan Silva",
    "Raí Ramos",
    "Gabriel",
    "Patryck",
    "Nathan",
    "Marcos Paulo",
    "Wadson",
    "Iba Ly",
    "Mateus Gabriel Schaffer",
    "Luan Martins Gonçalves",
    "Bernardo",
    "Kaua",
    "Kauê",
    "Lucas Mineiro",
    "Pablo",
    "Luis Mandaca",
    "Raí",
    "Davi Goes",
    "João Victor Trevisol Da Silva",
    "Luiz Henrique",
    "Kaynan Fragoso Azevedo",
    "Luis Amarilla",
    "Alan Kardec",
    "Manuel Castro",
    "Lucas Alves",
    "Safira",
    "Allanzinho",
    "Ray",
    "Fábio Lima",
    "João Scatolin",
    "Carlinhos"
  ],
  "Juventus": [
    "Carlo Pinsoglio",
    "Mattia Perin",
    "Michele Di Gregorio",
    "Juan Cabal",
    "Daniele Rugani",
    "Lloyd Kelly",
    "Bremer",
    "Pierre Kalulu",
    "Andrea Cambiaso",
    "Federico Gatti",
    "Javier Gil",
    "Arthur",
    "Manuel Locatelli",
    "Weston McKennie",
    "Teun Koopmeiners",
    "Khéphren Thuram",
    "Douglas Luiz",
    "Fabio Miretti",
    "Arkadiusz Milik",
    "Jérémie Boga",
    "Randal Kolo Muani",
    "Edon Zhegrova",
    "Jonathan David",
    "Francisco Conceição",
    "Kenan Yildiz",
    "Destiny Elimoghale",
    "Arman Durmiši"
  ],
  "Kaiserslautern": [
    "Julian Krahl",
    "Enis Kamga",
    "Yannick Onohiol",
    "Jacob Rasmussen",
    "Ivan Knežević",
    "Erik Wekesser",
    "Simon Asta",
    "Maxwell Gyamfi",
    "Jan Elvedi",
    "Paul Joly",
    "Mika Haas",
    "Kelven Frees",
    "Thierry Fidjeu-Tazemeta",
    "Marlon Ritter",
    "Naatan Skyttä",
    "Fabian Kunze",
    "Semih Sahin",
    "Leon Robinson",
    "Dion Hofmeister",
    "Erik Muller",
    "Owen Gibs",
    "David Schramm",
    "Ben Jungfleisch",
    "Kian Scheer",
    "Ivan Prtajin",
    "Mergim Berisha",
    "Erencan Yardimci",
    "Ibrahim Kanate"
  ],
  "Karlsruher SC": [
    "Robin Himmelmann",
    "Hans Christian Bernat",
    "Ferdinand Gebert",
    "Sebastian Jung",
    "Marcel Franke",
    "Christoph Kobald",
    "Viktor Bergh",
    "Rafael Pedrosa",
    "Marc Niclas Dühring",
    "Paul Scholl",
    "Deniz Ofli",
    "Marvin Wanitzek",
    "Santeri Vaananen",
    "Tim Civeja",
    "Lilian Egloff",
    "Kevin Wiethaup",
    "Kwon Hyeok-Kyu",
    "Louey Farhat",
    "Danyal Zor",
    "Moritz Broschinski",
    "Shio Fukuda",
    "Noel Eichinger",
    "Eymen Laghrissi",
    "Jason Manuel Ponente Ramirez",
    "John Davis Meyer"
  ],
  "LA Galaxy": [
    "JT Marcinkowski",
    "Brady Scott",
    "Novak Micovic",
    "Maya Yoshida",
    "Carlos Garcés",
    "Jose Magana",
    "John Nelson",
    "Jakob Glesnes",
    "Miki Yamane",
    "Chris Rindov",
    "Julián Aude",
    "Riley Dalgado",
    "Harbor Miller",
    "Marco Reus",
    "Erik Thommy",
    "Lucas Sanabria",
    "Ricard Puig",
    "Justin Haak",
    "Elijah Wynder",
    "Isaiah Parente",
    "Dylan Vanney",
    "Troy Elgersma",
    "Rúben Ismael",
    "João Klauss",
    "Robert Taylor",
    "Joseph Paintsil",
    "Julian Placias"
  ],
  "La Luz": [
    "Nicolás Forastiero",
    "Lusiel Gómez",
    "Facundo Méndez",
    "Nahuel Pintado",
    "Germán Peralta",
    "Francisco Martirena",
    "Tadeo Aguiar",
    "Nicolás Rodríguez",
    "Alejandro Prieto",
    "Germán Gabriel",
    "Mathías Pintos",
    "Gabriel de León",
    "Jonathan Baeza",
    "Joaquín Gottesman",
    "Jonathan Barboza",
    "Pablo Porcile",
    "Diego Vicente",
    "Matías Silva",
    "Luca Barreto",
    "Lucas Suárez",
    "Gonzalo Vega",
    "Facundo Sosa",
    "Nahuel Albano",
    "Lucas Pias",
    "Nicolás Sosa",
    "Delis Vargas",
    "Manuel Núñez",
    "Juan Facundo Crisafi",
    "Federico Millacet",
    "Federico Rodríguez",
    "Maximiliano Brito"
  ],
  "LAFC": [
    "Hugo Lloris",
    "Thomas Hasal",
    "Cabral Carter",
    "Ryan Hollingshead",
    "Eddie Segura",
    "Aaron Long",
    "Sergi Palencia",
    "Ryan Porteous",
    "Yevhen Cheberko",
    "Nkosi Tafari",
    "Kenny Nielsen",
    "Mark Delgado",
    "Timothy Tillman",
    "Mathieu Choinière",
    "Ryan Raposo",
    "Igor Jesus",
    "Jude Terry",
    "David Martínez",
    "Son Heung-Min",
    "Tyler Boyd",
    "Denis Bouanga",
    "Jeremy Ebobisse",
    "Jacob Shaffelburg",
    "Sebastian Nava",
    "Tommy Mihalic",
    "Marius Aiyenero"
  ],
  "Lanús": [
    "Nahuel Losada",
    "Franco Petroli",
    "Evaristo Dieguiz",
    "Martín Díaz",
    "Tomás Silva",
    "Gonzalo Pérez",
    "Carlos Izquierdoz",
    "Luciano Romero",
    "José Canale",
    "Tomás López",
    "Tomás Guidara",
    "Nicolás Morgantini",
    "Sasha Marcich",
    "Ronaldo de Jesus",
    "Sebastián Leiva",
    "Óctavio Ontívero",
    "Facunda Sánchez",
    "Tobías Quiroz",
    "Mateo Ramírez",
    "Elian Acosta",
    "Elías Prieto",
    "Gabriel Aguirre",
    "Juan Mujica",
    "Felipe Peña",
    "Eduardo Salvio",
    "Matías Sepúlveda",
    "Ramiro Carrera",
    "Raúl Loaiza",
    "Marcelino Moreno",
    "Agustín Cardozo",
    "Franco Watson",
    "Ian López",
    "Mariano Gerez",
    "Thiago Laplace",
    "Agustín Medina",
    "Tiago Domínguez",
    "Walter Bou",
    "Alexis Duarte",
    "Allan Wlk",
    "Lucas Besozzi",
    "Mateo Peralta",
    "Dylan Aquino",
    "Benjamín Acosta",
    "Thiago Balbuena",
    "Jeremías Chavero",
    "Thomás De Martis",
    "Yoshan Valois",
    "Gonzalo Lobos",
    "Dante Blanco"
  ],
  "Las Palmas": [
    "Caro",
    "Dinko Horkas",
    "Adri Suárez",
    "Álex Suárez",
    "Enrique Clemente",
    "Marvin",
    "Juanma Herzog",
    "Valentín Pezzolesi",
    "Viti",
    "Enzo Loiodice",
    "Kirian Rodríguez",
    "Manu Fuster",
    "Ale García",
    "Iñaki González",
    "Jeremía Recoba",
    "Jesé",
    "Sandro",
    "Adam Arvelo"
  ],
  "Lazio": [
    "Christos Mandas",
    "Alessio Furlanetto",
    "Davide Renzetti",
    "Edoardo Motta",
    "Patric",
    "Alessio Romagnoli",
    "Samuel Gigot",
    "Adam Marusic",
    "Alfonso Pedraza",
    "Danilho Doekhi",
    "Luca Pellegrini",
    "Nuno Tavares",
    "Romano Floriani",
    "Oliver Provstgaard",
    "Danilo Cataldi",
    "Mattia Zaccagni",
    "Manuel Lazzari",
    "Kenneth Taylor",
    "Nicolò Rovella",
    "Fisayo Dele-Bashiru",
    "Reda Belahyane",
    "Adrian Przyborek",
    "Boulaye Dia",
    "Gustav Isaksen",
    "Matteo Cancellieri",
    "Tijjani Noslin",
    "Petar Ratkov"
  ],
  "Le Havre": [
    "Mory Diaw",
    "Lionel Mpasi",
    "Paul Argney",
    "Vincent Sasso",
    "Gautier Lloris",
    "Ayumu Seko",
    "Timothee Pembélé",
    "Fodé Doucouré",
    "Yanis Zouaoui",
    "Stephan Zagadou",
    "Abdoulaye Touré",
    "Rassoul Ndiaye",
    "Kaito Mizuta",
    "Simon Ebonog",
    "Mokrane Bentoumi",
    "Ismail Bouneb",
    "Daren Mosengo",
    "Guy Zohouri",
    "Mbwana Samatta",
    "Godson Kyeremeh",
    "Félix Mambimbi",
    "Andy Logbo",
    "Noam Obougou",
    "Enzo Koffi"
  ],
  "Le Mans": [
    "Nicolas Kocik",
    "Ewan Hatfout",
    "Augustin Delbecque",
    "Samuel Yohou",
    "Lucas Buades",
    "Alexandre Lauray",
    "Yasser Larouci",
    "Lucas Calodat",
    "Harold Voyer",
    "Théo Eyoum",
    "Noa Boissé",
    "Edwin Quarshie",
    "Jean Vercruysse",
    "Lucas Bretelle",
    "Milan Robin",
    "Martin Rossignol",
    "Antoine Rabillard",
    "Dame Guèye",
    "Bilal Brahimi",
    "Erwan Colas",
    "William Harhouz",
    "Adil Bourabaa"
  ],
  "Lecce": [
    "Wladimiro Falcone",
    "Jasper Samooja",
    "Plamen Penev",
    "Christian Lupo",
    "Antonino Gallo",
    "Corrie Ndaba",
    "Jamil Siebert",
    "Kialonda Gaspar",
    "Danilo Veiga",
    "Gaby Jean",
    "Tiago Gabriel",
    "Matías Pérez",
    "Vernon Addo",
    "Owen Kouassi",
    "Marlon Nnamdi Ubani",
    "Lassana Coulibaly",
    "Youssef Maleh",
    "Lameck Banda",
    "Sadik Fofana",
    "Omri Gandelman",
    "Oumar Ngom",
    "Medon Berisha",
    "Olaf Gorter",
    "Niko Kovac",
    "Mohamed Kaba",
    "Willem Geubbels",
    "Konan N’Dri",
    "Santiago Pierotti",
    "Nikola Stulic",
    "Hjalte Morel Lærke",
    "Divine Onyemachi",
    "Francisco Esteban Sánchez"
  ],
  "Leeds United": [
    "Alex Cairns",
    "Lucas Perri",
    "Sam Byram",
    "James Justin",
    "Joe Rodon",
    "Jayden Bogle",
    "Gabriel Gudmundsson",
    "Sebastiaan Bornauw",
    "Jaka Bijol",
    "Ilia Gruev",
    "Ethan Ampadu",
    "Sean Longstaff",
    "Ao Tanaka",
    "Brenden Aaronson",
    "Anton Stach",
    "Sam Chambers",
    "Dominic Calvert-Lewin",
    "Daniel James",
    "Joël Piroe",
    "Lukas Nmecha",
    "Noah Okafor",
    "Wilfried Gnonto"
  ],
  "Leganés": [
    "Raúl Fernández",
    "Juan Soriano",
    "Gonzalo Aguilar",
    "Ignasi Miquel",
    "Rubén Peña",
    "Álvaro Tejero",
    "Javi Hernández",
    "Enric Franquesa",
    "Ruben Pulido Peñas",
    "Marvel",
    "Gonzalo Melero",
    "Dani Rodríguez",
    "Amadou Diawara",
    "Miguel Atienza",
    "Zico Buurmeester",
    "Roberto López",
    "Yassine Kechta",
    "Marcos Leiva",
    "Álex Millán",
    "Ismaël Gharbi",
    "Naim García",
    "Benjamin Pauwels",
    "Andrés Campos",
    "David Osei",
    "Alfred Gøthler"
  ],
  "Lens": [
    "Régis Gurtner",
    "Mathieu Gorgelin",
    "Robin Risser",
    "Ilan Jourdren",
    "Ruben Aguilar",
    "Jonathan Gradit",
    "Matthieu Udol",
    "Saud Abdulhamid",
    "Maik Nawrocki",
    "Jhoanner Chavez",
    "Samson Baidoo",
    "Pierre Ganiou",
    "Nidal Celik",
    "Kyllian Antonio",
    "Souleymane Sagnan",
    "Thorgan Hazard",
    "Amadou Haidara",
    "Michaël Cuisance",
    "Alpha Diallo",
    "Andrija Bulatovic",
    "Florian Thauvin",
    "Florian Sotoca",
    "Odsonne Édouard",
    "Michal Skoras",
    "Abdallah Sima",
    "Rayan Fofana"
  ],
  "Levante": [
    "Pablo Cuñat",
    "Alejandro Primo",
    "Jeremy Toljan",
    "Víctor García",
    "Unai Elgezabel",
    "Adrián de la Fuente",
    "Jorge Cabello",
    "Nacho Pérez",
    "Carlos Álvarez",
    "Kervin Arriaga",
    "Roger Brugué",
    "Orio Rey",
    "Jon Ander Olasagasti",
    "Iván Romero",
    "Tai Abed",
    "Etta Eyong",
    "Paco Cortés",
    "Kareem Tunde"
  ],
  "Lille": [
    "Marc-Aurele Caillard",
    "Arnaud Bodart",
    "Berke Özer",
    "Calvin Verdonk",
    "Romain Perraud",
    "Tanguy Nianzou",
    "Nathan Ngoy",
    "Alexsandro",
    "Tiago Santos",
    "Ousmane Toure",
    "Loun Srdanovic",
    "Isaac Cossier",
    "Benjamin André",
    "Nabil Bentaleb",
    "Hákon Haraldsson",
    "Ngal'ayel Mukau",
    "Ethan Mbappé",
    "Ayyoub Bouaddi",
    "Olivier Giroud",
    "Gaetan Perrin",
    "Mohamed Bayo",
    "Osame Sahraoui",
    "Felix Correia",
    "Marius Broholm",
    "Basar Önal",
    "Hamza Igmane",
    "Matias Fernandez-Pardo",
    "Noah Edjouma"
  ],
  "Lincoln City": [
    "George Wickens",
    "James Pardington",
    "Sonny Bradley",
    "Adam Jackson",
    "Tendayi Darikwa",
    "Thomas Hamer",
    "Ryley Towler",
    "Ayodeji Elerewe",
    "Andrei Coubis",
    "Charlie Parks",
    "Joshua Honohan",
    "Adam Reach",
    "Conor McGrandles",
    "Recco Hackett-Fairchild",
    "Tom Bayliss",
    "Dom Jefferies",
    "Ivan Varfolomeev",
    "James Collins",
    "Ben House",
    "Freddie Draper",
    "Robert Street",
    "Oscar Thorn",
    "Mason Melia"
  ],
  "Liverpool": [
    "Freddie Woodman",
    "Alisson Becker",
    "Giorgi Mamardashvili",
    "Vitezslav Jaros",
    "Harvey Davies",
    "Luke Chambers",
    "Joe Gomez",
    "Virgil van Dijk",
    "Kostas Tsimikas",
    "Conor Bradley",
    "Ronald Araújo",
    "Jeremie Frimpong",
    "Calvin Ramsay",
    "Milos Kerkez",
    "Jérémy Jacquet",
    "Calum Scanlon",
    "Giovanni Leoni",
    "Ifeanyi Ndukwe",
    "Talla Ndiaye",
    "Wataru Endo",
    "Curtis Jones",
    "Alexis Mac Allister",
    "Dominik Szoboszlai",
    "Ryan Gravenberch",
    "Harvey Elliott",
    "Florian Wirtz",
    "James McConnell",
    "Stefan Bajcetic",
    "Trey Nyoni",
    "Kieran Morrison",
    "Federico Chiesa",
    "Alexander Isak",
    "Cody Gakpo",
    "Hugo Ekitike",
    "Lewis Koumas",
    "Rio Ngumoha",
    "Will Wright",
    "Joshua Lambie",
    "Joshua Abe"
  ],
  "Liverpool Montevideo": [
    "Martín Campaña",
    "Mathias Bernatene",
    "Rafael Hornos",
    "Diego Cabrera",
    "Lucas Acosta",
    "Enzo Castillo",
    "Jean Pierre Rosso",
    "Santiago Laquidaín",
    "Facundo Perdomo",
    "Agustín Cayetano",
    "Kevin Amaro",
    "Lucas Fraga",
    "Santiago Strasorier",
    "Jorge Castillo",
    "Matias Mir",
    "Diego Zabala",
    "Kevin Lewis",
    "Nicolás Garayalde",
    "Santiago Milano",
    "Diego Romero",
    "Ezequiel Olivera",
    "Gonzalo De Mello",
    "Pablo Barreiro",
    "Federico Martínez",
    "Rubén Betancourt",
    "Facundo Barceló",
    "Renzo Machado",
    "Mateo Telechea",
    "Ramiro Degregorio",
    "Felipe Barrenechea",
    "Thiago Brizuela"
  ],
  "Londrina": [
    "Mauricio Kozlinski",
    "Luan",
    "Zanella",
    "Nino Paraíba",
    "Artur",
    "Wallace Reis",
    "Kevyn",
    "Weverton",
    "Heron",
    "Gabriel Lacerda",
    "André Dhominique",
    "Rafael Monteiro",
    "Yago Lincoln Rocha Santos",
    "Kauê Leonardo",
    "Caio",
    "Richarlyson Covre De Mello",
    "Tarik",
    "Lucas Marques",
    "Thalis",
    "Guilherme Maciel Dantas",
    "João Vitor",
    "Murilo Sousa",
    "André Cardoso",
    "Chumbinho",
    "Fabiano",
    "Cainã",
    "William Pottker",
    "Paulinho",
    "Gilberto",
    "Pablo Dyego",
    "Rai Nascimento",
    "Caio Maia",
    "Vitinho Mota",
    "Edivan Juninho",
    "Kauã Jonathan",
    "Fabricio"
  ],
  "Lorient": [
    "Benjamin Leroy",
    "Yvon Mvogo",
    "Bingourou Kamara",
    "Formose Mendy",
    "Alec Georgen",
    "Montassar Talbi",
    "Isaak Touré",
    "Nathaniel Adjei",
    "Dembo Sylla",
    "Panos Katseris",
    "Enzo Genton",
    "Arsène Kouassi",
    "Jean-Victor Makengo",
    "Bandiougou Fadiga",
    "Noah Cadiou",
    "Joel Mvuka",
    "Théo Le Bris",
    "Arthur Avom",
    "Gabin Bernardeau",
    "Mohamed Bamba",
    "Tosin Aiyegun"
  ],
  "Los Andes": [
    "Sebastián López",
    "Javier Bustillos",
    "Marko Brey",
    "Julian Rodriguez",
    "Daniel Franco",
    "Julián Navas",
    "Gabriel Carrasco",
    "Nazareno Fernandez Colombo",
    "Brian Leizza",
    "Peter Martínez Grance",
    "Cristian Linares",
    "Benjamin Garay",
    "Gonzalo Cozzoni",
    "Franco Rodriguez",
    "Aaron Sandoval",
    "Juan Manuel Vazquez",
    "Gabriel Cañete",
    "Tomás Díaz",
    "Sergio Ortíz",
    "Matias Gomez",
    "Facundo Villarreal",
    "Leandro Alegre",
    "Thiago Cicerone",
    "Mauricio Asenjo",
    "Tomás Blanco",
    "Mario Galeano",
    "Matías Gonzalez",
    "Camilo Viganoni"
  ],
  "Lyon": [
    "Lassine Diarra",
    "Dominik Greif",
    "Rémy Descamps",
    "Yvann Konan",
    "Nicolás Tagliafico",
    "Moussa Niakhaté",
    "Clinton Mata",
    "Abner",
    "Ruben Kluivert",
    "Mohamed Ouédraogo",
    "Noham Kamara",
    "Steeve Kango",
    "Corentin Tolisso",
    "Ainsley Maitland-Niles",
    "Mads Bidstrup",
    "Tyler Morton",
    "Tanner Tessmann",
    "Pavel Sulc",
    "Noah Nartey",
    "Mathys De Carvalho",
    "Khalis Merah",
    "Loïs Openda",
    "Ernest Nuamah",
    "Malick Fofana",
    "Julien Duranville",
    "Kail Boudache",
    "Alejandro Rodríguez",
    "Rémi Himbert"
  ],
  "Mainz": [
    "Robin Zentner",
    "Stefan Bell",
    "Danny da Costa",
    "Silvan Widmer",
    "Andreas Hanche-Olsen",
    "Phillipp Mwene",
    "Anthony Caci",
    "Kacper Potulski",
    "Fabio Gruber",
    "Lee Jae-Sung",
    "Dominik Kohr",
    "Nadiem Amiri",
    "Marco Richter",
    "Lennard Maloney",
    "Hong Hyun-Seok",
    "Eric Martel",
    "Paul Nebel",
    "Sota Kawasaki",
    "Kaishu Sano",
    "Sheraldo Becker",
    "Phillip Tietz",
    "Silas Katompa-Mvumpa",
    "William Bøving",
    "Benedict Hollerbach"
  ],
  "Málaga": [
    "Alfonso Herrero",
    "Carlos López",
    "Andres Cespedes",
    "Alejandro Mateos Guirado",
    "Einar Galilea",
    "Dani Sánchez",
    "Ángel Recio",
    "Carlos Puga",
    "Diego Murillo",
    "Pablo Arriaza",
    "Óscar González",
    "Rafa Garrido",
    "Juampe",
    "Ramón Enríquez",
    "Daniel Lorenzo",
    "Rafa Rodríguez",
    "Izan Merino",
    "Aarón Moloney",
    "Joseph Otunenche Otu",
    "Joaquín Muñoz",
    "Eneko Jauregui",
    "David Larrubia",
    "Julen Lobete",
    "Haitam Abaida",
    "Adrián Niño",
    "Chupete",
    "Juan Francisco Fernández Martin"
  ],
  "Mallorca": [
    "Iván Cuéllar",
    "Lucas Bergstrom",
    "Johan Mojica",
    "Martin Valjent",
    "Antonio Raíllo",
    "Toni Lato",
    "Mateu Morey",
    "David López",
    "Sergi Darder",
    "Pablo Torre",
    "Manu Morlanes",
    "Antonio Sánchez",
    "Jan Salas",
    "Abdón Prats",
    "Zito Luvumbo",
    "Justin-Noel Kalumba"
  ],
  "Manchester City": [
    "Marcus Bettinelli",
    "Gianluigi Donnarumma",
    "Rúben Dias",
    "Marc Guéhi",
    "Rayan Aït-Nouri",
    "Issa Kaboré",
    "Finley Burns",
    "Josko Gvardiol",
    "Josh Wilson-Esbrand",
    "Rico Lewis",
    "Nico O'Reilly",
    "Max Alleyne",
    "Vitor Reis",
    "Abdukodir Khusanov",
    "Stephen Mfuni",
    "Matthew Henderson-Hall",
    "Kaden Braithwaite",
    "Mateo Kovacic",
    "Kalvin Phillips",
    "Rodri",
    "Phil Foden",
    "Tijjani Reijnders",
    "Rayan Cherki",
    "Matheus Nunes",
    "Nico González",
    "Divine Mukasa",
    "Claudio Echeverri",
    "Xavier Tau Parker",
    "Erling Haaland",
    "Antoine Semenyo",
    "Jérémy Doku",
    "Omar Marmoush",
    "Savinho",
    "Divin Mubama",
    "Jaden Heskey",
    "Jeremy Monga",
    "Mahamadou Sangaré",
    "Floyd Samba"
  ],
  "Manchester United": [
    "Tom Heaton",
    "Karl Darlow",
    "Senne Lammens",
    "Harry Maguire",
    "Luke Shaw",
    "Lisandro Martínez",
    "Diogo Dalot",
    "Matthijs de Ligt",
    "Noussair Mazraoui",
    "Leny Yoro",
    "Ayden Heaven",
    "Harry Amass",
    "Patrick Dorgu",
    "Jaydan Kamason",
    "Diego León",
    "Bruno Fernandes",
    "Youri Tielemans",
    "Jack Fletcher",
    "Mason Mount",
    "Manuel Ugarte",
    "Toby Collyer",
    "Andrey Santos",
    "Kobbie Mainoo",
    "Daniel Gore",
    "Jim Thwaites",
    "Jacob Devaney",
    "Tyler Fletcher",
    "Matheus Cunha",
    "Bryan Mbeumo",
    "Joshua Zirkzee",
    "Benjamin Sesko",
    "Amad Diallo",
    "Shea Lacey",
    "Ethan Williams",
    "Ethan Wheatley",
    "JJ Gabriel"
  ],
  "Mantova": [
    "Stefano Cella",
    "Nicolò Radaelli",
    "Tommaso Maggioni",
    "Cristian Marai",
    "César Falletti",
    "Simone Trimboli",
    "David Wieser",
    "Francesco Ruocco",
    "Flavio Paoletti",
    "Stefano Baraldi",
    "Leonardo Mancuso",
    "Davis Mensah",
    "Mattia Bellini",
    "Davide Bragantini"
  ],
  "Marseille": [
    "Gerónimo Rulli",
    "Jeffrey de Lange",
    "Théo Vermot",
    "Jelle Van Neck",
    "Emerson",
    "Ulisses Garcia",
    "Derek Cornelius",
    "Nayef Aguerd",
    "Facundo Medina",
    "Leonardo Balerdi",
    "CJ Egan-Riley",
    "Bamo Meïté",
    "Hilan Slimani",
    "Geoffrey Kondogbia",
    "Pierre-Emile Højbjerg",
    "Amine Harit",
    "Angel Gomes",
    "Himad Abdelli",
    "Quinten Timber",
    "Tochukwu Nnadi",
    "Yanis Sellami",
    "Tadjidine Mmadi",
    "Neal Maupay",
    "Amine Gouiri",
    "Timothy Weah",
    "Faris Moumbagna",
    "Igor Paixão"
  ],
  "Metz": [
    "Ousmane Ba",
    "Pape Sy",
    "Jonathan Fischer",
    "Maxime Colin",
    "Bouna Sarr",
    "Jean Ruiz",
    "Urie-Michel Mboula",
    "Cleo Mélières",
    "Abdoulaye Nassoko",
    "Tahirys Dos Santos",
    "Adam Marchal",
    "Jessy Deminguet",
    "Alpha Touré",
    "Believe Munongo",
    "Hamza Kadamani",
    "Diego Duarte",
    "Habib Diallo",
    "Giorgi Abuashvili",
    "Ibou Sané",
    "Morgan Bokele",
    "Pape Fall",
    "Joseph Mangondo",
    "Édouard Soumah-Abbad",
    "Nathan Mbala",
    "Abdoulaye Ba",
    "Jahyann Pandore"
  ],
  "Middlesbrough": [
    "Seny Dieng",
    "Jon McLaughlin",
    "Solomon Brynn",
    "Luke Ayling",
    "Sam Edmundson",
    "Callum Brittain",
    "Alfie Jones",
    "Neto Borges",
    "Alex Bangura",
    "Adilson Malanda",
    "Finley Munroe",
    "Jack Daley",
    "Abdoulaye Kante",
    "Riley McGree",
    "Aidan Morris",
    "Sebastian Berhalter",
    "Jeremy Sarmiento",
    "Leo Castledine",
    "Finley Cartwright",
    "Law Mccabe",
    "Cruz Ibeh",
    "David Strelec",
    "Morgan Whittaker",
    "Sontje Hansen",
    "Kyle Joseph",
    "Micah Hamilton",
    "Tommy Conway",
    "Josh Dede",
    "Will Lankshear",
    "Max Arfsten"
  ],
  "Millwall": [
    "Max Crocombe",
    "Joel Coleman",
    "Lukas Jensen",
    "Jake Cooper",
    "Caleb Taylor",
    "Zak Sturge",
    "Tristan Crama",
    "Ryan Leonard",
    "Massimo Luongo",
    "Casper de Norre",
    "Daniel Kelly",
    "Alfie Doughty",
    "Luke Cundle",
    "Derek Mazou-Sacko",
    "Benicio Baker-Boaitey",
    "George Evans",
    "Femi Azeez",
    "Camiel Neghli",
    "Josh Coburn",
    "Zak Lovelace",
    "Mihailo Ivanovic",
    "Ajay Matthews",
    "Raees Bangura-Williams"
  ],
  "Minnesota United FC": [
    "Drake Callender",
    "Alec Smir",
    "Kayne Rizvanovich",
    "Michael Boxall",
    "Kyle Duncan",
    "D.J. Taylor",
    "Anthony Markanich",
    "Nicolás Romero",
    "Nectarios Triantis",
    "Devin Padelford",
    "Morris Duggan",
    "Jefferson Díaz",
    "Kieran Chandler",
    "Joaquín Pereyra",
    "Wil Trapp",
    "Julian Gressel",
    "Dominik Fitz",
    "Peter Stroud",
    "Carlos Harvey",
    "Owen Gene",
    "Tomás Chancalay",
    "Jordan Adebayo-Smith",
    "Bongokuhle Hlongwane",
    "Kelvin Yeboah",
    "Marcus Caldeira",
    "Mauricio Gonzalez",
    "Alisa Randell",
    "Mamadou Dieng",
    "Troy Putt"
  ],
  "Miramar Misiones": [
    "Christian Pérez",
    "Adrián Romero",
    "Pablo Pallante",
    "Santiago Mastrángelo",
    "Matías Lazo",
    "Diego Laurencena",
    "Martín Cardozo",
    "Adrián Speranza",
    "Juan Guardado",
    "Ignacio Christophersen",
    "Matías Appelt",
    "Agustín Trinidad",
    "Marcelo Broli",
    "Nei",
    "Gustavo Giacomazzi",
    "Juan Rodríguez",
    "Rodrigo Schram",
    "Rodrigo Mangini",
    "Federico Fernández",
    "Agustín Miraballes",
    "Mauricio Roldan",
    "Sebastián Pérez",
    "Renzo Capobianco",
    "Rodrigo Romero"
  ],
  "Mirassol": [
    "Walter",
    "Georgemy",
    "Thomazella",
    "Alex Muralha",
    "Gabriel",
    "Reinaldo",
    "Daniel Borges",
    "Victor Luis",
    "Lucas Oliveira",
    "João Victor Carroll",
    "Elias Lira Nogueira Junior",
    "Willian Machado",
    "Igor Marques",
    "Gabriel Knesowitsch",
    "Luiz Fernando",
    "Cauã Victor Soares Da Silva",
    "Marcelo Barbosa De Santos",
    "Carlos Eduardo",
    "Chico",
    "Neto Moura",
    "Gustavo Cazonatti",
    "Gustavo Mosquito",
    "Shaylon",
    "Wallison Luiz",
    "José Aldo",
    "Denilson",
    "João Wellington",
    "Edson Carioca",
    "Negueba",
    "André Luis",
    "Fernando",
    "Alesson",
    "Antonio Galeano",
    "Bruno Santos",
    "Vinicius Bacchi De Castro",
    "Felipe Pereira dos"
  ],
  "Mitre (Santiago del Estero)": [
    "Joaquín Ledesma",
    "Gastón Unrein",
    "Brian Mieres",
    "Daniel Abello",
    "Pablo Minissale",
    "Maximiliano Romero",
    "Luciano Correa",
    "Mateo Maldonado",
    "Martín Vázquez",
    "Juan Alessandroni",
    "Matías Ferrari",
    "Mateo Montenegro",
    "Alan López",
    "Santiago Lugones",
    "Santiago Rosales",
    "Marcos Machado",
    "Agustín Ramírez",
    "Enzo Avaro",
    "Rodrigo González",
    "Lautaro Ezequiel Mendoza"
  ],
  "Modena": [
    "Leandro Chichizola",
    "Abdullah Laidani",
    "Andrea Maran",
    "Francesco Zampano",
    "Davide Adorni",
    "Folly Nador",
    "Bryant Nieling",
    "Daniel Tonoli",
    "Gady Beyuku",
    "Simone Santoro",
    "Tito Fabbri",
    "Pietro Arnaboldi",
    "Pedro Mendes",
    "Antonio Imputato",
    "Edoardo Colpo"
  ],
  "Monaco": [
    "Lukas Hradecky",
    "Philipp Köhn",
    "Yann Lienard",
    "Jules Stawiecki",
    "Eric Dier",
    "Thilo Kehrer",
    "Jordan Teze",
    "Mohammed Salisu",
    "Vanderson",
    "Christian Mawissa",
    "Lamine Camara",
    "Paul Pogba",
    "Takumi Minamino",
    "Aleksandr Golovin",
    "Mamadou Coulibaly",
    "Denis Zakaria",
    "Edan Diop",
    "Stanis Idumbo",
    "Samuel Nibombé",
    "Pape Cabral",
    "Folarin Balogun",
    "Ansu Fati",
    "Mika Biereth",
    "Paris Brunner"
  ],
  "Montevideo City Torque": [
    "Gastón Rodríguez",
    "Franco Torgnascioli",
    "Martín Almeida",
    "Mathías Aguiar",
    "Gary Kagelmacher",
    "Jean López",
    "Franco Pizzichillo",
    "Kevin Silva",
    "Facundo Silvera",
    "Ezequiel Busquets",
    "Fabricio Silveira",
    "Benjamín García",
    "Eduardo Agüero",
    "Lautaro Silveira",
    "Valentino Würth",
    "Nahuel Leivas",
    "Nicolás Pérez",
    "Gonzalo Montes",
    "Pablo Siles",
    "Diogo Guzmán",
    "José Tarán",
    "Lucas Duré",
    "Facundo Rodríguez",
    "Ignacio Melián",
    "Sebastián Cáceres",
    "Alexander Silvera",
    "Alexander Da Silva",
    "Facundo Martínez",
    "Juan Quintana",
    "Esteban Obregon",
    "Salomón Rodríguez",
    "Luka Andrade",
    "Ignacio Molina",
    "Ramiro Lecchini",
    "Alessio Cartagena",
    "Yonatan Muñoz"
  ],
  "Montevideo Wanderers": [
    "José Río",
    "Gerónimo Govea",
    "Agustín Buffa Pedrouzo",
    "Paulo Lima",
    "Leandro Zazpe",
    "Fabricio Formiliano",
    "Mateo Acosta",
    "Alan García",
    "Lucas Furtado",
    "Nicolás Cabral",
    "Darlin Mencia",
    "Santiago Benítez",
    "Guillermo Borthagaray",
    "Enzo Gabriel Porro Porro",
    "Mateo Martínez",
    "Gonzalo Freitas",
    "Nicolás Queiroz",
    "Santiago Guzmán",
    "Renzo Sánchez",
    "José Alberti",
    "Jonás Luna",
    "Lautaro Blengio",
    "Jonathan Urretaviscaya",
    "Rodrigo Rivero",
    "Facundo Labandeira",
    "Joaquín Zeballos",
    "Esteban Crucci",
    "Luciano Cosentino",
    "Pablo Márquez",
    "Roque Ricca Gayol"
  ],
  "Montpellier": [
    "Mathieu Michel",
    "Simon Ngapandouentnbu",
    "Viktor Dzodic",
    "Kevin Kamdem Kamgaing",
    "Julien Laporte",
    "Théo Sainte-Luce",
    "Daylam Meddah",
    "Yael Mouanga",
    "Enzo Tchato",
    "Naoufel El Hannach",
    "Wilfried Ndollo Bille",
    "Mathis Chambon",
    "Mamadou Camara",
    "Florien Tardieu",
    "Everson",
    "Khalil Fayad",
    "Nabil Homssa",
    "Théo Chennahi",
    "Noah Vidal",
    "Yvan Mbappé",
    "Grégory Ayem",
    "Hichem Abderrebi",
    "Axel Gueguin",
    "Yanis Issoufou",
    "Nicolas Pays",
    "Junior Ndiaye",
    "Nordan Mukiele",
    "Daryll Benlahlou",
    "Laciné Megnan Pave"
  ],
  "Monza": [
    "Semuel Pizzignacco",
    "Aljaz Strajnar",
    "Demba Thiam",
    "Samuele Birindelli",
    "Arvid Brorsson",
    "Filippo Delli Carri",
    "Valentin Antov",
    "Andrea Carboni",
    "Adam Bakoune",
    "Lorenzo Lucchesi",
    "Lorenzo Colonnese",
    "Matteo Pessina",
    "Andrea Colpani",
    "Nicolas Galazzi",
    "Leonardo Colombo",
    "Nicolò Ballabio",
    "Danilo Treffiletti",
    "Giuseppe Martone",
    "Andrea Petagna",
    "Keita Baldé",
    "Patrick Ciurria",
    "Kevin Martins",
    "Dany Mota",
    "Patrick Cutrone",
    "Omari Forson",
    "Mathis Mout"
  ],
  "Nacional": [
    "Luis Mejía",
    "Alexis Martín Arias",
    "Ignacio Suárez",
    "Juan Bianchi",
    "Sebastián Coates",
    "Nicolás Rodríguez",
    "Francisco Calvo",
    "Camilo Cándido",
    "Agustin Rogel",
    "Emiliano Ancheta",
    "Paolo Calione",
    "Tomas Viera",
    "Benjamín Núñez Barolin",
    "Rubén Botta",
    "Bruno Zuculini",
    "Lucas Rodríguez",
    "Mateo Barcia",
    "Luciano Boggio",
    "Santiago Silva",
    "Juan García",
    "Kevin Martínez",
    "Agustín Dos Santos",
    "Román Clematte",
    "Luciano Rodríguez",
    "Maximiliano Gómez",
    "Juan Santos",
    "Tomás Verón Lupi",
    "Maximiliano Silvera",
    "Tiziano Correa",
    "Pavel Núñez"
  ],
  "Nantes": [
    "Maxime Dupé",
    "Alexis Mirbach",
    "Yanel Zézé",
    "Frédéric Guilbert",
    "Fabien Centonze",
    "Kelvin Amian",
    "Jean-Kévin Duverne",
    "Lucas Perrin",
    "Ali Almusrat",
    "Hugo Lamy",
    "Sékou Doucouré",
    "Tylel Tati",
    "Mathieu Cafaro",
    "Ibrahima Sissoko",
    "Lamine Diack",
    "Johann Lepenant",
    "Wilitty Younoussa",
    "Yassine Benhattab",
    "Malang Gomes",
    "Dehmaine Tabibou",
    "Louis Leroux",
    "Bahmed Deuff",
    "Sacha Ziani",
    "Mostafa Mohamed",
    "Ignatius Ganago",
    "Kilian Corredor",
    "Bahereba Guirassy"
  ],
  "Napoli": [
    "Nikita Contini",
    "Alex Meret",
    "Vanja Milinkovic-Savic",
    "Leonardo Spinazzola",
    "Giovanni Di Lorenzo",
    "Amir Rrahmani",
    "Mathías Olivera",
    "Alessandro Buongiorno",
    "Pasquale Mazzocchi",
    "Sam Beukema",
    "Rafa Marín",
    "Luca Marianucci",
    "Christian Garofalo",
    "Kevin De Bruyne",
    "Stanislav Lobotka",
    "Frank Anguissa",
    "Scott McTominay",
    "Billy Gilmour",
    "Antonio Vergara",
    "Romelu Lukaku",
    "Matteo Politano",
    "David Neres",
    "Noa Lang",
    "Lorenzo Lucca",
    "Walid Cheddira",
    "Rasmus Højlund",
    "Giovane"
  ],
  "Nashville SC": [
    "Brian Schwake",
    "Xavier Valdez",
    "Andy Nájar",
    "Jeisson Palacios",
    "Daniel Lovitz",
    "Jack Maher",
    "Josh Bauer",
    "Maxwell Woledzi",
    "Reed Baker-Whiting",
    "Thomas Williams",
    "Chris Applewhite",
    "Joe Willis",
    "Hany Mukhtar",
    "Bryan Acosta",
    "Alex Muyl",
    "Edvard Tagseth",
    "Patrick Yazbek",
    "Matthew Corcoran",
    "Shakur Mohammed",
    "Charles-Emile Brunet",
    "Famara Camara",
    "Jordan Knight",
    "Cristian Espinoza",
    "Sam Surridge",
    "Warren Madrigal",
    "Ahmed Qasim",
    "Elias Saad",
    "Woobens Pacius",
    "Zidane Yañez"
  ],
  "Náutico": [
    "Muriel",
    "Gastón Guruceaga",
    "Arnaldo",
    "Igor",
    "Reginaldo",
    "Luiz Paulo",
    "Matheus Ribeiro",
    "Mateus",
    "Wanderson Camelo Viana",
    "Ryan",
    "Gabriel Indio",
    "Gustavo Henrique Da Silva",
    "Betão",
    "Léo Jance",
    "Juan Rikelme",
    "Índio",
    "Auremir",
    "Wenderson",
    "Benjamín Borasi",
    "Luiz Felipe Oliveira De Paula",
    "Patricio Núñez",
    "Samuel",
    "Felipe Redaelli",
    "Halan",
    "Matheus Antonio Uchôa Da Silva",
    "Caio De Oliveira Mendonça Soares",
    "Hector Fernandes De Andrade Silva",
    "Derek",
    "Vinícius",
    "Victor Andrade",
    "Paulo Sérgio",
    "Todinho",
    "Felipe",
    "Maranhão",
    "Isaque Ferreira",
    "Rosa",
    "Luiz Claudio"
  ],
  "NEOM": [
    "Luís Maximiano",
    "Marcin Bulka",
    "Ozaybi Raed",
    "Mohammed Al Hakim",
    "Mohammed Al-Burayk",
    "Khalifah Al-Dawsari",
    "Mohannad Abu Taha",
    "Abdulmalik Al Oyayari",
    "Nathan Zeze",
    "Islam Hawsawi",
    "Khalid Al Rammah",
    "Ali Al Nakhli",
    "Abdulaziz Noor",
    "Ala Al-Hajji",
    "Abbas Al Hassan",
    "Amadou Koné",
    "Younis Alshanqity",
    "Geovanny Balanta",
    "Yahya Mousa Yahya Gharawi",
    "Fares Ahmed Al Ghafli",
    "Alexandre Lacazette",
    "Saïd Benrahma",
    "Hassan Hashim Al Ali",
    "Muhannad Al-Saad",
    "Nawaf Al Janahi",
    "Abdulaziz Al Khanani",
    "José Luis Carabalí",
    "Ahmed Al Anazi"
  ],
  "New England Revolution": [
    "Matt Turner",
    "JD Gunn",
    "Donovan Parisian",
    "Mamadou Fofana",
    "Andrew Farrell",
    "Tanner Beason",
    "Cody Baker",
    "William Sands",
    "Ilay Feingold",
    "Ethan Kohler",
    "Damario Mcintosh",
    "Peyton Miller",
    "Mimy Schinieder",
    "Gabe Dahlin",
    "Chris Mbaï Assem",
    "Carles Gil",
    "Diego Fagundez",
    "Matt Polster",
    "Jackson Yueill",
    "Alhassan Yusuf",
    "Brooklyn Raines",
    "Allan Oyirwoth",
    "Carlos Zarzalejo",
    "Eric Klein",
    "Cristiano Oliveira",
    "Javaun Mussenden",
    "Wilson Harris",
    "Leonardo Campana",
    "Griffin Yow",
    "Dor Turgeman",
    "Jayden Da",
    "Luca Langoni",
    "Shuma Sasaki",
    "Marcos Zambrano-Delgado",
    "Judah Siqueira"
  ],
  "New York City FC": [
    "Tomas Romero",
    "Greg Ranjitsingh",
    "Matt Freese",
    "Thiago Martins",
    "Kevin O'Toole",
    "Raul Gustavo",
    "Kai Trewin",
    "Tayvon Gray",
    "Kamran Acito",
    "Mitja Ilenic",
    "Max Murray",
    "Andrew Baiera",
    "Nico Cavallo",
    "Maxi Morález",
    "Nicolás Fernández",
    "Aiden O'Neill",
    "James Sands",
    "Andrés Perea",
    "Keaton Parks",
    "Cooper Flax",
    "Jonathan Shore",
    "Maxi Carrizo",
    "Jacob Arroyave",
    "Peter Molinari",
    "Kevin Pierre",
    "Hannes Wolf",
    "Talles Magno",
    "Alonso Martínez",
    "Bénie Traoré",
    "Agustin Ojeda",
    "Luighi Hanri",
    "Malachi Jones",
    "Seymour Reid",
    "Arnau Farnós"
  ],
  "New York Red Bulls": [
    "Ethan Horvath",
    "John McCarthy",
    "Anthony Marcucci",
    "Tim Parker",
    "Dylan Nealis",
    "Justin Che",
    "Jahkeele Marshall-Rutty",
    "Robert Voloder",
    "Juan González",
    "Omar Valencia",
    "Julián Bazán",
    "Matthew Dos Santos",
    "Cameron Harper",
    "Emil Forsberg",
    "Gustaf Beggren",
    "Nehuen Benedetti",
    "Nathan Worth",
    "Ronald Donkor",
    "Tanner Rosborough",
    "Adri Mehmeti",
    "Eric Maxim Choupo-Moting",
    "Cade Cowell",
    "Roald Mitchell",
    "Jorge Ruvalcaba",
    "Dennis Gjengaar",
    "Rafael Mosquera",
    "Andy Rojas",
    "Mohammed Sofo",
    "Mijahir Ameth Jiménez Murillo"
  ],
  "Newcastle United": [
    "Mark Gillespie",
    "Nick Pope",
    "Ewen Jaouen",
    "Aidan Harris",
    "Fabian Schär",
    "Dan Burn",
    "Sven Botman",
    "Tino Livramento",
    "Malick Thiaw",
    "Leo Shahar",
    "Lewis Hall",
    "Jacob Murphy",
    "Joelinton",
    "Harvey Barnes",
    "Joe Willock",
    "Jacob Ramsey",
    "Lewis Miley",
    "Sean Steur",
    "Aladji Bamba",
    "Yoane Wissa",
    "Anthony Elanga",
    "Nick Woltemade",
    "William Osula",
    "Sean Neave",
    "Bazoumana Touré"
  ],
  "Newell's Old Boys": [
    "Gabriel Arias",
    "Josué Reinatti",
    "Rodrigo Herrera",
    "Lautaro Giannetti",
    "Franco Escobar",
    "Saúl Salcedo",
    "Martín Ortega",
    "Armando Méndez",
    "Oscar Salómon",
    "Nicolas Goitea",
    "Martín Luciano",
    "Ivan Glavinovich",
    "Bruno Cabrera",
    "Alejo Montero",
    "Alan Soñora",
    "Marcelo Esponda",
    "David Sotelo",
    "Lucas Gómez",
    "Valentino Acuña",
    "Luca Regiardo",
    "Jerónimo Mattar",
    "Blas Benedetto",
    "Mateo Villalba",
    "Tomás Viola",
    "Juan Ramírez",
    "Walter Mazzantti",
    "Matías Cóccaro",
    "Walter Núñez",
    "Jeronimo Russo",
    "Facundo Gauch",
    "Francisco Scarpeccio"
  ],
  "Nice": [
    "Yehvann Diouf",
    "Jonathan Clauss",
    "Mohamed Abdelmoneim",
    "Ali Abdi",
    "Melvin Bard",
    "Antoine Mendy",
    "Kojo Peprah Oppong",
    "Moïse Bombito",
    "Morgan Sanson",
    "Laurent Abergel",
    "Gauthier Hein",
    "Tanguy Ndombele",
    "Youssouf Ndayishimiye",
    "Sofiane Diop",
    "Hicham Boudaoui",
    "Salis Abdul Samed",
    "Djibril Coulibaly",
    "Xavier Junior Mandza Tsiendi",
    "Isak Jansson",
    "Kevin Carlos",
    "Mohamed-Ali Cho"
  ],
  "Norwich City": [
    "Vladan Kovacevic",
    "Daniel Grimshaw",
    "Vicente Reyes",
    "Jack Stacey",
    "Harry Darling",
    "José Córdoba",
    "Jakov Medic",
    "Benjamin Chrisene",
    "Ruairi McConville",
    "Kellen Fisher",
    "Lucien Mahovo",
    "Bruno Alves",
    "Theodore Adelusi",
    "Vatan Oğuz Özcan",
    "Kenny McLean",
    "Sam Field",
    "Paris Maghoma",
    "Pelle Mattsson",
    "Liam Gibbs",
    "Anis Slimane",
    "Mirko Topic",
    "Matej Jurásek",
    "Forson Amankwah",
    "Ali Ahmed",
    "Gabriel Forsyth",
    "Andre Brooks",
    "Jacob Wright",
    "Elliot Myles",
    "Zachary Baumann",
    "Mohamed Toure",
    "Mathias Kvistgaarden",
    "Jovon Makama",
    "Oscar Schwartau",
    "Pape Diallo",
    "Ante Crnac",
    "Errol Mundle-Smith"
  ],
  "Nottingham Forest": [
    "Matz Sels",
    "John Victor",
    "Morato",
    "Ola Aina",
    "Nikola Milenkovic",
    "Omar Richards",
    "Neco Williams",
    "Luca Netz",
    "Jair Paula",
    "Murillo",
    "Zach Abbott",
    "Nicolò Savona",
    "Ibrahim Sangaré",
    "Xaver Schlager",
    "Ryan Yates",
    "Morgan Gibbs-White",
    "Nicolás Domínguez",
    "James McAtee",
    "Chris Wood",
    "Taiwo Awoniyi",
    "Callum Hudson-Odoi",
    "Dan Ndoye",
    "Igor Jesus",
    "Arnaud Kalimuendo",
    "Dilane Bakwa",
    "Omari Hutchinson",
    "Eric Da Silva Moreira"
  ],
  "Novorizontino": [
    "Paulo Henrique Fagundes Dos Anjos",
    "Jordi",
    "César",
    "Lucas",
    "João Vitor Indalecio Scapin",
    "Eduardo Brock",
    "Sander",
    "Renato Silveira",
    "Carlos Lora",
    "Gabriel",
    "Carlinhos",
    "Patrick",
    "Maykon",
    "Alemão",
    "Marlon",
    "Luis",
    "Matheus Bianqui",
    "Juninho",
    "Alexis Alvariño",
    "Leo Naldi",
    "Rômulo Simão",
    "Diego Galo",
    "Jardiel",
    "Miguel Contiero",
    "Jhones Kauê",
    "Bruno Santana",
    "Christian Ortíz",
    "Carlão",
    "Robson",
    "Nicolas Careca",
    "Vinicius Paiva",
    "Diego Mathias",
    "Hélio",
    "Ronald Barcellos",
    "Tavinho",
    "Hector",
    "Francisco Reidiney Duarte Gomes"
  ],
  "Nueva Chicago": [
    "Luciano Jachfe",
    "Juan Carranza",
    "Facundo Masuero",
    "Lucas Bersce",
    "Dylan Gissi",
    "Guillermo Ferracuti",
    "Iván Antunes",
    "Elias Machuca",
    "Rodrigo Rámirez",
    "Bruno Palazzo",
    "Gonzalo Paz",
    "Gonzalo Trindade",
    "Diego Arroyo",
    "Roman Zalazar",
    "Gerónimo Velozo",
    "Gabriel Reta",
    "Emerson Silveira",
    "Enzo Carrizo",
    "Matías Vera",
    "Emiliano Méndez",
    "Alan Ruíz",
    "Lucas López",
    "Evelio Cardozo",
    "Enzo Roldán",
    "Ramiro Balbuena",
    "Maximiliano Rogoski",
    "Gabriel Vega",
    "Lucas Vázquez",
    "Germán Mansilla",
    "Tomás Orqueida",
    "Javier Pereyra",
    "Braian Toloza",
    "Leonel Ortiz",
    "Nazareno Petrecca",
    "Alejo Gonzalez",
    "Joaquín González",
    "Mauro Pérez",
    "Tomás Rodríguez",
    "Lucas Ambrogio",
    "Sebastián Cocimano",
    "Diego Barros"
  ],
  "Operário Ferroviário": [
    "Vagner da Silva",
    "Elias",
    "Talles",
    "Diego",
    "Maguinho",
    "Klaus",
    "Juninho",
    "Joseph",
    "Miranda",
    "Mikael",
    "José Cuenú",
    "Gabriel Feliciano",
    "João Gabriel Rodrigues Botao",
    "Renan Gustavo Ribeiro Moreira",
    "Juan Pablo Zuluaga",
    "Gabriel Boschilia",
    "Paraíba",
    "Charles Almeida",
    "Trindade",
    "Bruno Aparecido Reis Ezequiel",
    "Pedro Veronez",
    "Brenno",
    "Vinícius Diniz",
    "Pablo",
    "Aylon",
    "Caio Dantas",
    "Maxwell",
    "Hildeberto Pereira",
    "Vinicius Mingotti",
    "Dudu",
    "João Victor"
  ],
  "Oriental": [
    "Adriel da Silva",
    "Emiliano Bermúdez",
    "Lucero Álvarez",
    "Brian Lapaz",
    "Nicolás Rodríguez",
    "Gabriel Chocobar",
    "Nicolás Kozlovsky",
    "Kauê Marques",
    "Malcom Pereira",
    "Enzo Fernández",
    "Joaquín Viera",
    "Ángelo Gabrielli",
    "Lautaro Ultra",
    "Christian Paiva",
    "Thiago González",
    "Juan Pablo Viré",
    "Facundo Briñón",
    "Enzo Vlaeminch",
    "Renato Alexandrino",
    "Ezequiel Silva",
    "Franco Tejera",
    "Martín Vallejo",
    "Nahuel Gómez",
    "Julio Caballero",
    "Francisco Burgio",
    "Braian Galván",
    "Cristian Franco",
    "Matías Rigoleto",
    "Franco Mateo",
    "Bruno Motta"
  ],
  "Orlando City SC": [
    "Maxime Crépeau",
    "Javier Otero",
    "Tristan Himes",
    "Robin Jansson",
    "Adrián Marín",
    "Griffin Dorsey",
    "David Brekalo",
    "Iago Teodoro",
    "Nolan Miller",
    "Tahir Reid-Brown",
    "Clovis Archange",
    "Wilder Cartagena",
    "Martín Ojeda",
    "Eduard Atuesta",
    "Iván Angulo",
    "Braian Ojeda",
    "Gustavo Caraballo",
    "Luis Otávio",
    "Colin Guske",
    "Joran Gerbet",
    "Ignacio Gómez",
    "Zakaria Taifi",
    "Dylan Judelson",
    "Issah Haruna",
    "Antoine Griezmann",
    "Daryl Dike",
    "Marco Pasalic",
    "Tyrese Spicer",
    "Pedro Leão",
    "Tiago",
    "Justin Ellis",
    "Bernardo Rhein Goncalves",
    "Harvey Sarajian"
  ],
  "Osasuna": [
    "Aitor Fernández",
    "Sergio Herrera",
    "Valentin Rosier",
    "Alejandro Catena",
    "Abel Bretones",
    "Jorge Herrando",
    "Enzo Boyomo",
    "Iñigo Arguibide",
    "Lucas Torró",
    "Rubén García",
    "Jon Moncayola",
    "Aimar Oroz",
    "Iker Muñoz",
    "Asier Osambela",
    "Moi Gómez",
    "Ante Budimir",
    "Enrique Barja",
    "Raúl García",
    "Raúl Moro",
    "Iker Benito"
  ],
  "Padova": [
    "Louis Mouquet",
    "Antonio Barreca",
    "Filippo Sgarbi",
    "Giulio Favale",
    "Christian Pastina",
    "Carlo Faedo",
    "Alessandro Boi",
    "Alejandro Gómez",
    "Jacopo Bacci",
    "Kevin Varas Marcillo",
    "Alessandro Capelli",
    "Pietro Fusi",
    "Gianluca Caprari",
    "Cristian Buonaiuto",
    "Kevin Lasagna",
    "Mattia Bortolussi",
    "Alessandro Seghetti",
    "Emiliano Lo Biundo"
  ],
  "Palermo": [
    "Jesse Joronen",
    "Nils Balaguss",
    "Simone Pizzuto",
    "Pietro Ceccaroni",
    "Giangiacomo Magnani",
    "Mattia Bani",
    "Tommaso Augello",
    "Patryk Peda",
    "Niccolò Pierozzi",
    "Ettore Nicolosi",
    "Antonio Palumbo",
    "Alexis Blin",
    "Claudio Gomes",
    "Filippo Ranocchia",
    "Jacopo Segre",
    "Pietro Avena",
    "Valerio Brutto",
    "Salvatore Squillacioti",
    "Francesco Balsamo",
    "Joel Pohjanpalo",
    "Dennis Johnsen",
    "Jeremy Le Douaron"
  ],
  "Palmeiras": [
    "Marcelo Lomba",
    "Carlos Miguel",
    "Kaique",
    "Luiz Felipe",
    "Kauan Lima",
    "Luiz Fernando",
    "Gustavo Gómez",
    "Alexander Barboza",
    "Murilo",
    "Joaquín Piquerez",
    "Bruno Fuchs",
    "Khellven",
    "Agustín Giay",
    "Jefté",
    "Luiz Benedetti",
    "Arthur Gabriel",
    "Thiago Soares",
    "Derick",
    "Luccas Ramon",
    "Luis Saboia",
    "Mohamed Kone",
    "André Lucas",
    "Emiliano Martínez",
    "Felipe Anderson",
    "Lucas Evangelista",
    "Andreas Pereira",
    "Marlon Freitas",
    "Jhon Arias",
    "Maurício",
    "Rafael Coutinho",
    "Larson",
    "Erick Machado",
    "Luis Felipe",
    "Victor Gabriel",
    "Guilherme Nogueira",
    "Ruan Yago",
    "Isaac",
    "João Paulo",
    "Paulinho",
    "Ramón Sosa",
    "José Manuel López",
    "Vitor Roque",
    "Riquelme",
    "Allan Andrade",
    "Heittor",
    "Eduardo",
    "Juan Gabriel",
    "Kauã",
    "Miguel Cinoncelli Bilong"
  ],
  "Paris FC": [
    "Kevin Trapp",
    "Obed Nkambadio",
    "Hamari Traoré",
    "Thibault De Smet",
    "Moustapha Mbow",
    "Samir Chergui",
    "Otavio",
    "Diego Coppola",
    "Tuomas Ollila",
    "Nhoa Sangui",
    "Vincent Marchetti",
    "Pierre Lees-Melou",
    "Maxime López",
    "Ilan Kebbal",
    "Adama Camara",
    "Rudy Matondo",
    "Ciro Immobile",
    "Moses Simon",
    "Jonathan Ikoné",
    "Alimani Gory",
    "Jean-Phillipe Krasso"
  ],
  "Paris Saint-Germain": [
    "Matvei Safonov",
    "Lucas Chevalier",
    "Alessandro Longoni",
    "Marquinhos",
    "Lucas Digne",
    "Lucas Hernández",
    "Achraf Hakimi",
    "Willian Pacho",
    "Nuno Mendes",
    "Illia Zabarnyi",
    "Lucas Beraldo",
    "Fabián Ruiz",
    "Vitinha",
    "Warren Zaïre-Emery",
    "João Neves",
    "Senny Mayulu",
    "Dro Fernández",
    "Ousmane Dembélé",
    "Khvicha Kvaratskhelia",
    "Bradley Barcola",
    "Désiré Doué",
    "Ibrahim Mbaye",
    "Quentin Ndjantou"
  ],
  "Parma": [
    "Zion Suzuki",
    "Edoardo Corvi",
    "Emanuele Valeri",
    "Enrico Del Prato",
    "Lautaro Valenti",
    "Abdoulaye Ndiaye",
    "Botond Balogh",
    "Franco Carboni",
    "Alessandro Circati",
    "Mariano Troilo",
    "Peter Amoran",
    "Sascha Britschgi",
    "Dominik Drobnic",
    "Adrián Bernabé",
    "Oliver Sørensen",
    "Mandela Keita",
    "Christian Ordoñez",
    "Abdou-Salam Konate",
    "Pontus Almqvist",
    "Jacob Ondrejka",
    "Matija Frigan",
    "Mateo Pellegrino",
    "Antoine Joujou",
    "Nesta Elphege"
  ],
  "Patronato": [
    "Franco Rivasseau",
    "Fernando Moreyra",
    "Juan Salas",
    "Franco Meritello",
    "Facundo Heredia",
    "Nahuel Genez",
    "Juan Barinaga",
    "Federico Bravo",
    "Brandon Cortés",
    "Walter Rueda",
    "Valentín Pereyra",
    "Santiago Piccioni",
    "Alejo Miró",
    "Augusto Picco",
    "Alan Sosa",
    "Franco Soldano",
    "Renzo Reynaga",
    "Joaquín Barolín"
  ],
  "Pau": [
    "Esteban Salles",
    "Georges Grimaud",
    "Matis Duval",
    "Gaëtan Paquiez",
    "Anthony Briancon",
    "Axel Bamba",
    "Ousmane Kanté",
    "Mathys Tourraine",
    "Souleymane Basse",
    "Joseph Kalulu Kyatengwa",
    "Robin Verhaeghe",
    "Cheikh Fall",
    "Antonin Bobichon",
    "Quentin Daubin",
    "Lorenzo Rajot",
    "Tom Pouilly",
    "Kylian Gasnier",
    "Alexis Lefebvre",
    "Giovani Versini",
    "Royce Openda",
    "Titouan Nihouarn",
    "Abdoulaye Mbaye"
  ],
  "Paysandú FC": [
    "Nazareno Ferreyra",
    "Nicolás Césaro",
    "Benjamín Gougeon",
    "Matías González",
    "Nicolás Morales",
    "Agustín Vique",
    "Nicolás Bicca",
    "Francisco Ibáñez",
    "Mathías Gómez",
    "Andrew Teuten",
    "Ulises Márquez",
    "Brandon Logiuratto",
    "Dilan Cardozo",
    "Michel Acosta",
    "Ignacio Gómez",
    "Agustín Gómez",
    "Pablo Furtado",
    "Ezequiel Amaro",
    "Cristian Sención",
    "Emiliano Arrieta",
    "Lucas Wasilewsky",
    "Juan Silvera",
    "Benjamín Torres",
    "Bryan Sánchez",
    "Santiago Ramírez",
    "Camilo Lozano",
    "Luca Guichón",
    "Kevin Palivoda",
    "Alexis Iturria",
    "Franco López",
    "Gabriel López",
    "Emiliano Bonilla",
    "Luis López",
    "Carlos Duarte",
    "Balthasar Pesce",
    "Vicente Pesce"
  ],
  "Peñarol": [
    "Washington Aguerre",
    "Sebastian Britos Rodriguez",
    "Luis Díaz",
    "Franco Romero",
    "Maximiliano Olivera",
    "Diego Laxalt",
    "Lucas Hernández",
    "Mauricio Lemos",
    "Nahuel Herrera",
    "Andrés Madruga",
    "Lucas Ferreira",
    "Thiago Espinosa",
    "Ignacio Alegre",
    "Facundo Álvez",
    "Brian Barboza",
    "Eric Remedi",
    "Leonardo Fernández",
    "Roberto Fernández",
    "Jesús Trindade",
    "Franco González",
    "Eduardo Darias",
    "Leandro Umpiérrez",
    "Tomás Olase",
    "Stiven Mülhethaler",
    "Germán Barbas",
    "Julio Daguer",
    "Kevin Rodríguez",
    "Jonathan Rodríguez",
    "Abel Hernández",
    "Marcelo Cabrera",
    "Douglas Arezo",
    "Facundo Batista",
    "Luis Miguel Angulo",
    "Brandon Álvarez",
    "Cristian Jaime"
  ],
  "Philadelphia Union": [
    "Andre Blake",
    "George Marks",
    "Andrew Rick",
    "Kai Wagner",
    "Nathan Harriel",
    "Japhet Sery",
    "Frankie Westfield",
    "Neil Pierre",
    "Philippe Ndinga Ossibadjouo",
    "Finn Sundstrom",
    "Geiner Martínez",
    "Alejandro Bedoya",
    "Indiana Vassilev",
    "Jesús Bueno",
    "Jeremy Rafanello",
    "Ben Bender",
    "Quinn Sullivan",
    "Jovan Lukic",
    "Danley Jean Jacques",
    "Cavan Sullivan",
    "Milan Iloski",
    "Bruno Damiani",
    "Augustin Anello",
    "Sal Olivas",
    "Ezekiel Alladoh",
    "Stas Korzeniowski",
    "Malik Jakupovic"
  ],
  "Pisa": [
    "Simone Scuffet",
    "Adrian Semper",
    "Tommaso Guizzo",
    "Raúl Albiol",
    "Antonio Caracciolo",
    "Francesco Coppola",
    "Arturo Calabresi",
    "Simone Canestrelli",
    "Samuele Angori",
    "Rosen Bozhinov",
    "Juan Cuadrado",
    "Idrissa Touré",
    "Mehdi Léris",
    "Malthe Hojholt",
    "Gabriele Piccinini",
    "Isak Vural",
    "Brando Bettazzi",
    "Stefano Moreo",
    "Matteo Tramoni",
    "Henrik Meister"
  ],
  "Platense": [
    "Brian Bustos",
    "Juan Pablo Cozzani",
    "Nicolás Sumavil",
    "Joaquín Giudice",
    "Santino Cambiasso",
    "Ignacio Vázquez",
    "Víctor Cuesta",
    "Gonzalo Goñi",
    "Tomás Giménez",
    "Agustín Lagos",
    "Juan Ignacio Saborido",
    "Tomas Silva",
    "Santiago Quirós",
    "Eugenio Raggio",
    "Mateo Mendia",
    "Fabricio Gabriel López",
    "Celías Ingenthron",
    "Agustín Maglione",
    "Lucas Testa",
    "Thiago Currado",
    "Axel Guzmán",
    "Ivan Gomez",
    "Leonardo Heredia",
    "Pablo Ferreira",
    "Martín Barrios",
    "Agustín Funes",
    "Franco Zapiola",
    "Maximiliano Amarfil",
    "Franco Minerva",
    "Santiago Dalmasso",
    "Felipe Bussio",
    "Demian Troya",
    "Santiago Bouhet",
    "Salvador Rixner",
    "Nico López",
    "Alejandro Vera",
    "Augusto Lotti",
    "Guido Mainero",
    "Bautista Merlini",
    "Gastón Togni",
    "Juan Gauto",
    "Gonzalo Lencina",
    "Héctor Bobadilla",
    "Nicolas Retamar",
    "Luciano Giménez",
    "Manuel Tucker",
    "Tomás Nasif",
    "Lucas Zelaya",
    "Matías Ramírez",
    "Luca Bastilla",
    "Fausto San Pedro"
  ],
  "Plaza Colonia": [
    "Andrés Samurio",
    "Tiago Glättli",
    "Álvaro Fernández",
    "Emilio Zeballos",
    "Federico Barrandeguy",
    "Ezequias Redín",
    "Haibrany Ruiz Días",
    "Martín Jourdan",
    "Joaquín Sarlabós",
    "Nicolás Ayala",
    "Matías Aguilar",
    "Mateo Casanova",
    "Cristian Rodríguez",
    "Esteban Rodríguez",
    "Agustín García",
    "Marcos Zubizarreta",
    "Matías Gómez",
    "Ramiro Quintana",
    "Rodrigo Pérez",
    "Juan Cruz Mascia",
    "Gonzalo Wigman",
    "Martín Taberne",
    "Daniel Bahia",
    "Joaquín Tessa",
    "Franco Gaimari",
    "Leandro Gallo",
    "Axl Velázquez"
  ],
  "Ponte Preta": [
    "Guilherme Viana",
    "Vinicius",
    "Danilo Barcelos",
    "Cunha",
    "Thalys Victor Martins Sena",
    "Marcio Silva",
    "Diego Porfirio",
    "Kevyson",
    "Sergio Palacios",
    "Juan Rodrigues Leopoldino",
    "Diego Monteiro Leão",
    "Gustavo Felipe Almeida",
    "Julio De Oliveira",
    "Élvis",
    "Rodrigo Souza",
    "Léo Gomes",
    "André",
    "Diogo Ribeiro",
    "Nicolas Araujo Da Silva",
    "Gustavo Teles",
    "Murilo",
    "Pedrinho",
    "Miguel",
    "Jonathan Cafú",
    "Daniel Goncalves Batista",
    "David Conceição",
    "Brandão",
    "João Victor Damião Dos Santos"
  ],
  "Portland Timbers": [
    "Trey Muse",
    "James Pantemis",
    "Hunter Sulte",
    "Ian Smith",
    "Eric Miller",
    "Brandon Bye",
    "Kamal Miller",
    "Juan Mosquera",
    "Zac McGraw",
    "Finn Surman",
    "Alex Bonetig",
    "Charles Ondo",
    "Sawyer Jura",
    "Diego Chará",
    "Joao Ortiz",
    "Cole Bassett",
    "Jimer Fory",
    "David Da Costa",
    "Eric Izoita",
    "José Caicedo",
    "Vincent Janssen",
    "Ariel Lassiter",
    "Omir Fernández",
    "Kristoffer Velde",
    "Alexander Aravena",
    "Antony",
    "Kevin Kelsy",
    "Noah Santos",
    "Gage Guerra"
  ],
  "Portsmouth": [
    "Ben Killip",
    "Josef Bursik",
    "Nicolas Schmid",
    "Daniel Bielica",
    "Josh Knight",
    "Conor Shaughnessy",
    "Connor Ogilvie",
    "Regan Poole",
    "Zak Swanson",
    "Jacob Farrell",
    "Hayden Matthews",
    "Madiodio Dia",
    "Michael Ani",
    "John Swift",
    "Marlon Pack",
    "Josh Murphy",
    "Ebrima Adams",
    "Keshi Anderson",
    "Odin Bailey",
    "Luke Le Roux",
    "Márk Kosznovszky",
    "Rocco Robert Shein",
    "Adrian Segecic",
    "Terry Devlin",
    "Eoin Kenny",
    "Chinedu Agu",
    "Marko Milovanovic",
    "Colby Bishop",
    "Harvey Blair",
    "Thomas Waddingham",
    "Franco Umeh-Chibueze",
    "Luke Brooke-Smith",
    "Olutayo Singerr",
    "Nathaniel Chioma"
  ],
  "Preston North End": [
    "David Cornell",
    "Lee Nicholls",
    "Daniel Iversen",
    "Andrew Hughes",
    "Liam Lindsay",
    "Andrija Vukcevic",
    "Jordan Storey",
    "Lewis Gibson",
    "Pol Valentín",
    "Odeluga Offiah",
    "Thierry Small",
    "Brad Potts",
    "Jordan Thompson",
    "Alistair McCann",
    "Alfie Devine",
    "Andy Moran",
    "Kaedyn Kamara",
    "Kitt Nelson",
    "Theo Carrol",
    "Callum Lang",
    "Milutin Osmajic",
    "Jusef Erabi"
  ],
  "Progreso": [
    "Renzo Bacchia",
    "Agustín Requena",
    "Lautaro Nahuel Fernández Cedrés",
    "Gastón Silva",
    "Federico Andueza",
    "Sebastián Cardozo",
    "Emiliano Álvarez",
    "Ayrton Cougo",
    "Marco Saravia",
    "Gianfranco Trasante Medina",
    "Hernán Carroso Pais",
    "Federico García Martínez",
    "Mauro Joaquín Martín Colmán",
    "Ignacio Lemmo",
    "Gonzalo Silva",
    "Ramiro Cristobal",
    "Lucas Ocampo",
    "Facundo De León",
    "Lorenzo Couture",
    "Agustín Daniel Codagnone Puga",
    "Agustín Pinheiro Goggia",
    "Jonathan Dos Santos",
    "Nahuel López",
    "Nahuel Acosta",
    "Agustin Paz",
    "Matteo Copelotti",
    "Maximiliano Juambeltz",
    "Gary Said Silva Sabas",
    "Joaquín Solleiro Silva"
  ],
  "Queens Park Rangers": [
    "Pierce Charles",
    "Calum Ward",
    "Matteo Salamon",
    "Jake Clark-Salter",
    "Liam Morrison",
    "Boy Kemper",
    "Jimmy Dunne",
    "Tariq Lamptey",
    "Ronnie Edwards",
    "Ziyad Larkeche",
    "Amadou Salif Mbengue",
    "Kealey Adamson",
    "João Henrique",
    "Tylon Smith",
    "Glen Kamara",
    "Ilias Chair",
    "Nicolas Madsen",
    "Kwame Poku",
    "Harvey Vale",
    "Jonathan Varane",
    "Isak Alemayehu",
    "Jaylan Pearman",
    "Kieran Morgan",
    "Philip Sanyaolu",
    "Paul Smyth",
    "Koki Saito",
    "Rumarn Burrell",
    "Alfie Lloyd",
    "Justin Obikwu",
    "Rayan Kolli",
    "Richard Kone",
    "Ashley Trujillo",
    "Kalen Brunson",
    "Leon Scarlett"
  ],
  "Quilmes": [
    "Esteban Glellel",
    "Joaquín Canadell",
    "Ramiro Martínez",
    "Ariel Kippes",
    "Thomas Ortega",
    "Martín Vallejos",
    "Agustín Ortega",
    "Pedro Paredes",
    "Agustín Lavezzi",
    "Juan Yangali",
    "Ulises Vera",
    "Mauro Fernández",
    "Aaron Spetale",
    "Axel Batista",
    "Gabriel Vázquez"
  ],
  "Racing Club": [
    "Facundo Cambeses",
    "Matías Tagliamonte",
    "Francisco Gómez",
    "Thiago De Bellis",
    "Marcos Rojo",
    "Agustín García Basso",
    "Pacha Espino",
    "Nazareno Colombo",
    "Marco Di Cesare",
    "Gastón Martirena",
    "Ezequiel Cannavo",
    "Tobías Rubio",
    "Gonzalo Escudero",
    "Mateo Martínez",
    "Alejandro Tello",
    "Matías Kranevitter",
    "Matías Zaracho",
    "Santiago Sosa",
    "Matko Miljevic",
    "Diego Ortegoza",
    "Adrián Fernández",
    "Ignacio Agustin Rodríguez",
    "Alan Forneris",
    "Bautista Perez",
    "Santino Benjamín Aguirre",
    "Alexis Ariel Yegros",
    "Adrián Martínez",
    "Duván Vergara",
    "Tomás Conechny",
    "Lautaro Díaz",
    "Santiago Solari",
    "Valentin Carboni",
    "Elías Torres"
  ],
  "Racing Club de Montevideo": [
    "Facundo Machado",
    "Federico Varese",
    "Guillermo Cotugno",
    "Facundo Parada",
    "Martín Ferreira",
    "Ramiro Brazionis",
    "Felipe Álvarez",
    "Facundo González",
    "Yury Oyarzo",
    "Elías Bentancor",
    "Diego Cheuquepal",
    "Matías Unyicio",
    "José Varela",
    "Agustín De La Cuesta",
    "Erik de los Santos",
    "Álex Vázquez",
    "Agustín Álvarez Wallace",
    "Franco Suárez",
    "Lucca Loprete",
    "Esteban Da Silva",
    "Juan Bosca",
    "Juan Pérez",
    "Gonzalo Facundo Oliva Giménez",
    "Nicolás Sosa Sánchez",
    "Thiago Fernández",
    "Rodrigo Dudok",
    "Tomás Habib",
    "Sebastián Da Silva",
    "Rodrigo Gadea",
    "Iván Manzur"
  ],
  "Racing de Córdoba": [
    "Brian Olivera",
    "Gonzalo Laborda",
    "Valentín Dutruel",
    "Lucas Flores",
    "Alejandro Rébola",
    "Jonathan Bay",
    "Emanuel Díaz",
    "Raúl Chamorro",
    "Gabriel Aranda",
    "Matías Sánchez",
    "Santiago Rinaudo",
    "Marcio Gómez",
    "Tomás Kummer",
    "Fabrizio Ghiggia",
    "Guido Pache",
    "Matías Machado",
    "Ciro Rivas",
    "Francisco Martín",
    "Lucas Soto",
    "Cristian Vega",
    "Gaspar Íñiguez",
    "Facundo Juárez",
    "Gaspar Vega",
    "Abel Bustos",
    "Exequiel Oviedo",
    "Luciano Viano",
    "Francisco Monticelli",
    "Franco Tossen",
    "Martín Szumik",
    "Lautaro Avila",
    "Fernando Ortíz",
    "Catriel Peña",
    "Pablo Chavarría",
    "Ricardo Centurion",
    "Ignacio Valsangiacomo",
    "Sergio González",
    "Facundo Taborda",
    "Alan Olinick",
    "Alfie James",
    "Leandro Córdoba"
  ],
  "Racing Santander": [
    "Simon Eriksson",
    "Jorge Salinas",
    "Manu",
    "Alvaro Mantilla",
    "Facundo González",
    "Íñigo Sainz",
    "Gustavo Puerta",
    "Maguette Gueye",
    "Sergio Martínez",
    "Andrés Martín",
    "Asier Villalibre",
    "Iñigo Vicente",
    "Giorgi Guliashvili",
    "Juan Carlos Arana"
  ],
  "Rayo Vallecano": [
    "Daniel Cárdenas",
    "Augusto Batalla",
    "Florian Lejeune",
    "Iván Balliu",
    "Luiz Felipe",
    "Andrei Ratiu",
    "Pep Chavarría",
    "Jozhua Vertrouwd",
    "Nobel Mendy",
    "Pelayo Fernández",
    "Álvaro García",
    "Unai López",
    "Pedro Díaz",
    "Isi Palazón",
    "Óscar Valentín",
    "Randy Nteka",
    "Pathé Ciss",
    "Fran Pérez",
    "Jorge de Frutos",
    "Sergio Camello",
    "Alexandre Alemão"
  ],
  "RB Leipzig": [
    "Ørjan Nyland",
    "Leopold Zingerle",
    "Maarten Vandevoordt",
    "Willi Orbán",
    "Lukas Klostermann",
    "Benjamin Henrichs",
    "David Raum",
    "Ridle Baku",
    "El Chadaille Bitshiabu",
    "Maxime Estève",
    "Castello Lukeba",
    "Max Finkgrafe",
    "Abdoul Koné",
    "Eljif Elmas",
    "Christoph Baumgartner",
    "Nicolas Seiwald",
    "Rocco Reitz",
    "Antonio Nusa",
    "Ezechiel Banzuzi",
    "Arthur Vermeeren",
    "Assan Ouédraogo",
    "Andrija Maksimovic",
    "Viggo Gebel",
    "Benno Kaltefleiter",
    "Johan Bakayoko",
    "Rômulo",
    "Brajan Gruda",
    "Conrad Harder",
    "Tidiam Gomis",
    "Robert Ramsak",
    "Ayodele Thomas",
    "Sani Suleiman",
    "Samba Konate"
  ],
  "Real Betis": [
    "Álvaro Valles",
    "Yan Zhuravskyi",
    "Marc Bartra",
    "Héctor Bellerín",
    "Diego Llorente",
    "Fran García",
    "Junior Firpo",
    "Natan",
    "Valentín Gómez",
    "Ángel Ortiz",
    "Rodrigo Riquelme",
    "Isco",
    "Giovani Lo Celso",
    "Pablo Fornals",
    "Marc Roca",
    "Álvaro Fidalgo",
    "Nelson Deossa",
    "Aitor Ruibal",
    "Antony",
    "Iker Losada",
    "Abde Ezzalzouli",
    "Cucho Hernández",
    "Pablo García",
    "José Morante"
  ],
  "Real Madrid": [
    "Thibaut Courtois",
    "Andriy Lunin",
    "Antonio Rüdiger",
    "Denzel Dumfries",
    "Ferland Mendy",
    "Trent Alexander-Arnold",
    "Éder Militão",
    "Ibrahima Konaté",
    "Marc Cucurella",
    "Álvaro Carreras",
    "Dean Huijsen",
    "Raúl Asencio",
    "Bernardo Silva",
    "Federico Valverde",
    "Brahim Díaz",
    "Aurélien Tchouaméni",
    "Eduardo Camavinga",
    "Jude Bellingham",
    "Arda Güler",
    "Kylian Mbappé",
    "Vinícius Júnior",
    "Rodrygo",
    "Endrick",
    "Carlos Espí",
    "Yan Diomande"
  ],
  "Real Oviedo": [
    "Aarón Escandell",
    "Miguel Narváez",
    "Dani Calvo",
    "David Costas",
    "Nacho Vidal",
    "Samu Rodríguez",
    "Leander Dendoncker",
    "Alberto Reina",
    "Luka Ilic",
    "Kwasi Sibo",
    "Álex Cardero",
    "Aritz Aldasoro",
    "Youness Lachhab",
    "Aisar",
    "Ovie Ejaria",
    "Jacobo González",
    "Haissem Hassan",
    "Ilyas Chaira",
    "Alexandru Mihai Isfan",
    "Pablo Sáenz",
    "Víctor García Mingo"
  ],
  "Real Salt Lake": [
    "Rafael",
    "Mason Stajduhar",
    "Max Kerkvliet",
    "Luis Rivera",
    "Juan Arias",
    "DeAndre Yedlin",
    "Justen Glad",
    "Alexandros Katranis",
    "Samuel Junqua",
    "Philip Quinton",
    "Kobi Henry",
    "Lukas Engel",
    "Gio Villa",
    "Ruben Messalles",
    "Diego Luna",
    "Stijn Spierings",
    "Pablo Ruiz",
    "Juan Manuel Sanabria",
    "Emeka Eneli",
    "Griffin Dillon",
    "Zach Booth",
    "Noel Caliskan",
    "Luca Moisa",
    "Owen Anderson",
    "Antonio Riquelme",
    "Saba Lobjanidze",
    "Victor Olatunji",
    "Morgan Guilavogui",
    "Ariath Piol",
    "Dominik Marczuk",
    "Chance Cowell",
    "Omar Marquez",
    "Aiden Hezarkhani",
    "Lineker Rodrigues",
    "Van Parker",
    "Sergi Solans"
  ],
  "Real Sociedad": [
    "Álex Remiro",
    "Unai Marrero",
    "Igor Zubeldia",
    "Álvaro Odriozola",
    "Aihen Muñoz",
    "Jon Aramburu",
    "Jon Martín",
    "Iñaki Rupérez",
    "Carlos Soler",
    "Yangel Herrera",
    "Beñat Turrientes",
    "Luka Sucic",
    "Arsen Zakharyan",
    "Pablo Marín",
    "Jon Gorrotxategi",
    "Gonçalo Guedes",
    "Mikel Oyarzabal",
    "Takefusa Kubo",
    "Sergio Gómez",
    "Ander Barrenetxea",
    "Jon Karrikaburu",
    "Orri Óskarsson"
  ],
  "Real Sociedad II": [
    "Aitor Fraga",
    "Iñaki Rupérez",
    "Luken Beitia",
    "Jon Balda",
    "Unax Agote",
    "Eneko Astigarraga",
    "Iker Calderon",
    "Unax Larrañaga",
    "Alex Lebarbier",
    "Mikel Rodriguez",
    "Jon Eceizabarrena",
    "Jon Garro",
    "Gorka Gorosabel",
    "Lander Astiazarán",
    "Tomás Carbonell",
    "Darío Ramírez",
    "Sydney Osazuwa",
    "Daniel Díaz",
    "Ekain Orobengoa",
    "Arkaitz Mariezkurrena",
    "Alex Marchal",
    "Job Ochieng",
    "Gorka Carrera"
  ],
  "Real Valladolid": [
    "Álvaro Aceves",
    "Carlos Clerc",
    "Pablo Tomeo",
    "Trilli",
    "Ramón Martínez",
    "Guillermo Bueno",
    "David Torres",
    "Iván Garriel",
    "Mohamed Jaouab",
    "Koke",
    "Julien Ponceau",
    "Stanko Juric",
    "Victor Meseguer",
    "Mathis Lachuer",
    "Ibrahim Alani",
    "Amath Ndiaye",
    "Iván Alejo",
    "Marcos André",
    "Vegard Østraat Erlien",
    "Stipe Biuk",
    "Juan Latasa",
    "Adrián Arnun",
    "Jorge Delgado"
  ],
  "Red Star FC 93": [
    "Gaetan Poussin",
    "Yanis Benchaouch",
    "Kevin Cabral",
    "Pierre Lemonnier",
    "Bradley Danger",
    "Matthieu Huard",
    "Ryad Hachem",
    "Théo Magnin",
    "Dylan Durivaux",
    "Josué Escartin",
    "Elyaz Zidane",
    "Chaib Lahmer",
    "Saif-Eddine Khaoui",
    "Samuel Renel",
    "Balthazar Pierret",
    "Guilaume Trani",
    "Islamdine Halifa",
    "Damien Durand",
    "Jovany Ikanga",
    "Kémo Cissé",
    "Abdelsamad Hachem"
  ],
  "Remo": [
    "Ivan",
    "Marcelo Rangel",
    "Ygor Vinhas",
    "Alexandre",
    "João Victor",
    "Marllon",
    "Cristian Tassano",
    "Duplexe Tchamba",
    "Léo Andrade",
    "Matheus Piauí",
    "Mayk",
    "Matheus Alexandre",
    "João",
    "Marcelinho",
    "Zé Ivaldo",
    "Rafael",
    "Yago Pikachu",
    "Patrick",
    "José Welison",
    "Zé Ricardo",
    "Leonel Picco",
    "Edson Fernando",
    "Jajá",
    "Franco Catarozzi",
    "David Francisco",
    "Tico",
    "Miguel",
    "Vitor Bueno",
    "Gabriel Taliari",
    "Jaderson",
    "Gabriel Poveda",
    "Alef Manga",
    "Eduardo",
    "Rafael Monti",
    "Andres Gonzalez",
    "Paulo Henrique"
  ],
  "Rentistas": [
    "John Alex Faust",
    "Stéfano Perdomo",
    "Martín Tejera",
    "Guillermo Maidana",
    "Ignacio Ithurralde",
    "Sebastián Ramírez",
    "Luciano Barbosa De Jesús",
    "Nicolás Rodríguez",
    "Nicolás Raguso",
    "Erick Cabaco",
    "Sebastián Sellanes",
    "Gonzalo Bazalo",
    "Anderson Silva de Franca",
    "Paulo Salas",
    "Hugo Soria",
    "Hugo Dorrego",
    "Lucas Rodríguez",
    "José Varela",
    "David Terans",
    "Andre Silva",
    "Marcelo Fernández",
    "Gustavo Alles",
    "Erardo Cocaro"
  ],
  "River Plate": [
    "Ezequiel Centuríon",
    "Santiago Beltrán",
    "Franco Jaroszewicz",
    "Nicolás Otamendi",
    "Marcos Acuña",
    "Juan Portillo",
    "Giovanni González",
    "Lucas Martínez Quarta",
    "Gonzalo Montiel",
    "Francisco Ortega",
    "Tobías Palacio",
    "Lautaruo Rivero",
    "Lucas Obregón",
    "Facundo González",
    "Ángel Susano",
    "Lucas Flores",
    "Thiago Salvatierra",
    "Juan Meza",
    "Mauro Arambarri",
    "Fausto Vera",
    "Lucas Beltrán",
    "Aníbal Moreno",
    "Tomás Galván",
    "Thiago Acosta",
    "Santiago Espíndola",
    "Jonathan Spiff",
    "Lucas Silva",
    "Valentín Lucero",
    "Maximiliano Soria",
    "Sebastián Driussi",
    "Ángel Correa",
    "Rafael Borré",
    "Facundo Colidio",
    "Agustín Ruberto",
    "Tobías Andrada",
    "Felipe Esquivel",
    "Joaquin Freitas",
    "Lautaro Pereyra"
  ],
  "River Plate (Montevideo)": [
    "José Arbio",
    "Facundo Pérez",
    "Brian Ferrares",
    "Lorenzo González",
    "Carlos Rodríguez",
    "Maximiliano Perg",
    "Lucas Camejo",
    "Rodrigo Cabrera",
    "Mathías Rodríguez",
    "Mauricio Gómez",
    "Francisco Triver",
    "Matías De Los Santos",
    "Tomás López",
    "Felipe Chiappini",
    "Alejandro García",
    "Santiago Romero",
    "Bruno Téliz",
    "Rodrigo Rodríguez",
    "Matías Escobar",
    "Diego Sánchez",
    "Cristian Techera",
    "Gabriel Costa",
    "Maximiliano Burruzo",
    "Inti López",
    "Vitinho",
    "Rodrigo Hernández",
    "Diego Vera",
    "Tomás Benardoni"
  ],
  "Rodez Aveyron": [
    "Quentin Braat",
    "Lucas Margueron",
    "Enzo Crombez",
    "Steven Luyambulabiwa",
    "Jean Lambert Evans",
    "Ryan Ponti",
    "Mathis Magnin",
    "Raphael Lipinski",
    "Loni Quenabio",
    "Corentin Issanchou",
    "Luzolo Vangi Vungele",
    "Clément Jolibois",
    "Djibril Mavounia-Kouka",
    "Damjan Pavlovic",
    "Samy Benchama",
    "Octave Joly",
    "Cheick Mohamed Doumbia",
    "Antonin Cartillier",
    "Jordan Mendes",
    "Kenny Nagera",
    "Hermann Tebily",
    "Ibrahima Baldé",
    "Mehdi Baaloudj",
    "Mathis Touho"
  ],
  "Rosario Central": [
    "Leonardo Sosa",
    "Axel Werner",
    "Jeremias Ledesma",
    "Damian Fernandez",
    "Ezequiel Zapata",
    "Juan Komar",
    "Alexis Soto",
    "Facundo Mallo",
    "Emanuel Coronel",
    "Santiago Burgos",
    "Sebastian Zaracho",
    "Gastón Ávila",
    "Agustín Sández",
    "Ulises Ciccioli",
    "Juan Giménez",
    "Luca Raffin",
    "Ignacio Ovando",
    "Elías Verón",
    "Leonardo Rios",
    "Alvaro Güich",
    "Juan Scaglia",
    "Asael Oviedo",
    "Lucas Ramos",
    "Ángel Di María",
    "Kevin Gutiérrez",
    "Guillermo Fernández",
    "Franco Cervi",
    "Jáminton Campaz",
    "Federico Navarro",
    "Vicente Pizarro",
    "Franco Ibarra",
    "Alan Rodríguez",
    "Gaspar Duarte",
    "Giovanni Cantizano",
    "Santiago Segovia",
    "Ignacio Moreno",
    "Tomás Salteño",
    "Paolo Giaccone",
    "Bautista Cantero",
    "Juan Guzman",
    "Joaquín Espina",
    "Marco Ruben",
    "Marcelo Cabrera",
    "Enzo Copetti",
    "Tomas Badaloni",
    "Julián Fernández",
    "Fabricio Oviedo",
    "Lisandro Duarte",
    "Paulo Bustos",
    "Gino Pavoni",
    "Valentino Felici"
  ],
  "Saint-Étienne": [
    "Gautier Larsonneur",
    "Lucas Lavallée",
    "Mamour Ndiaye",
    "Maxime Bernauer",
    "Mickael Nade",
    "João Ferreira",
    "Ebenezer Annan",
    "Julien Le Cardinal",
    "Chico Lamba",
    "Sohaib Nair",
    "Lassana Traoré",
    "Kévin Pedro",
    "Strahinja Stojkovic",
    "Aimen Moueffek",
    "Jakob Breum",
    "Pierre Ekwah",
    "Mahmoud Jaber",
    "Áron Csongvai",
    "Igor Miladinovic",
    "Paul Eymard",
    "Luan Gadegbeku",
    "Irvin Cardona",
    "Zuriko Davitashvili",
    "Thierno Ballo",
    "Ben Old",
    "Lucas Stassin",
    "Augustine Boakye",
    "Joshua Duffus",
    "Djylian N'Guessan",
    "Marten-Chris Paalberg"
  ],
  "Sampdoria": [
    "Nicola Ravaglia",
    "Simone Ghidotti",
    "Andrey Krastev",
    "Alex Ferrari",
    "Lorenzo Venuti",
    "Fabio Depaoli",
    "Alessandro Di Pardo",
    "Alessandro Pio Riccio",
    "Simone Giordano",
    "Alessio Papasergio",
    "Karim Diop",
    "Liam Henderson",
    "Francesco Conti",
    "Matteo Ricci",
    "Jordan Ferri",
    "Oliver Abildgaard",
    "Stefan Amarandei",
    "Massimo Coda"
  ],
  "San Diego FC": [
    "CJ dos Santos",
    "Pablo Sisniega",
    "Marcus Ryu Alstrup",
    "Duran Ferree",
    "Christopher McVey",
    "Dagur Thórhallsson",
    "Ian Murphy",
    "William Kumado",
    "Oscar Verhoeven",
    "Kieran Sargeant",
    "Luca Bombino",
    "Wilson Eisner",
    "Ian Pilcher",
    "Osvald Søe",
    "Aníbal Godoy",
    "Emmanuel Boateng",
    "Jeppe Tverskov",
    "Onni Valakari",
    "Bryce Duke",
    "Gabriel Pirani",
    "Elias Achouri",
    "David Vazquez",
    "Pedro Soma",
    "Manu Duah",
    "Lewis Morgan",
    "Marcus Ingvartsen",
    "Amahl Pellegrino",
    "Anders Dreyer",
    "Alex Mighten",
    "Alejandro Alvarado Jr.",
    "Bryan Zamblé"
  ],
  "San Jose Earthquakes": [
    "Angus Gunn",
    "Earl Edwards",
    "Francesco Montali",
    "Nate Crockford",
    "Luca Ulrich",
    "Dave Romney",
    "Vítor Costa",
    "Paul Marie",
    "DeJuan Jones",
    "Jack Jasinski",
    "Max Floriani",
    "Jamar Ricketts",
    "Reid Roberts",
    "Jonathan Gonzalez",
    "Ronaldo Vieira",
    "Jack Skahan",
    "Ian Harkes",
    "Noel Buck",
    "Niko Tsakiris",
    "Edwyn Mendoza",
    "Beau Leroux",
    "Kaedren Spivey",
    "Nick Fernandez",
    "Rohan Rajagopal",
    "Timo Werner",
    "Darius Johnson",
    "Preston Judd",
    "Ousseni Bouda",
    "Benjamin Kikanovic",
    "Nonso Adimabua"
  ],
  "San Lorenzo": [
    "José Devecchi",
    "Orlando Gill",
    "Mateo Clemente",
    "Daniel Herrera",
    "Emiliano Amor",
    "Danilo Arboleda",
    "Gastón Hernández",
    "Guzmán Corujo",
    "Franco Lorenzón",
    "Ezequiel Herrera",
    "Mathías De Ritis",
    "Oscar Arias",
    "Alejo Cordoba",
    "Lautaro Montenegro",
    "Ramiro Pedroza",
    "Teo Rodríguez",
    "Nicolás Blanco",
    "Nicolas Tripichio",
    "Juan Álvarez",
    "Nahuel Barrios",
    "Carlos Insaurralde",
    "Gonzalo Abrego",
    "Gonzalo Alassia",
    "Martin Rio",
    "Mauricio Cardillo",
    "Uriel Ojeda",
    "Juan Rattalino",
    "Ignacio Perruzzi",
    "Facundo Gulli",
    "Ezequiel Cerutti",
    "Diego Herazo",
    "Gustavo Del Prete",
    "Alexis Cuello",
    "Matías Reali",
    "Matías Hernández",
    "Rodrigo Auzmendi",
    "Agustín Ladstatter",
    "Branco Salinardi"
  ],
  "San Martín de San Juan": [
    "Sebastián Díaz",
    "Federico Bonansea",
    "Maximiliano Velazco",
    "Lautaro Garzón",
    "Francisco Emanuel Valenzuela Baron",
    "Lucas Acosta",
    "Emanuel Aguilera",
    "Leonel Álvarez",
    "Federico Murillo",
    "Mauro Osores",
    "Facundo Nadalín",
    "Hernán Zuliani",
    "Lucas Verón",
    "Nicolas Paz",
    "Sebastián González",
    "Guillermo Acosta",
    "Leonardo Monje",
    "Nicolas Pelaitay",
    "Carlo Lattanzio",
    "Diego Mercado",
    "Gonzalo Lucero",
    "Sebastián Jaurena",
    "Luciano Ferreyra",
    "Ramiro Rumbolo",
    "Manuel Cocca",
    "Luciano Riveros",
    "Nicolás Iachetti",
    "Rodrigo Nieva",
    "Gabriel Hachen",
    "Franco Coronel",
    "Genaro Rossi",
    "Nazareno Funez",
    "Bruno Juncos",
    "Francisco Valenzuela",
    "Lautaro Agüero"
  ],
  "San Martín de Tucumán": [
    "Juan Jaime",
    "Darío Sand",
    "Nahuel Manganelli",
    "Nicolás Ferreyra",
    "Victor Salazar",
    "Ezequiel Parnisari",
    "Rodrigo Ayala",
    "Nahuel Gallardo",
    "Jorge Emanuel Juárez",
    "Guillermo Rodríguez",
    "Laureano Rodríguez",
    "Alejandro Galván",
    "Nicolás Castro",
    "Aníbal Paz",
    "Matias Ariel Garcia",
    "Gabriel Carabajal",
    "Leonardo Monroy",
    "Jesús Soraire",
    "Kevin López",
    "Milton Ríos",
    "Alan Cisnero",
    "Agustín Graneros",
    "Octavio Zamora",
    "Juan Valdez",
    "Diego Diellos",
    "Gonzalo Rodríguez",
    "Santiago Briñone",
    "Álvaro Veliez",
    "Bruno Cabrera",
    "Nicolás Moreno",
    "Lautaro Ovando",
    "Mauro Véron",
    "Luca Arfaras",
    "Leonel Sir"
  ],
  "San Miguel": [
    "Matias Escobar",
    "Andrés Sosa",
    "Mateo Reynoso",
    "Facundo Cardozo",
    "Kevin Ceceri",
    "Damián Adín",
    "Dixon Rentería",
    "Franco Aguirre",
    "Lucio Pérez",
    "Alexis Cruz",
    "Iván Ramírez",
    "David Müller",
    "Leandro Ortiz",
    "Leandro Desábato",
    "Jorge Ferrero",
    "Tomas Diaz Grassano",
    "Matías Benítez",
    "Mateo Serra",
    "Fabricio Almeida",
    "Thomas Carosio",
    "Tiago Gordillo",
    "Elian De La Cruz",
    "Daniel Juárez",
    "Bruno Nasta",
    "Lucas Delgado",
    "Lucas Brochero",
    "Tomás Jerez",
    "Máximo Oses"
  ],
  "San Telmo": [
    "Juan Rial",
    "Joaquín Enrico",
    "Facundo Roncaglia",
    "Patricio Romero",
    "Martín González",
    "Carlos Casas",
    "Juan Motroni",
    "Lázaro Britez",
    "Rodrigo Dinocco",
    "Lautaro Buteler",
    "Cristian Núñez",
    "Fabián Henríquez",
    "Javier Iritier",
    "Matías Ledesma",
    "Juan Zurbriggen",
    "Iñaki Lartirigoyen",
    "Elías Britez",
    "Gabriel Paredes",
    "Ian Pardo",
    "Leonel Pollacchi",
    "Evan Álvarez",
    "Cristian Ortíz",
    "Román Gamarra",
    "Renzo Uriburu",
    "Joel Gonzalez",
    "Facundo Báez",
    "Jeronimo Porto",
    "Martín Batallini",
    "Gastón Viera",
    "Elias Peralta",
    "Matías Salerno"
  ],
  "Santos": [
    "João Paulo",
    "Gabriel Brazão",
    "Diogenes",
    "Rodrigo Falcão",
    "João Pedro",
    "Arthur Vale",
    "Luan Peres",
    "Lucas Verissimo",
    "Adonis Frias",
    "Igor",
    "Gonzalo Escobar",
    "Marcelo Tórrez",
    "Vinicius Lira",
    "João Alencar",
    "Rafael Gonzaga",
    "João Ananias",
    "Willian Arão",
    "João Schmidt",
    "Thaciano",
    "Christian Oliva",
    "Álvaro Barreal",
    "Gabriel Menino",
    "Miguel Terceros",
    "Nicola Profeta",
    "Gabriel Bontempo",
    "Gustavo Henrique",
    "Vinícius Rocha",
    "Pepê Fermino",
    "Kauan Barreto",
    "Samuel Mendes",
    "Vinicius Fabri",
    "Neymar",
    "Gustavo Caballero",
    "Gabriel Barbosa",
    "Rony",
    "Benjamín Rollheiser",
    "Moisés",
    "João Victor Dos Santos Alves",
    "Mateus Xavier",
    "Kaio Ganga",
    "Nadson",
    "Robinho Junior",
    "Pedro Assis",
    "Fernando Pradella Rocha",
    "David Nogueira",
    "Gabriel Follmer",
    "Davizinho"
  ],
  "São Bernardo": [
    "Alex Alves",
    "Júnior Oliveira",
    "Leonard Langhans",
    "Jemerson",
    "Rodrigo Ferreira",
    "Pará",
    "Mário Sérgio",
    "Matheus Salustiano",
    "Helder Gomes Maciel",
    "Augusto",
    "Hugo",
    "Wellington Jesus Cardoso",
    "Luizão",
    "João Pedro",
    "Hyoran",
    "Foguinho",
    "Marcão Silva",
    "Lucas Fernandes",
    "Rodrigo Andrade",
    "Lino",
    "Lucas Lima",
    "Eduardo",
    "Felipe Rodrigues Saraiva Freitas",
    "Breno Ruan Melo Almeida",
    "Daniel Amorim",
    "Felipe Garcia",
    "Pedro Vitor",
    "Pedrinho",
    "Echaporã",
    "Fabrício Daniel",
    "Lucas Reis",
    "Lucas Rian Santos Oliveira",
    "Daniel Davi Simao Roque"
  ],
  "São Paulo": [
    "Rafael",
    "Carlos Coronel",
    "Young",
    "Felipe Preis",
    "João Pedro",
    "Cédric",
    "Rafael Tolói",
    "Wendell",
    "Robert Arboleda",
    "Lucas Ramon",
    "Domingos Duarte",
    "Buta",
    "Iago",
    "Enzo Díaz",
    "Sabino",
    "Matheus Souza",
    "Isac",
    "Igor Felisberto",
    "Guilherme Reis",
    "Luis Osorio",
    "Igão",
    "Hugo",
    "Maik",
    "Nicolas",
    "Felipe Oliveira",
    "Danielzinho",
    "Cauly",
    "Marcos Antonio",
    "Luan",
    "Damián Bobadilla",
    "Pablo Maia",
    "Matheus Ferreira",
    "Pedro Ferreira",
    "Bezerra",
    "Djhordney Ferreira",
    "Robert William",
    "Lucas Moura",
    "Jonathan Calleri",
    "Luciano",
    "Artur",
    "Joao Victor",
    "André Silva",
    "Ferreira",
    "Juan Potes",
    "Paulo Sérgio",
    "Ryan Francisco",
    "Lucca Marques",
    "Gustavo Santana",
    "Tetê",
    "Brenno"
  ],
  "Sarmiento (Junín)": [
    "Iván Arboleda",
    "Thyago Ayala",
    "Juan Insaurralde",
    "Nicolás Pasquini",
    "Lucas Suarez",
    "Joel Godoy",
    "Renzo Orihuela",
    "Gastón Arturia",
    "Juan Manuel Cabrera",
    "Thiago Santamaría",
    "Ulises Giménez",
    "Jeremías Vallejos",
    "Agustín Seyral",
    "Jonathan Gómez",
    "Mauricio Martínez",
    "Manuel Garcia",
    "Yair Arismendi",
    "Cristian Zabala",
    "Carlos Villalba",
    "Gabriel Díaz",
    "Julian Contrera",
    "Osmar Giménez",
    "Julián Mavilla",
    "Elián Giménez",
    "Jhon Rentería",
    "Facundo Alaggia",
    "Alexis González",
    "Diego Churín",
    "Jonathan Herrera",
    "Pablo Magnin",
    "Junior Marabel",
    "Gastón González",
    "Santiago Salle",
    "Brandon Márquez"
  ],
  "Sassuolo": [
    "Stefano Turati",
    "Jay Idzes",
    "Fali Candé",
    "Josh Doig",
    "Edoardo Pieragnolo",
    "Tommaso Macchioni",
    "Giorgio Vezzosi",
    "Nemanja Matic",
    "Kristian Thorstvedt",
    "Daniel Boloca",
    "Edoardo Iannoni",
    "Ismaël Koné",
    "Cristian Volpato",
    "Luca Lipani",
    "Darryl Bakola",
    "Domenico Berardi",
    "Andrea Pinamonti",
    "Armand Laurienté",
    "Luca Moro"
  ],
  "SC Paderborn 07": [
    "Markus Schubert",
    "Nahuel Nicolas Noll",
    "Florian Pruhs",
    "Felix Götze",
    "Marcel Hoffmeier",
    "Laurin Curda",
    "Mattes Hansen",
    "Jano Horst",
    "Nyamekye Awortwie-Grant",
    "Tjark Scheller",
    "Clemens Lippmann",
    "Tom Baack",
    "Raphael Obermair",
    "Sebastian Klaas",
    "Nick Batzner",
    "Santiago Castaneda",
    "Timur Gayret",
    "Jonah Sticker",
    "Mika Baur",
    "Luka Djuric",
    "Niklas Mohr",
    "Sven Michel",
    "Steffen Tigges",
    "Stefano Marino",
    "Kennedy Okpala",
    "Ruben Müller",
    "Lasse Eickel",
    "Albert Millgramm"
  ],
  "Schalke 04": [
    "Kevin Müller",
    "Loris Karius",
    "Johannes Siebeking",
    "Timo Becker",
    "Robin Gosens",
    "Nikola Katic",
    "Maximilian Wöber",
    "Anton Donkor",
    "Hasan Kurucay",
    "Adrian Gantenbein",
    "Dylan Leonard",
    "Vitalie Becker",
    "Mert Can Ayhan",
    "Janik Bachmann",
    "Finn Porath",
    "Ron Schallenberg",
    "Dejan Ljubicic",
    "Adil Aouchiche",
    "Satoshi Tanaka",
    "Soufian El-Faouzi",
    "Max Grüger",
    "Mauro Zalazar",
    "Luca Vozar",
    "Moussa Sylla",
    "Kenan Karaman",
    "Bryan Lasme",
    "Junior Adamu",
    "Christian Gomis",
    "Emil Höjlund",
    "Zaid Amoussou-Tchibara"
  ],
  "Seattle Sounders FC": [
    "Stefan Frei",
    "Andy Thomas",
    "Max Anchor",
    "Kim Kee-Hee",
    "Yeimar Gómez",
    "Nouhou Tolo",
    "Jackson Ragen",
    "Alex Roldan",
    "Antino Lopez",
    "Ryan Sailor",
    "Mark O'Neill",
    "Stuart Hawkins",
    "Gallatin Sandnes",
    "Albert Rusnák",
    "Cristian Roldan",
    "Hassani Dotson",
    "Peter Kingston",
    "Kalani Kossa-Rienzi",
    "Nikola Petkovic",
    "Snyder Brunell",
    "Sebastian Gomez",
    "Charlie Gaffney",
    "Edson Carli",
    "Paul Arriola",
    "Jordan Morris",
    "Jesús Ferreira",
    "Paul Rothrock",
    "Daniel Musovski",
    "Pedro de la Vega",
    "Osaze De Rosario",
    "Mark Bronnik"
  ],
  "Sevilla": [
    "Odisseas Vlachodimos",
    "Marcão",
    "Fábio Cardoso",
    "Gabriel Suazo",
    "José Ángel Carmona",
    "Federico Gattoni",
    "Adrià Pedrosa",
    "Andrés Castrín",
    "Enrique Salas",
    "Oso",
    "Rubén Vargas",
    "Lucien Agoumé",
    "Manu Bueno",
    "Alexis Sánchez",
    "Chidera Ejuke",
    "Alfonso González",
    "Peque",
    "Isaac Romero"
  ],
  "Sheffield United": [
    "Adam Rhys Davies",
    "Michael Cooper",
    "Japhet Tanganga",
    "Harrison Burrows",
    "Jamie Shackleton",
    "Sam McCallum",
    "Femi Seriki",
    "Mark McGuinness",
    "Nils Zätterström",
    "Jairo Riedewald",
    "Joe Rothwell",
    "Gustavo Hamer",
    "Callum O'Hare",
    "Tahith Chong",
    "Oliver Arblaster",
    "Sydie Peck",
    "Patrick Bamford",
    "Tyrese Campbell",
    "Thomas Cannon",
    "Ryan One"
  ],
  "Sochaux": [
    "Mehdi Jeannin",
    "Alexandre Pierre",
    "Matthis Schübler-Lecart",
    "Mathieu Peybernes",
    "Benjaloud Youssouf",
    "Saad Agouzoul",
    "Dylan Tavares",
    "Arthur Vitelli",
    "Dalangunypole Gomis",
    "Élie N'Gatta",
    "Mohamed Toure",
    "Bakary Diawara",
    "Jonathan Mexique",
    "Julien Masson",
    "Victor Lobry",
    "Honoré Bayanginisa",
    "Pape Yatma Diop",
    "Boubacar Fofana",
    "Kapitbafan Djoco",
    "Samy Baghdadi",
    "Benjamin Gomel",
    "Mathis Claricia",
    "Julien Vetro",
    "Landry Nomel",
    "Noa Kotto Kotto Mouyema",
    "Victor Monthieu",
    "Ethan Cortes"
  ],
  "Southampton": [
    "George Long",
    "Aaron Ramsdale",
    "Gavin Bazunu",
    "Daniel Peretz",
    "Jack Stephens",
    "James Bree",
    "Mads Roerslev",
    "Ryan Manning",
    "Yukinari Sugawara",
    "Nathan Wood",
    "Taylor Harwood-Bellis",
    "Welington",
    "Joshua Quarshie",
    "Finn Azaz",
    "Flynn Downes",
    "Samuel Edozie",
    "Tom Fellows",
    "Shea Charles",
    "Cameron Bragg",
    "Kuryu Matsuki",
    "Léo Scienza",
    "Caspar Jander",
    "Moses Sesay",
    "Barnaby Williams",
    "Cyle Larin",
    "Ben Brereton Díaz",
    "Cameron Archer",
    "Lewis Dobbin",
    "Damion Downs"
  ],
  "Sport Recife": [
    "Thiago Couto",
    "Dênis",
    "Antônio Adriano",
    "Victor Hugo Barbosa De Farias",
    "Erick",
    "Edson Pereira",
    "Ze Marcos",
    "Marcelo Benevenuto",
    "Claudinho",
    "Felipinho",
    "Marcelo",
    "Habraão",
    "Kayky",
    "Rafinha",
    "Augusto Pucci",
    "Caio Moura",
    "Patrick",
    "Matheus Bessa",
    "Richarlyson",
    "Willian",
    "Clayson",
    "Carlos De Peña",
    "Yago Felipe",
    "José Gabriel",
    "Biel",
    "Pedro",
    "Fábio Matheus",
    "Murilo Rhikman",
    "Adriel",
    "Thalis",
    "Felipinho Santos",
    "Zé Roberto",
    "Pedro Perotti",
    "Dudu Teodora",
    "Marlon",
    "Diego Hernández",
    "Chrystian",
    "Jefinho",
    "Lipão",
    "Maron",
    "Arthur Moreira",
    "Fernandinho"
  ],
  "Sporting Gijón": [
    "Gerard Moreno",
    "Rubén Yáñez",
    "Pablo García",
    "Alex Diego",
    "Pablo Vázquez",
    "Guillermo Rosas",
    "Yann Kembo",
    "Diego Sanchez",
    "Carlos Hernandez",
    "Mamadou Loum",
    "Àlex Corredera",
    "César Gelabert",
    "Gaspar Campos",
    "Ignacio Martín",
    "Manu Rodríguez",
    "Juan Otero",
    "Andrés Ferrari",
    "Enol Prendes"
  ],
  "Sporting Kansas City": [
    "Stefan Cleveland",
    "John Pulskamp",
    "Ryan Schewe",
    "Jack Kortkamp",
    "Jayden Reid",
    "Ian James",
    "Emir Karic",
    "Zorhan Bassong",
    "Jansen Miller",
    "Moisés Mosquera",
    "Ethan Bartlow",
    "Or Blorian",
    "Justin Reynolds",
    "Diego Borges",
    "Wyatt Meyer",
    "Jacob Bartlett",
    "Pierre Lurot",
    "Manu García",
    "Lasse Berg Johnsen",
    "Jacob Davis",
    "Johann Ortiz",
    "Shane Donovan",
    "Zamir Loyo Reynaga",
    "Kwaku Agyabeng",
    "Dejan Joveljic",
    "Shapi Suleymanov",
    "Calvin Harris",
    "Capita",
    "Stephen Afrifa",
    "Taylor Calheira"
  ],
  "St. Louis CITY SC": [
    "Roman Bürki",
    "Benjamin Lundt",
    "Christian Olivares",
    "Colin Welsh",
    "Timo Baumgartl",
    "Rafael Santos",
    "Tomas Totland",
    "Jaziel Orozco",
    "Kyle Hiebert",
    "Lukas MacNaughton",
    "Fallou Fall",
    "Mamadou Fall",
    "Eduard Löwen",
    "Christopher Durkin",
    "Marcel Hartel",
    "Alexandru Matan",
    "Tomas Ostrak",
    "Dante Polvara",
    "Daniel Edelman",
    "Conrad Wallem",
    "Miguel Perez",
    "Célio Pompeu",
    "Mykhi Joyner",
    "Tyson Pearce",
    "Simon Becher",
    "Jeong Sang-Bin",
    "Palmer Ault",
    "Caden Glover",
    "Brendan McSorley"
  ],
  "St. Pauli": [
    "Ben Voll",
    "Simon Spari",
    "Marcus Mathiesen",
    "Lars Ritzka",
    "Adam Dzwigala",
    "David Nemeth",
    "Arkadiusz Pyrka",
    "Rony Jansson",
    "Jannik Robatsch",
    "Louis Oppie",
    "Tomoya Ando",
    "Mathias Rasmussen",
    "Eric Smith",
    "Mathias Pereira Lage",
    "Connor Metcalfe",
    "Joel Chima Fujita",
    "Erik Ahlstrand",
    "Samuel Klein",
    "Marwin Schmitz",
    "Nick Schmidt",
    "Branimir Hrgota",
    "Martijn Kaars",
    "Taichi Hara",
    "Scott Banks",
    "Ricky-Jade Jones",
    "Abdoulie Ceesay"
  ],
  "Stade de Reims": [
    "Edin Omeragic",
    "Tom Hülsmann",
    "Soumaïla Sylla",
    "Sergio Akieme",
    "Joseph Okumu",
    "Armel Junior Zohouri",
    "N'Tamon Elie Ahouonon",
    "Jean Mambuku",
    "Yohan Demoncy",
    "Reda Khadra",
    "Theo Leoni",
    "John Finn",
    "Yaya Fofana",
    "Mory Gbane",
    "Ange Tia",
    "Théo Deflorenne",
    "Jordan Pefok",
    "Keito Nakamura",
    "Mohamed Daramy",
    "Sambou Soumano",
    "Salama",
    "Hafiz Ibrahim",
    "Lenny Sylla"
  ],
  "Stade Laval": [
    "Mamadou Samassa",
    "Maxime Hautbois",
    "Mathis Ntessa",
    "Lucas Droyaux",
    "Moïse Adilehou",
    "William Bianda",
    "Aboubacar Lô",
    "Jules Gaudin",
    "Sidi Bane",
    "Mattéo Commaret",
    "Joseph Layousse",
    "Esteban Mouton",
    "Alessio Beaudouin",
    "Mamadou Sidibé",
    "Francis Coquelin",
    "Cyril Mandouki",
    "Teddy Bouriaud",
    "Sam Sanna",
    "Malik Sellouki",
    "Julien Maggiotti",
    "Ethan Clavreul",
    "Aboubakary Kanté",
    "Noa Mupemba",
    "Trévis Dago",
    "Aymeric Faurand-Tournaire",
    "Mathys Houdayer"
  ],
  "Stade Rennais": [
    "Brice Samba",
    "Nicolas Lemaitre",
    "Lilian Brassier",
    "Anthony Rouault",
    "Alidu Seidu",
    "Quentin Merlin",
    "Mahamadou Nagida",
    "Abdelhamid Aït Boudlal",
    "Gonçalo Oliveira",
    "Adrien Thomasson",
    "Przemyslaw Frankowski",
    "Valentin Rongier",
    "Sebastian Szymanski",
    "Mahdi Camara",
    "Djaoui Cissé",
    "Breel Embolo",
    "Ludovic Blas",
    "Arnaud Nordin",
    "Mousa Al-Tamari",
    "Issa Soumaré",
    "Esteban Lepaul",
    "Elias Legendre"
  ],
  "Stoke City": [
    "Frank Fielding",
    "Viktor Johansson",
    "Joshua Griffiths",
    "Luke Graham",
    "Aaron Cresswell",
    "Ben Gibson",
    "Ben Wilmot",
    "Eric Bocat",
    "Junior Tchamadeu",
    "Bosun Lawal",
    "Maksym Talovierov",
    "Jaden Mears",
    "Will Smith",
    "Ethan Galbraith",
    "Ben Pearson",
    "Svante Ingelsson",
    "Tatsuki Seko",
    "Tomás Rigo",
    "Bae Jun-Ho",
    "Djibril Soumaré",
    "Ruben Curley",
    "Gabriel Kelly",
    "Raphael-Pijus Otegbayo",
    "Jerome Osei Kyremeh",
    "Lamine Cisse",
    "Sam Gallagher",
    "Sorba Thomas",
    "Róbert Bozeník",
    "Million Manhoef",
    "Milan Smit",
    "Ato Ampah"
  ],
  "Strasbourg": [
    "Soumaila Coulibaly",
    "Ben Chilwell",
    "Andrew Omobamidele",
    "Ismael Doukoure",
    "Abakar Sylla",
    "Guela Doué",
    "Lucas Høgsberg",
    "Julio Enciso",
    "Sebastian Nanasi",
    "Abdoul Ouattara",
    "Maximillian Oyedele",
    "Pape Diop",
    "Mathis Amougou",
    "Rabby Nzingoula",
    "Samir El Mourabet",
    "Sékou Mara",
    "Diego Moreira",
    "Martial Godo",
    "Samuel Amo-Ameyaw",
    "Joaquín Panichelli",
    "Gessime Yassine",
    "Rayane Messi"
  ],
  "Sudtirol": [
    "Marius Adamonis",
    "Daniel Theiner",
    "Lorenzo Bonifacio",
    "Andrea Masiello",
    "Frederic Veseli",
    "Simone Davi",
    "Hamza El Kaouakibi",
    "Federico Davi",
    "Nicola Pietrangeli",
    "Carlo Sabatini",
    "Salvatore Molina",
    "Daniele Casiraghi",
    "Domen Crnigoj",
    "Fabian Tait",
    "Karim Zedadka",
    "Simone Tronchin",
    "Marco Frigerio",
    "Jacopo Martini",
    "Dhirar Brik",
    "Silvio Merkaj"
  ],
  "Sunderland": [
    "Simon Moore",
    "Anthony Patterson",
    "Robin Roefs",
    "Melker Ellborg",
    "Thomas Meunier",
    "Nordi Mukiele",
    "Omar Alderete",
    "Reinildo Mandava",
    "Ajibola Alese",
    "Danny Ballard",
    "Trai Hume",
    "Jenson Seelt",
    "Leo Hjelde",
    "Archie Lightfoot",
    "Ben Kindon",
    "Abdoullah Ba",
    "Granit Xhaka",
    "Luke O'Nien",
    "Alan Browne",
    "Enzo Le Fée",
    "Habib Diarra",
    "Noah Sadiki",
    "Chris Rigg",
    "Tom Proctor",
    "Charles Richard Dinsdale",
    "Wilson Isidor",
    "Brian Brobbey",
    "Simon Adingra",
    "Nilson Angulo",
    "Romaine Mundle",
    "Chemsdine Talbi",
    "Jocelin Ta Bi",
    "Felix Scott"
  ],
  "Swansea City": [
    "Paul Farman",
    "Lawrence Vigouroux",
    "Andrew Fisher",
    "Cameron Burgess",
    "Josh Tymon",
    "Joshua Key",
    "Ben Cabango",
    "Daniel Watts",
    "Jay Fulton",
    "Marko Stamenic",
    "Gonçalo Franco",
    "Leo Walta",
    "Melker Widell",
    "Thomas Woodward",
    "Elijah Just",
    "Adam Idah",
    "Eom Ji-Sung",
    "Zeidane Inoussa",
    "Ronald",
    "Zan Vipotnik",
    "Joseph Opoku"
  ],
  "Tacuarembó FC": [
    "Federico Pintado",
    "Paolo Martínez",
    "Claudio Dafonte",
    "Maximiliano Camargo",
    "Martín Marta",
    "Federico Ferreira",
    "Lucas López",
    "Ayrton Castro",
    "Enzo Acosta",
    "Mateo Pereyra",
    "Luciano Píriz",
    "Sebastián Píriz",
    "Joaquín Moreira",
    "Anderson Brum",
    "Agustín Coitto",
    "Ian López",
    "José Duarte",
    "Mauro Estol",
    "Esteban de Lima",
    "Santiago Vargas",
    "Nicolás González",
    "Juan Rodríguez",
    "Diego Méndez",
    "Geremy Mesa",
    "Nicolás Mello",
    "Dilan Ilarraz",
    "Pablo López",
    "Lucão",
    "Tizian Varela",
    "Néstor Álvarez",
    "Tomás Pastorino"
  ],
  "Talleres (Córdoba)": [
    "Ezequiel Unsain",
    "Jeremías Florentín",
    "Santino Barbi",
    "Franco Yennerich",
    "José Palomino",
    "Matías Catalán",
    "Gabriel Báez",
    "Rodrigo Guth",
    "Augusto Schott",
    "Román Riquelme",
    "Santiago Fernández",
    "Valentín Fascendini",
    "Alexandro Maidana",
    "Timoteo Chamorro",
    "Lucio Ferrari",
    "Thiago Baroni",
    "Federico Fattori",
    "Franco Cristaldo",
    "Juan Sforza",
    "Mateo Caceres",
    "Alejandro Galarza",
    "Matias Gomez",
    "Giovanni Baroni",
    "Lautaro Ortiz",
    "Bruno Trey",
    "Diego Valoyes",
    "Ronaldo Martínez",
    "Rick",
    "Valentin Depietri",
    "Bruno Barticciotto",
    "Valentín Dávila",
    "Ignacio Alastra",
    "Emiliano Chiavassa",
    "Gonzalo Nuccio"
  ],
  "Temperley": [
    "Ezequiel Mastriola",
    "Jerónimo Pourtau",
    "Valentin Diaz",
    "Lisandro Morrone",
    "Nicolás Molina",
    "Rodrigo Mazur",
    "Pedro Souto",
    "Lucas Angelini",
    "Santiago Flores",
    "Iago Iriarte",
    "Valentino Werro",
    "Valentin Aguiñagalde",
    "Matías Calzón",
    "Franco Tirotta",
    "Luciano Nieto",
    "Adrián Arregui",
    "Gerónimo Tomasetti",
    "Franco Diaz",
    "Lucas Richarte",
    "Lorenzo Monti Azpiazu",
    "Franco Benítez",
    "Nicolás Ávalos",
    "Gabriel Hauche",
    "Brandán Fernando",
    "Jonathan Díaz",
    "Eduardo Melo",
    "Marcos Echeverría",
    "Oswaldo Pacheco",
    "Facundo Krüger",
    "Julian Carrasco",
    "Bautista Fernández",
    "Francisco Silva",
    "Román Quiroga"
  ],
  "Tenerife": [
    "Sergio Padilla",
    "Dani Martín",
    "Gabriel Lozano",
    "Marc Mateu",
    "Álvaro González",
    "José León",
    "Anthony Landázuri",
    "David Rodríguez Ramos",
    "César Álvarez",
    "Juanjo",
    "Nacho Gil",
    "Daniel Fernández",
    "Fabricio",
    "Enric Gallego",
    "Jesús De Miguel",
    "Iván Chapela",
    "Noel López",
    "Alassán Manjam Gutiérrez",
    "Francisco Sabina",
    "Mahamadou Balde"
  ],
  "Tigre": [
    "Lautaro Morales",
    "Felipe Zenobio",
    "Luka Fuster",
    "Máximo Leguizamón",
    "Juan Villalba",
    "Ramón Arias",
    "Federico Álvarez",
    "Guillermo Soto",
    "Joaquín Laso",
    "Nahuel Banegas",
    "Alan Barrionuevo",
    "Gonzalo Requena",
    "Thiago Sanchez",
    "Valentin Moreno",
    "Angelo Marchese",
    "Luciano Minniti",
    "Bautista Feversani",
    "Alex González",
    "Lucas Molas",
    "Román Saravia",
    "Fabricio Córdoba",
    "Gonzalo Martínez",
    "Marco Rivas",
    "Jalil Elías",
    "Gastón Pérez",
    "Hector Garay",
    "Sebastián Medina",
    "Bruno Leyes",
    "Simón Rivero",
    "Elías Cabrera",
    "Jabes Saralegui",
    "Santiago González",
    "Nicolás Dubersarsky",
    "Tiago Serrago",
    "Sebastián Lezcano",
    "Nicolás Afonso",
    "Lucian Carracedo",
    "Román Pesolilla",
    "Alfio Oviedo",
    "José Romero",
    "Ignacio Russo",
    "Santiago López",
    "Ian Subiabre",
    "Manuel Fernández",
    "Ignacio Peluffo",
    "Jordan Andrusisen",
    "Benjamín Figueredo",
    "Brandon Leszczuk",
    "Santino Galesio"
  ],
  "Torino": [
    "Alberto Paleari",
    "Franco Israel",
    "Lapo Siviero",
    "Marcus Holmgren Pedersen",
    "Cristiano Biraghi",
    "Adrian Ismajli",
    "Saúl Coco",
    "Nikola Vlasic",
    "Ivan Ilic",
    "Emirhan Ilkhan",
    "Cesare Casadei",
    "Gvidas Gineitis",
    "Wisdom Acquah",
    "Duván Zapata",
    "Ché Adams",
    "Zakaria Aboukhlal",
    "Zanos Savva",
    "Alieu Njie",
    "Tommaso Gabellini"
  ],
  "Toronto FC": [
    "William Yarbrough",
    "Luka Gavran",
    "Adisa De Rosario",
    "Walker Zimmerman",
    "Benjamín Kuscevic",
    "Raheem Edwards",
    "Kobe Franklin",
    "Matheus Pereira",
    "Zane Monlouis",
    "Nickseon Gomis",
    "Jackson Gilman",
    "Lazar Stefanovic",
    "Richard Chukwu",
    "Reid Fisher",
    "Stefan Kapor",
    "Micah Chisholm",
    "Luca Costabile",
    "Jonathan Osorio",
    "Djordje Mihailovic",
    "Malik Henry",
    "Markus Cimermancic",
    "Alonso Coello",
    "Antone Bossenberry",
    "Fletcher Bank",
    "Derrick Etienne Jr.",
    "Dániel Sallói",
    "Josh Sargent",
    "Theo Corbeanu",
    "Deandre Kerr",
    "Jules-Anthony Vilsaint",
    "Emilio Aristizábal",
    "Dékwon Barrow",
    "Jahmarie Nolan"
  ],
  "Tottenham Hotspur": [
    "Martin Dúbravka",
    "Guglielmo Vicario",
    "Brandon Austin",
    "Antonín Kinsky",
    "Ben Davies",
    "Cristian Romero",
    "Andy Robertson",
    "Kevin Danso",
    "Djed Spence",
    "Pedro Porro",
    "Ashley Phillips",
    "Jan Paul van Hecke",
    "Destiny Udogie",
    "Micky van de Ven",
    "Kota Takai",
    "Souza",
    "James Maddison",
    "Rodrigo Bentancur",
    "Sandro Tonali",
    "Mohammed Kudus",
    "Conor Gallagher",
    "Dejan Kulusevski",
    "Pape Matar Sarr",
    "Archie Gray",
    "Xavi Simons",
    "Lucas Bergvall",
    "Richarlison",
    "Dominic Solanke",
    "Dane Scarlett",
    "Mathys Tel",
    "Wilson Odobert"
  ],
  "Toulouse": [
    "Guillaume Restes",
    "Mathys Niflore",
    "Naime Said Mchindra",
    "Mark McKenzie",
    "Rasmus Nicolaisen",
    "Nicolas Wasbauer",
    "Ylies Aradj",
    "Christ Tapé",
    "Dayann Methalie",
    "Ismail Diallo",
    "Seny Koumbassa",
    "Frédéric Efuele Ngoyala",
    "Gaetan Bakhouche",
    "Niklas Schmidt",
    "Aron Donnum",
    "Cristian Cásseres Jr.",
    "Abu Francis",
    "Mario Sauer",
    "Noah Lahmadi",
    "Rafik Messali",
    "Mathis Saka",
    "Alexis Vossah",
    "Darris Zema",
    "Yann Gboho",
    "Jacen Russell-Rowe",
    "Santiago Hidalgo",
    "Julián Vignolo",
    "Ilyas Azizi",
    "Enzo Faty"
  ],
  "Tristán Suárez": [
    "Daniel Monllor",
    "Joaquín Mendive",
    "Joaquín Bigo",
    "Marcos Funes",
    "Matías Olguín",
    "Alejandro Molina",
    "Mauricio Guzmán",
    "Diego Mastrángelo",
    "Brian Caraballo",
    "Nicolás Fernández",
    "Ayrton Sánchez",
    "Manuel Agustin Guillen",
    "Mateo Pérez",
    "Nicolás Sánchez",
    "Diego Becker",
    "Francisco Ramírez",
    "Nicolás Del Priore",
    "Agustín Baldi",
    "Marcos Enrique",
    "Maximiliano Luayza",
    "Walter Berrondo",
    "Máximo Ferulano",
    "Fernando Álvarez",
    "Gianluca Banuera",
    "Kevin Colli",
    "Santiago Aquino",
    "César Romero",
    "Mateo Bustamante",
    "Tiziano Lionel Noriega",
    "Maximiliano Álvarez",
    "Renzo Conechny",
    "Jonathan Berón",
    "Santiago Magnotta"
  ],
  "Troyes": [
    "Zacharie Boucher",
    "Hillel Konaté",
    "Michel Diaz",
    "Adrien Monfray",
    "Paolo Gozzi Iweru",
    "Ismael Boura",
    "Lucas Maronnier",
    "Yvann Titi",
    "Tom Akpakoun",
    "Antoine Mille",
    "Alexandre Philiponeau",
    "Mouhamed Diop",
    "Merwan Ifnaoui",
    "Roman Murcy",
    "Renaud Ripart",
    "Kandet Diawara",
    "Ibrahim Traoré",
    "Elijah Odede",
    "Amadou Diakité",
    "Anis Ouzenadji"
  ],
  "TSV Eintracht Braunschweig": [
    "Benjamin Uphoff",
    "Ron-Thorben Hofmann",
    "Nick Bodon",
    "Noah Katterbach",
    "Kevin Ehlers",
    "Frederik Jakel",
    "Sanoussy Ba",
    "Lukas Frenkert",
    "Louis Breunig",
    "Andi Hoti",
    "Fabio Di-Michele-Sanchez",
    "Damjan Kovacevic",
    "Tristan Wagner",
    "Lino Tempelmann",
    "Florian Flick",
    "Robin Heusser",
    "Mehmet Can Aydin",
    "Sidney Raebiger",
    "Arlet Zé",
    "Samuele Di Benedetto",
    "Max Marie",
    "Yann Sturm",
    "Aaron Opoku",
    "Maximilian Entrup",
    "Sidi Sané",
    "Jovan Mijatovic",
    "Johan Gómez",
    "Jan Urbich"
  ],
  "Udinese": [
    "Daniele Padelli",
    "Maduka Okoye",
    "Rene Pirih",
    "Thomas Kristensen",
    "Christian Kabasele",
    "Hassane Kamara",
    "Kingsley Ehizibue",
    "Oumar Solet",
    "Nicolò Bertola",
    "Branimir Mlacic",
    "Jesper Karlström",
    "Jurgen Ekkelenkamp",
    "Jakub Piotrowski",
    "Oier Zarraga",
    "Lennon Miller",
    "Juan David Arizala",
    "Abdoulaye Camara",
    "Keinan Davis",
    "Adam Buksa",
    "Bayo Youssouf",
    "Giulio Vinciati"
  ],
  "Unión": [
    "Federico Gomes",
    "Matias Mansilla",
    "Lucas Meuli",
    "Bruno Pittón",
    "Juan Pintado",
    "Juan Ludueña",
    "Lautaro Vargas",
    "Mateo Aimar",
    "Maizon Rodríguez",
    "Tomás Fagioli",
    "Ignacio Isla",
    "Nazareno Garcia Fazzi",
    "Lucas Santiago",
    "Julián Palacio",
    "Augusto Solari",
    "Lucas Menossi",
    "Franco Fragapane",
    "Braian Cuello",
    "Joaquín Mosqueira",
    "Santino Vera",
    "Emilio Giaccone",
    "Santiago Grella",
    "Mateo Peresutti",
    "Lucas Cacciabue",
    "Marcelo Estigarribia",
    "Cristian Tarragona",
    "Ricardo Solbes",
    "Misael Aguirre",
    "Valentín Jesús Cerrudo"
  ],
  "Uruguay": [
    "Fernando Muslera",
    "Sergio Rochet",
    "Santiago Mele",
    "Guillermo Varela",
    "José María Giménez",
    "Mathías Olivera",
    "Santiago Bueno",
    "Joaquín Piquerez",
    "Matías Viña",
    "Ronald Araújo",
    "Sebastián Cáceres",
    "Emiliano Martínez",
    "Giorgian de Arrascaeta",
    "Rodrigo Bentancur",
    "Federico Valverde",
    "Manuel Ugarte",
    "Nicolás de la Cruz",
    "Maxi Araújo",
    "Rodrigo Zalazar",
    "Juan Manuel Sanabria",
    "Facundo Pellistri",
    "Brian Rodríguez",
    "Rodrigo Aguirre",
    "Agustín Canobbio",
    "Darwin Núñez",
    "Federico Viñas"
  ],
  "Uruguay Montevideo": [
    "Andrés Samurio",
    "Gabriel Araújo",
    "Mateo Pisso",
    "Theo Casavalle",
    "Kevin Sotto",
    "Agustín Peña",
    "Juan Madrid",
    "Gianluca López",
    "Mathías Goyeni",
    "Mathías Abero",
    "Santiago De Ávila",
    "Benjamin Ilama",
    "Tobías Correa",
    "David Alfaro",
    "Guzmán Pereira",
    "Valentín Silva",
    "Cristian Lima",
    "Richard Núñez",
    "Luciano Minhondo",
    "Agustín Pons",
    "Esteban Rodríguez",
    "Agustín Díaz",
    "Lucas Rodríguez",
    "Maximiliano Viera",
    "Emiliano García",
    "Lucas Ortíz",
    "Facundo Techera",
    "Rodrigo Muniz",
    "Gonzalo Barreto",
    "Sebastián Camacho",
    "Juan Álvarez",
    "Francisco Martinicorena",
    "Fausto Rivero"
  ],
  "Valencia": [
    "Cristian Rivero",
    "Stole Dimitrievski",
    "José Gayà",
    "Jesús Vázquez",
    "Copete",
    "César Tárrega",
    "Iker Córdoba",
    "Javier Guerra",
    "Guido Rodríguez",
    "Pepelu",
    "Filip Ugrinic",
    "André Almeida",
    "Umar Sadiq",
    "Arnaut Danjuma",
    "Dani Raba",
    "Luis Rioja",
    "Hugo Duro",
    "Alberto Marí",
    "Diego López"
  ],
  "Vancouver Whitecaps FC": [
    "Adrián Zendejas",
    "Yohei Takaoka",
    "Isaac Boehmer",
    "Sam Adekugbe",
    "Tristan Blackmon",
    "Mathías Laborda",
    "Ranko Veselinovic",
    "Tate Johnson",
    "Édier Ocampo",
    "Belal Halbouni",
    "Mihail Gherasimencov",
    "Trevor Wright",
    "Nikola Djordjevic",
    "Ryan Gauld",
    "Andrés Cubas",
    "Jean-Claude Ngando",
    "Ralph Priso-Mbongue",
    "Oliver Larraz",
    "Liam Mackenzie",
    "Jeevan Badwal",
    "Thomas Müller",
    "Brian White",
    "Emmanuel Sabbi",
    "Cheick Sabaly",
    "Kenji Cabrera",
    "Kwasi Poku",
    "Bruno Caicedo",
    "Johnny Selemani",
    "Rayan Elloumi",
    "Micaah Dominique Gladwin Garnette"
  ],
  "Vasco da Gama": [
    "Léo Jardim",
    "Daniel Fuzato",
    "Phillipe Gabriel",
    "Pablo",
    "Marcão",
    "José Luis Rodríguez",
    "Paulo Henrique",
    "Carlos Cuesta",
    "Lucas Piton",
    "Lucas Freitas",
    "Alan Saldivia",
    "Cuiabano",
    "Robert",
    "Paulinho",
    "Alison",
    "Walace",
    "Melim",
    "Riquelme Avellar",
    "Breno Vereza",
    "Bruno André Azevedo Ribeiro",
    "Jotavve Fonseca",
    "Wanyson Nogueira",
    "Breno Sales",
    "Jair",
    "Tchê Tchê",
    "Thiago Mendes",
    "Nuno Moreira",
    "Matheus Carvalho",
    "Cauan Barros",
    "JP",
    "Lukas Zuccarello",
    "Ramon Rique",
    "Gustavo Guimarães",
    "Lucca Guima",
    "Léo Félix",
    "Samuel de Jesus",
    "David",
    "Claudio Spinelli",
    "Brenner",
    "Marino Hinestroza",
    "Adson",
    "Andrés Gómez",
    "Johan Rojas",
    "Bruno Lopes",
    "Andrey Fernandes",
    "Anderson Felix",
    "Diego Minete",
    "Alex Bruno",
    "Luiz Lócio"
  ],
  "Vélez Sarsfield": [
    "Tomás Marchiori",
    "Franco Villalba",
    "Agustín Cortez",
    "Álvaro Busso",
    "Emanuel Mammana",
    "Lisandro Magallán",
    "Elias Gomez",
    "Joaquín García",
    "Jano Gordon",
    "Thiago Silveor",
    "Leo Cristaldo",
    "Simon Escobar",
    "Alexis Pereyra",
    "Diego Valdés",
    "Manuel Lanzini",
    "Rodrigo Aliendro",
    "Claudio Baeza",
    "Lucas Robertone",
    "Luca Feler",
    "Thiago Villalba",
    "Matías Pellegrini",
    "Álex Verón",
    "Dilan Godoy",
    "Matías Arias",
    "Thiago Aguirre",
    "Juan Policella",
    "Lautaro Piola"
  ],
  "Venezia": [
    "Matteo Grandi",
    "Filip Stankovic",
    "Ridgeciano Haps",
    "Marin Sverko",
    "Giorgio Altare",
    "Joel Schingtienne",
    "Richie Sagrado",
    "Alfred Duncan",
    "Emil Bohinen",
    "Nunzio Lella",
    "Gianluca Busio",
    "Enrique Perez",
    "Marko Farji",
    "Antoine Hainaut",
    "Matteo Dagasso",
    "Saad El Haddad",
    "Lion Lauberbach",
    "John Yeboah",
    "Andrea Adorante",
    "Antonio Casas",
    "Okoro Obinna"
  ],
  "VfB Stuttgart": [
    "Fabian Bredlow",
    "Marius Funk",
    "Stefan Drljaca",
    "Dennis Seimen",
    "Maximilian Mittelstädt",
    "Dan-Axel Zagadou",
    "Jeff Chabot",
    "Josha Vagnoman",
    "Leonidas Stergiou",
    "Ramon Hendriks",
    "Lorenz Assignon",
    "Ameen Al Dakhil",
    "Luca Jaquez",
    "Finn Jeltsch",
    "Grischa Prömel",
    "Atakan Karazor",
    "Nikolas Nartey",
    "Chris Führich",
    "Angelo Stiller",
    "Bilal El Khannouss",
    "Laurin Ulrich",
    "Jarzinho Malanga",
    "Chema Andrés",
    "Mirza Catovic",
    "Ertugrul Yigit",
    "Lazar Jovanovic",
    "Ermedin Demirovic",
    "Deniz Undav",
    "Jamie Leweling",
    "Tiago Tomás",
    "Badredine Bouanani",
    "Justin Diehl",
    "Jovan Milosevic",
    "Jeremy Arévalo"
  ],
  "VfL Bochum": [
    "Timo Horn",
    "Tino Casali",
    "Hugo Rölleke",
    "Karol Mets",
    "Maximilian Wittek",
    "Michael Steinwender",
    "Oliver Olsen",
    "Philipp Strompf",
    "Mikkel Rakneberg",
    "Yigit Karademir",
    "Kacper Koscierski",
    "Koji Miyoshi",
    "Berkan Taz",
    "Jean-Manuel Mbom",
    "Enis Cokaj",
    "Mats Pannewig",
    "Tom Meyer",
    "Lasse Isbruch",
    "Philipp Hofmann",
    "Gerrit Holtmann",
    "Daniel Hanslik",
    "Christian Rasmussen",
    "Alessandro Crimaldi",
    "Babis Charalampos Drakas"
  ],
  "VfL Osnabruck": [
    "Jonas Krumrey",
    "Luca Boggemann",
    "Niklas Sauter",
    "Jannik Müller",
    "Joel Abu Hanna",
    "Patrick Kammerbauer",
    "Niklas Wiemann",
    "Konrad Faber",
    "Robin Fabinski",
    "Theo Janotta",
    "Lukas Leonard Bornschein",
    "Bjarke Jacobsen",
    "Bryan Henning",
    "David Kopacz",
    "Fridolin Wagner",
    "Leonhard Munst",
    "Leon Opitz",
    "Jonathan Wensing",
    "Robin Meißner",
    "Tony Lesueur",
    "Luca Raimund",
    "Ismail Badjie",
    "Bernd Riesselmann"
  ],
  "VfL Wolfsburg": [
    "Pavao Pervan",
    "Timon Wellenreuther",
    "Kamil Grabara",
    "Jakub Zielinski",
    "Denis Vavro",
    "Hauke Wahl",
    "Rogério",
    "Joakim Maehle",
    "Moritz Jenz",
    "Kilian Fischer",
    "Aaron Zehnter",
    "Cleiton",
    "Saël Kumbedi",
    "Jonas Adjetey",
    "Mathys Angély",
    "Jan Bürger",
    "Christian Eriksen",
    "Maximilian Arnold",
    "Yannick Gerhardt",
    "Mattias Svanberg",
    "Vinicius Souza",
    "Elvis Rexhbecaj",
    "Aster Vranckx",
    "Muhammed Damar",
    "Bence Dárdai",
    "Eryk Grzywacz",
    "Pharell Hensel",
    "Fabian Reese",
    "Robert Glatzel",
    "Fraser Hornby",
    "Mohamed Amoura",
    "Alessio Besio",
    "Dzenan Pejcinovic",
    "Kento Shiogai",
    "Trevor Benedict",
    "Bruno Katz"
  ],
  "Vicenza": [
    "Samuele Massolo",
    "Riccardo Gagno",
    "Mattia Basso",
    "Filippo Costa",
    "Giuseppe Cuomo",
    "Maxime Leverbe",
    "Thomas Sandon",
    "Matteo Vescovi",
    "Lorenzo Caferri",
    "Michele Cavion",
    "Mattia Vitale",
    "Loris Zonta",
    "Marco Carraro",
    "Raul Talarico",
    "Armand Rada",
    "Giulio Pellizzari",
    "Claudio Morra",
    "Nicola Rauti",
    "Filippo Alessio"
  ],
  "Vila Nova": [
    "Helton Leite",
    "Dalberson",
    "Gabriel Átila",
    "Tiago",
    "Douglas Mendes",
    "Hayner",
    "Igor Cariús",
    "Willian Prado Camargo",
    "Anderson Jesus",
    "Caio Marcelo Pinheiro Da Silva",
    "Higor Luiz De Souza",
    "Breno Augusto De Azevedo Bora",
    "Marquinhos Gabriel",
    "Willian Maranhão",
    "Dodô",
    "Bruno Cesar Xavier",
    "João Pedro Vieira",
    "Higor Matheus Meritão",
    "Nathan",
    "Enzo",
    "Gabriel Dias",
    "Dudu",
    "Samuel Frota Nunes",
    "Dellatorre",
    "Everton",
    "André Luis",
    "Rafael Silva",
    "Janderson",
    "Caique",
    "Emerson Lima",
    "Gustavo Puskas Pinheiro Lemos",
    "Soares",
    "Ryan Lima",
    "Jackson"
  ],
  "Villarreal": [
    "Luiz Júnior",
    "Rubén Gómez",
    "Yakiv Kinareykin",
    "Gerard Moreno",
    "Juan Foyth",
    "Alex Freeman",
    "Logan Costa",
    "Sergi Cardona",
    "Santiago Mouriño",
    "Willy Kambwala",
    "Renato Veiga",
    "Pau Navarro",
    "Daniel Budesca",
    "César Bonafé Ceita",
    "Santi Comesaña",
    "Pape Gueye",
    "Alberto Moleiro",
    "Cheikh Ahmad Tidiane Thiam",
    "Moussa Diallo",
    "Ayoze Pérez",
    "Nicolas Pépé",
    "Tajon Buchanan",
    "Tani Oluwaseyi",
    "Georges Mikautadze",
    "Ilias Akhomach"
  ],
  "Virtus Entella": [
    "Simone Colombi",
    "Ovidijus Siaulys",
    "Federico Del Frate",
    "Samuele Gariti",
    "Michele Sanguineti",
    "Ivan Marconi",
    "Luca Parodi",
    "Andrea Tiritiello",
    "Francesco Mezzoni",
    "Riccardo Turicchia",
    "Stefano Di Mario",
    "Andrea Bottaro",
    "Mattia Alborghetti",
    "Davide Bariti",
    "Leonardo Benedetti",
    "Niccolò Squizzato",
    "Nermin Karic",
    "Marco Emilio Nichetti",
    "Matteo Carbone",
    "Andrea Franzoni",
    "Ernesto Matteazzi",
    "Pedro Dayan Neves Pinheiro",
    "Luigi Cuppone",
    "Bernat Guiu",
    "Andrea Traniello"
  ],
  "Vitória": [
    "Gabriel",
    "Yuri Sena",
    "Lucas Arcanjo",
    "Fintelman",
    "Emanuel Britez",
    "Riccieli",
    "Luan Cândido",
    "Ramon",
    "Cacá",
    "Camutanga",
    "Jamerson",
    "Edu",
    "Fabiano",
    "Matheusinho",
    "Nathan",
    "Diego Tarzia",
    "Kauan Santos",
    "Gean",
    "Ivan",
    "Guilherme Inácio",
    "Wanderson",
    "Nicolas Celis",
    "Walace",
    "Tomás Pochettino",
    "Emmanuel Martínez",
    "Matheus",
    "Alejandro Almaraz",
    "Caique",
    "Gabriel Baralhas",
    "Enrique Saverio",
    "Rúben Ismael",
    "Dudu",
    "Wendell Sacramento",
    "Zé Vitor",
    "Edenilson",
    "Cauan De Jesus",
    "Lucas Lohan",
    "Osvaldo",
    "Marinho",
    "Renato Kayzer",
    "Lucas",
    "Erick",
    "Fabrício Santos",
    "Renê",
    "Kauan Vitor",
    "Marcos Vinicius",
    "Anderson Bispo Dos Santos",
    "Ruan Gabriel"
  ],
  "Watford": [
    "Egil Selvik",
    "Jeremy Ngakia",
    "Marc Bola",
    "Matthew Pollock",
    "Jeremy Petris",
    "Kévin Keben",
    "James Clarridge",
    "Edo Kayembe",
    "Imran Louza",
    "Hector Kyprianou",
    "Edoardo Bove",
    "Mamadou Doumbia",
    "Kwadwo Baah",
    "Rocco Vata",
    "Nestory Irankunda",
    "Jack Grieves",
    "Luca Kjerrumgaard",
    "Othmane Maamma",
    "Amin Nabizada"
  ],
  "Werder Bremen": [
    "Markus Kolke",
    "Alexander Schlager",
    "Karl Hein",
    "Stefan Smarkalev",
    "Mitchell Weiser",
    "Niklas Stark",
    "Karim Coulibaly",
    "Marco Friedl",
    "Amos Pieper",
    "Felix Agu",
    "Olivier Deman",
    "Oskar Wójcik",
    "Julian Malatini",
    "Mick Schmetgens",
    "Mats Heitmann",
    "Luca Höcker",
    "Jens Stage",
    "Romano Schmid",
    "Senne Lynen",
    "Skelly Alvero",
    "Chuki",
    "Patrice Covic",
    "Dariusz Stalmach",
    "Darwin Kaan Soylu",
    "Dawid Kownacki",
    "Cedric Itten",
    "Marco Grüll",
    "Keke Topp",
    "Justin Njinmah",
    "Samuel Mbangula",
    "Salim Musah",
    "Kenny Quetant",
    "Paul Bright Max Erevbenagie"
  ],
  "West Bromwich Albion": [
    "Max O'Leary",
    "Alex Williams",
    "Krystian Bielik",
    "George Campbell",
    "Chris Mepham",
    "Nathaniel Phillips",
    "Alfie Gilchrist",
    "Alex Mowatt",
    "Ousmane Diakite",
    "Callum Styles",
    "Jayson Molumby",
    "Isaac Price",
    "Michael Johnston",
    "Aune Heggebo",
    "Tammer Bany"
  ],
  "West Ham United": [
    "Alphonse Areola",
    "Mads Hermansen",
    "Finlay Herrick",
    "Joël Veltman",
    "Max Kilman",
    "Kyle Walker-Peters",
    "Konstantinos Mavropanos",
    "Aaron Wan-Bissaka",
    "Jean-Clair Todibo",
    "Kaelan Casey",
    "Oliver Scarles",
    "El Hadji Malick Diouf",
    "Ezra Mayers",
    "Airidas Golambeckis",
    "James Ward-Prowse",
    "Tomás Soucek",
    "Edson Álvarez",
    "Soungoutou Magassa",
    "Keiber Lamadrid",
    "George Earthy",
    "Lewis Orford",
    "Mohamadou Kanté",
    "Maxwel Cornet",
    "Jarrod Bowen",
    "Valentín Castellanos",
    "Pablo",
    "Joshua Ajala"
  ],
  "Wolverhampton Wanderers": [
    "Daniel Bentley",
    "Sam Johnstone",
    "José Sá",
    "Kieran Trippier",
    "Ladislav Krejcí",
    "Hugo Bueno",
    "Santiago Bueno",
    "Yerson Mosquera",
    "Rodrigo Gomes",
    "Jackson Tchatchoua",
    "David Møller Wolfe",
    "Nasser Djiga",
    "Toti Gomes",
    "Pedro Lima",
    "Boubacar Traoré",
    "Jean-Ricner Bellegarde",
    "Marshall Munetsi",
    "Tommy Doyle",
    "André",
    "Fernando López",
    "Raúl Jiménez",
    "Adam Armstrong",
    "Hwang Hee-Chan",
    "Sasa Kalajdzic",
    "Tawanda Chirewa",
    "Rafiki Said",
    "Enso González",
    "Mateus Mané"
  ],
  "Wrexham": [
    "Danny Ward",
    "Callum Burton",
    "Arthur Okonkwo",
    "Conor Coady",
    "Aaron James",
    "Dan Scarr",
    "Dominic Hyam",
    "Zak Vyner",
    "Liberato Cacace",
    "Lewis Brunt",
    "Max Cleworth",
    "Callum Doyle",
    "Elliott Lee",
    "Matty James",
    "Josh Windass",
    "Ben Sheaf",
    "George Dobson",
    "Oliver Rathbone",
    "Ryan Barnett",
    "Ryan Longman",
    "Lewis O'Brien",
    "George Thomason",
    "Sebastian Revan",
    "Harry Ashfield",
    "Alexander James Moore",
    "Kieffer Moore",
    "Ryan Hardie",
    "Davis Kellior-Dunn",
    "Nathan Broadhead",
    "Sam Smith",
    "Bailey Cadamarteri"
  ]
}
